var items = {
  "block.minecraft.acacia_button": "Акаци пускӑч",
  "block.minecraft.acacia_door": "Акаци алӑк",
  "block.minecraft.acacia_fence": "Акаци карта",
  "block.minecraft.acacia_fence_gate": "Акаци калинкке",
  "block.minecraft.acacia_hanging_sign": "Акаци ҫакмалли паллӑ",
  "block.minecraft.acacia_leaves": "Акаци ҫулҫи",
  "block.minecraft.acacia_log": "Акаци пӗрене",
  "block.minecraft.acacia_planks": "Акаци хӑма",
  "block.minecraft.acacia_pressure_plate": "Акаци пусмалли плита",
  "block.minecraft.acacia_sapling": "Акаци хунавӗ",
  "block.minecraft.acacia_shelf": "Акаци ҫӳлӗк",
  "block.minecraft.acacia_sign": "Акаци паллӑ",
  "block.minecraft.acacia_slab": "Акаци плита",
  "block.minecraft.acacia_stairs": "Акаци картлашка",
  "block.minecraft.acacia_trapdoor": "Акаци люк",
  "block.minecraft.acacia_wall_hanging_sign": "Хӳмери акаци ҫакмалли паллӑ",
  "block.minecraft.acacia_wall_sign": "Хӳмери акаци паллӑ",
  "block.minecraft.acacia_wood": "Акаци йывӑҫ",
  "block.minecraft.activator_rail": "Ӗҫлеттерекен рельс",
  "block.minecraft.air": "Сывлӑш",
  "block.minecraft.allium": "Хӑвӑл сухан",
  "block.minecraft.amethyst_block": "Аметист блок",
  "block.minecraft.amethyst_cluster": "Аметист кластерӗ",
  "block.minecraft.ancient_debris": "Авалхи ванчăксем",
  "block.minecraft.andesite": "Андезит",
  "block.minecraft.andesite_slab": "Андезит плита",
  "block.minecraft.andesite_stairs": "Андезит картлашка",
  "block.minecraft.andesite_wall": "Андезит карта",
  "block.minecraft.anvil": "Сунтал",
  "block.minecraft.attached_melon_stem": "Ҫыпҫӑннӑ арпус туни",
  "block.minecraft.attached_pumpkin_stem": "Ҫыпҫӑннӑ кавăн туни",
  "block.minecraft.azalea": "Азали",
  "block.minecraft.azalea_leaves": "Азали ҫулҫи",
  "block.minecraft.azure_bluet": "Сӑрӑ хаустони",
  "block.minecraft.bamboo": "Бамбук",
  "block.minecraft.bamboo_block": "Бамбук блок",
  "block.minecraft.bamboo_button": "Бамбук пускăч",
  "block.minecraft.bamboo_door": "Бамбук алӑк",
  "block.minecraft.bamboo_fence": "Бамбук карта",
  "block.minecraft.bamboo_fence_gate": "Бамбук калинкке",
  "block.minecraft.bamboo_hanging_sign": "Бамбук ҫакмалли паллӑ",
  "block.minecraft.bamboo_mosaic": "Бамбук мозаика",
  "block.minecraft.bamboo_mosaic_slab": "Бамбук мозаика плита",
  "block.minecraft.bamboo_mosaic_stairs": "Бамбук мозаика картлашка",
  "block.minecraft.bamboo_planks": "Бамбук хӑма",
  "block.minecraft.bamboo_pressure_plate": "Бамбук пусмалли плита",
  "block.minecraft.bamboo_sapling": "Бамбук хунавӗ",
  "block.minecraft.bamboo_shelf": "Бамбук ҫӳлӗк",
  "block.minecraft.bamboo_sign": "Бамбук паллӑ",
  "block.minecraft.bamboo_slab": "Бамбук плита",
  "block.minecraft.bamboo_stairs": "Бамбук картлашка",
  "block.minecraft.bamboo_trapdoor": "Бамбук люк",
  "block.minecraft.bamboo_wall_hanging_sign": "Хӳмери бамбук ҫакмалли паллӑ",
  "block.minecraft.bamboo_wall_sign": "Хӳмери бамбук паллӑ",
  "block.minecraft.banner.base.black": "Пӗтӗмпех хура",
  "block.minecraft.banner.base.blue": "Пӗтӗмпех кăвак",
  "block.minecraft.banner.base.brown": "Пӗтӗмпех хăмăр",
  "block.minecraft.banner.base.cyan": "Пӗтӗмпех кӑвак симӗс",
  "block.minecraft.banner.base.gray": "Пӗтӗмпех сăрă",
  "block.minecraft.banner.base.green": "Пӗтӗмпех симӗс",
  "block.minecraft.banner.base.light_blue": "Пӗтӗмпех сенкер",
  "block.minecraft.banner.base.light_gray": "Пӗтӗмпех ҫутӑ сӑрӑ",
  "block.minecraft.banner.base.lime": "Пӗтӗмпех сарӑ симӗс",
  "block.minecraft.banner.base.magenta": "Пӗтӗмпех хӗрлӗ кӗрен",
  "block.minecraft.banner.base.orange": "Пӗтӗмпех хĕрлĕ сарă",
  "block.minecraft.banner.base.pink": "Пӗтӗмпех кĕрен",
  "block.minecraft.banner.base.purple": "Пӗтӗмпех хĕрлĕ кăвак",
  "block.minecraft.banner.base.red": "Пӗтӗмпех хĕрлĕ",
  "block.minecraft.banner.base.white": "Пӗтӗмпех шурă",
  "block.minecraft.banner.base.yellow": "Пӗтӗмпех сарă",
  "block.minecraft.banner.border.black": "Хура хӑю",
  "block.minecraft.banner.border.blue": "Кӑвак хӑю",
  "block.minecraft.banner.border.brown": "Хӑмӑр хӑю",
  "block.minecraft.banner.border.cyan": "Кӑвак симӗс хӑю",
  "block.minecraft.banner.border.gray": "Сӑрӑ хӑю",
  "block.minecraft.banner.border.green": "Симӗс хӑю",
  "block.minecraft.banner.border.light_blue": "Сенкер хӑю",
  "block.minecraft.banner.border.light_gray": "Ҫутӑ сӑрӑ хӑю",
  "block.minecraft.banner.border.lime": "Сарӑ симӗс хӑю",
  "block.minecraft.banner.border.magenta": "Хӗрлӗ кӗрен хӑю",
  "block.minecraft.banner.border.orange": "Хĕрлĕ сарӑ хӑю",
  "block.minecraft.banner.border.pink": "Кӗрен хӑю",
  "block.minecraft.banner.border.purple": "Хӗрлӗ кӑвак хӑю",
  "block.minecraft.banner.border.red": "Хӗрлӗ хӑю",
  "block.minecraft.banner.border.white": "Шурӑ хӑю",
  "block.minecraft.banner.border.yellow": "Сарӑ хӑю",
  "block.minecraft.banner.bricks.black": "Хура кирпӗч",
  "block.minecraft.banner.bricks.blue": "Кӑвак кирпӗч",
  "block.minecraft.banner.bricks.brown": "Хӑмӑр кирпӗч",
  "block.minecraft.banner.bricks.cyan": "Кӑвак симӗс кирпӗч",
  "block.minecraft.banner.bricks.gray": "Сӑрӑ кирпӗч",
  "block.minecraft.banner.bricks.green": "Симӗс кирпӗч",
  "block.minecraft.banner.bricks.light_blue": "Сенкер кирпӗч",
  "block.minecraft.banner.bricks.light_gray": "Ҫутӑ сӑрӑ кирпӗч",
  "block.minecraft.banner.bricks.lime": "Сарӑ симӗс кирпӗч",
  "block.minecraft.banner.bricks.magenta": "Хӗрлӗ кӗрен кирпӗч",
  "block.minecraft.banner.bricks.orange": "Хĕрлĕ сарă кирпӗч",
  "block.minecraft.banner.bricks.pink": "Кӗрен кирпӗч",
  "block.minecraft.banner.bricks.purple": "Хӗрлӗ кӑвак кирпӗч",
  "block.minecraft.banner.bricks.red": "Хӗрлӗ кирпӗч",
  "block.minecraft.banner.bricks.white": "Шурӑ кирпӗч",
  "block.minecraft.banner.bricks.yellow": "Сарӑ кирпӗч",
  "block.minecraft.banner.circle.black": "Хура ҫавра",
  "block.minecraft.banner.circle.blue": "Кăвак ҫавра",
  "block.minecraft.banner.circle.brown": "Хӑмӑр ҫавра",
  "block.minecraft.banner.circle.cyan": "Кӑвак симӗс ҫавра",
  "block.minecraft.banner.circle.gray": "Сӑрӑ ҫавра",
  "block.minecraft.banner.circle.green": "Симӗс ҫавра",
  "block.minecraft.banner.circle.light_blue": "Сенкер ҫавра",
  "block.minecraft.banner.circle.light_gray": "Ҫутӑ сӑрӑ ҫавра",
  "block.minecraft.banner.circle.lime": "Сарӑ симӗс ҫавра",
  "block.minecraft.banner.circle.magenta": "Хӗрлӗ кӗрен ҫавра",
  "block.minecraft.banner.circle.orange": "Хĕрлĕ сарă ҫавра",
  "block.minecraft.banner.circle.pink": "Кӗрен ҫавра",
  "block.minecraft.banner.circle.purple": "Хӗрлӗ кӑвак ҫавра",
  "block.minecraft.banner.circle.red": "Хӗрлӗ ҫавра",
  "block.minecraft.banner.circle.white": "Шурӑ ҫавра",
  "block.minecraft.banner.circle.yellow": "Сарӑ ҫавра",
  "block.minecraft.banner.creeper.black": "Хура крипер",
  "block.minecraft.banner.creeper.blue": "Кӑвак крипер",
  "block.minecraft.banner.creeper.brown": "Хӑмӑр крипер",
  "block.minecraft.banner.creeper.cyan": "Кӑвак симӗс крипер",
  "block.minecraft.banner.creeper.gray": "Сӑрӑ крипер",
  "block.minecraft.banner.creeper.green": "Симӗс крипер",
  "block.minecraft.banner.creeper.light_blue": "Сенкер крипер",
  "block.minecraft.banner.creeper.light_gray": "Ҫутӑ сӑрӑ крипер",
  "block.minecraft.banner.creeper.lime": "Сарӑ симӗс крипер",
  "block.minecraft.banner.creeper.magenta": "Хӗрлӗ кӗрен крипер",
  "block.minecraft.banner.creeper.orange": "Хĕрлĕ сарă крипер",
  "block.minecraft.banner.creeper.pink": "Кӗрен крипер",
  "block.minecraft.banner.creeper.purple": "Хӗрлӗ кӑвак крипер",
  "block.minecraft.banner.creeper.red": "Хӗрлӗ крипер",
  "block.minecraft.banner.creeper.white": "Шурӑ крипер",
  "block.minecraft.banner.creeper.yellow": "Сарӑ крипер",
  "block.minecraft.banner.cross.black": "Хура чалӑш хӗрес",
  "block.minecraft.banner.cross.blue": "Кăвак чалӑш хӗрес",
  "block.minecraft.banner.cross.brown": "Хăмăр чалӑш хӗрес",
  "block.minecraft.banner.cross.cyan": "Кӑвак симӗс чалӑш хӗрес",
  "block.minecraft.banner.cross.gray": "Сăрă чалӑш хӗрес",
  "block.minecraft.banner.cross.green": "Симӗс чалӑш хӗрес",
  "block.minecraft.banner.cross.light_blue": "Сенкер чалӑш хӗрес",
  "block.minecraft.banner.cross.light_gray": "Ҫутӑ сӑрӑ чалӑш хӗрес",
  "block.minecraft.banner.cross.lime": "Сарӑ симӗс чалӑш хӗрес",
  "block.minecraft.banner.cross.magenta": "Хӗрлӗ кӗрен чалӑш хӗрес",
  "block.minecraft.banner.cross.orange": "Хĕрлĕ сарă чалӑш хӗрес",
  "block.minecraft.banner.cross.pink": "Кĕрен чалӑш хӗрес",
  "block.minecraft.banner.cross.purple": "Хĕрлĕ кăвак чалӑш хӗрес",
  "block.minecraft.banner.cross.red": "Хĕрлĕ чалӑш хӗрес",
  "block.minecraft.banner.cross.white": "Шурă чалӑш хӗрес",
  "block.minecraft.banner.cross.yellow": "Сарă чалӑш хӗрес",
  "block.minecraft.banner.curly_border.black": "Хура шӑллӑ хӑю",
  "block.minecraft.banner.curly_border.blue": "Кӑвак шӑллӑ хӑю",
  "block.minecraft.banner.curly_border.brown": "Хӑмӑр шӑллӑ хӑю",
  "block.minecraft.banner.curly_border.cyan": "Кӑвак симӗс шӑллӑ хӑю",
  "block.minecraft.banner.curly_border.gray": "Сӑрӑ шӑллӑ хӑю",
  "block.minecraft.banner.curly_border.green": "Симӗс шӑллӑ хӑю",
  "block.minecraft.banner.curly_border.light_blue": "Сенкер шӑллӑ хӑю",
  "block.minecraft.banner.curly_border.light_gray": "Ҫутӑ сӑрӑ шӑллӑ хӑю",
  "block.minecraft.banner.curly_border.lime": "Сарӑ симӗс шӑллӑ хӑю",
  "block.minecraft.banner.curly_border.magenta": "Хӗрлӗ кӗрен шӑллӑ хӑю",
  "block.minecraft.banner.curly_border.orange": "Хĕрлĕ сарă шӑллӑ хӑю",
  "block.minecraft.banner.curly_border.pink": "Кӗрен шӑллӑ хӑю",
  "block.minecraft.banner.curly_border.purple": "Хӗрлӗ кӑвак шӑллӑ хӑю",
  "block.minecraft.banner.curly_border.red": "Хӗрлӗ шӑллӑ хӑю",
  "block.minecraft.banner.curly_border.white": "Шурă шӑллӑ хӑю",
  "block.minecraft.banner.curly_border.yellow": "Сарӑ шӑллӑ хӑю",
  "block.minecraft.banner.diagonal_left.black": "Хура сулахай чалӑш ҫурри",
  "block.minecraft.banner.diagonal_left.blue": "Кӑвак сулахай чалӑш ҫурри",
  "block.minecraft.banner.diagonal_left.brown": "Хӑмӑр сулахай чалӑш",
  "block.minecraft.banner.diagonal_left.cyan": "Кӑвак симӗс сулахай чалӑш ҫурри",
  "block.minecraft.banner.diagonal_left.gray": "Сӑрӑ сулахай чалӑш",
  "block.minecraft.banner.diagonal_left.green": "Симӗс сулахай чалӑш ҫурри",
  "block.minecraft.banner.diagonal_left.light_blue": "Сенкер сулахай чалӑш ҫурри",
  "block.minecraft.banner.diagonal_left.light_gray": "Ҫутӑ сӑрӑ сулахай чалӑш ҫурри",
  "block.minecraft.banner.diagonal_left.lime": "Сарӑ симӗс сулахай чалӑш ҫурри",
  "block.minecraft.banner.diagonal_left.magenta": "Хӗрлӗ кӗрен сулахай чалӑш ҫурри",
  "block.minecraft.banner.diagonal_left.orange": "Хӗрлӗ сарӑ сулахай чалӑш ҫурри",
  "block.minecraft.banner.diagonal_left.pink": "Кӗрен сулахай чалӑш ҫурри",
  "block.minecraft.banner.diagonal_left.purple": "Хӗрлӗ кӑвак сулахай чалӑш ҫурри",
  "block.minecraft.banner.diagonal_left.red": "Хӗрлӗ сулахай чалӑш ҫурри",
  "block.minecraft.banner.diagonal_left.white": "Шурӑ сулахай чалӑш ҫурри",
  "block.minecraft.banner.diagonal_left.yellow": "Сарӑ сулахай чалӑш ҫурри",
  "block.minecraft.banner.diagonal_right.black": "Хура сылтӑм чалӑш ҫурри",
  "block.minecraft.banner.diagonal_right.blue": "Кӑвак сылтӑм чалӑш ҫурри",
  "block.minecraft.banner.diagonal_right.brown": "Хӑмӑр сылтӑм чалӑш ҫурри",
  "block.minecraft.banner.diagonal_right.cyan": "Кӑвак симӗс сылтӑм чалӑш ҫурри",
  "block.minecraft.banner.diagonal_right.gray": "Сӑрӑ сылтӑм чалӑш ҫурри",
  "block.minecraft.banner.diagonal_right.green": "Симӗс сылтӑм чалӑш ҫурри",
  "block.minecraft.banner.diagonal_right.light_blue": "Сенкер сылтӑм чалӑш ҫурри",
  "block.minecraft.banner.diagonal_right.light_gray": "Ҫутӑ сӑрӑ сылтӑм чалӑш ҫурри",
  "block.minecraft.banner.diagonal_right.lime": "Сарӑ симӗс сылтӑм чалӑш ҫурри",
  "block.minecraft.banner.diagonal_right.magenta": "Хӗрлӗ кӗрен сылтӑм чалӑш ҫурри",
  "block.minecraft.banner.diagonal_right.orange": "Хӗрлӗ сарӑ сылтӑм чалӑш ҫурри",
  "block.minecraft.banner.diagonal_right.pink": "Кӗрен сылтӑм чалӑш ҫурри",
  "block.minecraft.banner.diagonal_right.purple": "Хӗрлӗ кӑвак сылтӑм чалӑш ҫурри",
  "block.minecraft.banner.diagonal_right.red": "Хӗрлӗ сылтӑм чалӑш ҫурри",
  "block.minecraft.banner.diagonal_right.white": "Шурӑ сылтӑм чалӑш ҫурри",
  "block.minecraft.banner.diagonal_right.yellow": "Сарӑ сылтӑм чалӑш ҫурри",
  "block.minecraft.banner.diagonal_up_left.black": "Хура тӳнтер сулахай чалӑш ҫурри",
  "block.minecraft.banner.diagonal_up_left.blue": "Кӑвак тӳнтер сулахай чалӑш ҫурри",
  "block.minecraft.banner.diagonal_up_left.brown": "Хӑмӑр тӳнтер сулахай чалӑш ҫурри",
  "block.minecraft.banner.diagonal_up_left.cyan": "Кӑвак симӗс тӳнтер сулахай чалӑш ҫурри",
  "block.minecraft.banner.diagonal_up_left.gray": "Сӑрӑ тӳнтер сулахай чалӑш ҫурри",
  "block.minecraft.banner.diagonal_up_left.green": "Симӗс тӳнтер сулахай чалӑш ҫурри",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Сенкер тӳнтер сулахай чалӑш ҫурри",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Ҫутӑ сӑрӑ тӳнтер сулахай чалӑш ҫурри",
  "block.minecraft.banner.diagonal_up_left.lime": "Сарӑ симӗс тӳнтер сулахай чалӑш ҫурри",
  "block.minecraft.banner.diagonal_up_left.magenta": "Хӗрлӗ кӗрен тӳнтер сулахай чалӑш ҫурри",
  "block.minecraft.banner.diagonal_up_left.orange": "Хӗрлӗ сарӑ тӳнтер сулахай чалӑш ҫурри",
  "block.minecraft.banner.diagonal_up_left.pink": "Кӗрен тӳнтер сулахай чалӑш ҫурри",
  "block.minecraft.banner.diagonal_up_left.purple": "Хӗрлӗ кӑвак тӳнтер сулахай чалӑш ҫурри",
  "block.minecraft.banner.diagonal_up_left.red": "Хӗрлӗ тӳнтер сулахай чалӑш ҫурри",
  "block.minecraft.banner.diagonal_up_left.white": "Шурӑ тӳнтер сулахай чалӑш ҫурри",
  "block.minecraft.banner.diagonal_up_left.yellow": "Сарӑ тӳнтер сулахай чалӑш ҫурри",
  "block.minecraft.banner.diagonal_up_right.black": "Хура тӳнтер сылтӑм чалӑш ҫурри",
  "block.minecraft.banner.diagonal_up_right.blue": "Кӑвак тӳнтер сылтӑм чалӑш ҫурри",
  "block.minecraft.banner.diagonal_up_right.brown": "Хӑмӑр тӳнтер сылтӑм чалӑш ҫурри",
  "block.minecraft.banner.diagonal_up_right.cyan": "Кӑвак симӗс тӳнтер сылтӑм чалӑш ҫурри",
  "block.minecraft.banner.diagonal_up_right.gray": "Сӑрӑ тӳнтер сылтӑм чалӑш ҫурри",
  "block.minecraft.banner.diagonal_up_right.green": "Симӗс тӳнтер сылтӑм чалӑш ҫурри",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Сенкер тӳнтер сылтӑм чалӑш ҫурри",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Ҫутӑ сӑрӑ ӳпентернӗ сылтӑм чалӑш ҫурри",
  "block.minecraft.banner.diagonal_up_right.lime": "Сарӑ симӗс тӳнтер сылтӑм чалӑш ҫурри",
  "block.minecraft.banner.diagonal_up_right.magenta": "Хӗрлӗ кӗрен тӳнтер сылтӑм чалӑш ҫурри",
  "block.minecraft.banner.diagonal_up_right.orange": "Хӗрлӗ сарӑ тӳнтер сылтӑм чалӑш ҫурри",
  "block.minecraft.banner.diagonal_up_right.pink": "Кӗрен тӳнтер сылтӑм чалӑш ҫурри",
  "block.minecraft.banner.diagonal_up_right.purple": "Хӗрлӗ кӑвак тӳнтер сылтӑм чалӑш ҫурри",
  "block.minecraft.banner.diagonal_up_right.red": "Хӗрлӗ тӳнтер сылтӑм чалӑш ҫурри",
  "block.minecraft.banner.diagonal_up_right.white": "Шурӑ тӳнтер сылтӑм чалӑш ҫурри",
  "block.minecraft.banner.diagonal_up_right.yellow": "Сарӑ тӳнтер сылтӑм чалӑш ҫурри",
  "block.minecraft.banner.flow.black": "Хура вӑркӑш",
  "block.minecraft.banner.flow.blue": "Кӑвак вӑркӑш",
  "block.minecraft.banner.flow.brown": "Хӑмӑр вӑркӑш",
  "block.minecraft.banner.flow.cyan": "Кӑвак симӗс вӑркӑш",
  "block.minecraft.banner.flow.gray": "Сӑрӑ вӑркӑш",
  "block.minecraft.banner.flow.green": "Симӗс вӑркӑш",
  "block.minecraft.banner.flow.light_blue": "Сенкер вӑркӑш",
  "block.minecraft.banner.flow.light_gray": "Ҫутӑ сӑрӑ вӑркӑш",
  "block.minecraft.banner.flow.lime": "Сарӑ симӗс вӑркӑш",
  "block.minecraft.banner.flow.magenta": "Хӗрлӗ кӗрен вӑркӑш",
  "block.minecraft.banner.flow.orange": "Хӗрлӗ сарӑ вӑркӑш",
  "block.minecraft.banner.flow.pink": "Кӗрен вӑркӑш",
  "block.minecraft.banner.flow.purple": "Хӗрлӗ кӑвак вӑркӑш",
  "block.minecraft.banner.flow.red": "Хӗрлӗ вӑркӑш",
  "block.minecraft.banner.flow.white": "Шурӑ вӑркӑш",
  "block.minecraft.banner.flow.yellow": "Сарӑ вӑркӑш",
  "block.minecraft.banner.flower.black": "Хура чечек",
  "block.minecraft.banner.flower.blue": "Кӑвак чечек",
  "block.minecraft.banner.flower.brown": "Хӑмӑр чечек",
  "block.minecraft.banner.flower.cyan": "Кӑвак симӗс чечек",
  "block.minecraft.banner.flower.gray": "Сӑрӑ чечек",
  "block.minecraft.banner.flower.green": "Симӗс чечек",
  "block.minecraft.banner.flower.light_blue": "Сенкер чечек",
  "block.minecraft.banner.flower.light_gray": "Ҫутӑ сӑрӑ чечек",
  "block.minecraft.banner.flower.lime": "Сарӑ симӗс чечек",
  "block.minecraft.banner.flower.magenta": "Хӗрлӗ кӗрен чечек",
  "block.minecraft.banner.flower.orange": "Хĕрлĕ сарӑ чечек",
  "block.minecraft.banner.flower.pink": "Кĕрен чечек",
  "block.minecraft.banner.flower.purple": "Хӗрлӗ кӑвак чечек",
  "block.minecraft.banner.flower.red": "Хĕрлĕ чечек",
  "block.minecraft.banner.flower.white": "Шурă чечек",
  "block.minecraft.banner.flower.yellow": "Сарӑ чечек",
  "block.minecraft.banner.globe.black": "Хура чăмăр",
  "block.minecraft.banner.globe.blue": "Кӑвак чăмăр",
  "block.minecraft.banner.globe.brown": "Хӑмӑр чăмăр",
  "block.minecraft.banner.globe.cyan": "Кăвак симӗс чăмăр",
  "block.minecraft.banner.globe.gray": "Сӑрӑ чăмăр",
  "block.minecraft.banner.globe.green": "Симӗс чăмăр",
  "block.minecraft.banner.globe.light_blue": "Сенкер чăмăр",
  "block.minecraft.banner.globe.light_gray": "Ҫутӑ сӑрӑ чăмăр",
  "block.minecraft.banner.globe.lime": "Сарӑ симӗс чăмăр",
  "block.minecraft.banner.globe.magenta": "Хӗрлӗ кӗрен чăмăр",
  "block.minecraft.banner.globe.orange": "Хĕрлĕ сарă чăмăр",
  "block.minecraft.banner.globe.pink": "Кӗрен чăмăр",
  "block.minecraft.banner.globe.purple": "Хӗрлӗ кӑвак чăмăр",
  "block.minecraft.banner.globe.red": "Хӗрлӗ чăмăр",
  "block.minecraft.banner.globe.white": "Шурӑ чăмăр",
  "block.minecraft.banner.globe.yellow": "Сарӑ чăмăр",
  "block.minecraft.banner.gradient.black": "Хура градиент",
  "block.minecraft.banner.gradient.blue": "Кӑвак градиент",
  "block.minecraft.banner.gradient.brown": "Хӑмӑр градиент",
  "block.minecraft.banner.gradient.cyan": "Кăвак симӗс градиент",
  "block.minecraft.banner.gradient.gray": "Сӑрӑ градиент",
  "block.minecraft.banner.gradient.green": "Симӗс градиент",
  "block.minecraft.banner.gradient.light_blue": "Сенкер градиент",
  "block.minecraft.banner.gradient.light_gray": "Ҫутӑ сӑрӑ градиент",
  "block.minecraft.banner.gradient.lime": "Сарӑ симӗс градиент",
  "block.minecraft.banner.gradient.magenta": "Хӗрлӗ кӗрен градиент",
  "block.minecraft.banner.gradient.orange": "Хĕрлĕ сарă градиент",
  "block.minecraft.banner.gradient.pink": "Кĕрен градиент",
  "block.minecraft.banner.gradient.purple": "Хӗрлӗ кӑвак градиент",
  "block.minecraft.banner.gradient.red": "Хӗрлӗ градиент",
  "block.minecraft.banner.gradient.white": "Шурӑ градиент",
  "block.minecraft.banner.gradient.yellow": "Сарӑ градиент",
  "block.minecraft.banner.gradient_up.black": "Хура тӳнтер градиент",
  "block.minecraft.banner.gradient_up.blue": "Кӑвак тӳнтер градиент",
  "block.minecraft.banner.gradient_up.brown": "Хӑмӑр тӳнтер градиент",
  "block.minecraft.banner.gradient_up.cyan": "Кăвак симӗс тӳнтер градиент",
  "block.minecraft.banner.gradient_up.gray": "Сăрă тӳнтер градиент",
  "block.minecraft.banner.gradient_up.green": "Симӗс тӳнтер градиент",
  "block.minecraft.banner.gradient_up.light_blue": "Сенкер тӳнтер градиент",
  "block.minecraft.banner.gradient_up.light_gray": "Ҫутӑ сӑрӑ тӳнтер градиент",
  "block.minecraft.banner.gradient_up.lime": "Сарӑ симӗс тӳнтер градиент",
  "block.minecraft.banner.gradient_up.magenta": "Хӗрлӗ кӗрен тӳнтер градиент",
  "block.minecraft.banner.gradient_up.orange": "Хĕрлĕ сарă тӳнтер градиент",
  "block.minecraft.banner.gradient_up.pink": "Кĕрен тӳнтер градиент",
  "block.minecraft.banner.gradient_up.purple": "Хӗрлӗ кӑвак тӳнтер градиент",
  "block.minecraft.banner.gradient_up.red": "Хĕрлĕ тӳнтер градиент",
  "block.minecraft.banner.gradient_up.white": "Шурă тӳнтер градиент",
  "block.minecraft.banner.gradient_up.yellow": "Сарӑ тӳнтер градиент",
  "block.minecraft.banner.guster.black": "Хура ҫавра ҫил",
  "block.minecraft.banner.guster.blue": "Кӑвак ҫавра ҫил",
  "block.minecraft.banner.guster.brown": "Хӑмӑр ҫавра ҫил",
  "block.minecraft.banner.guster.cyan": "Кӑвак симӗс ҫавра ҫил",
  "block.minecraft.banner.guster.gray": "Сӑрӑ ҫавра ҫил",
  "block.minecraft.banner.guster.green": "Симӗс ҫавра ҫил",
  "block.minecraft.banner.guster.light_blue": "Сенкер ҫавра ҫил",
  "block.minecraft.banner.guster.light_gray": "Ҫутӑ сӑрӑ ҫавра ҫил",
  "block.minecraft.banner.guster.lime": "Сарӑ симӗс ҫавра ҫил",
  "block.minecraft.banner.guster.magenta": "Хӗрлӗ кӗрен ҫавра ҫил",
  "block.minecraft.banner.guster.orange": "Хӗрлӗ сарӑ ҫавра ҫил",
  "block.minecraft.banner.guster.pink": "Кӗрен ҫавра ҫил",
  "block.minecraft.banner.guster.purple": "Хӗрлӗ кӑвак ҫавра ҫил",
  "block.minecraft.banner.guster.red": "Хӗрлӗ ҫавра ҫил",
  "block.minecraft.banner.guster.white": "Шурӑ ҫавра ҫил",
  "block.minecraft.banner.guster.yellow": "Сарӑ ҫавра ҫил",
  "block.minecraft.banner.half_horizontal.black": "Хура ҫӳлти ҫурри",
  "block.minecraft.banner.half_horizontal.blue": "Кӑвак ҫӳлти ҫурри",
  "block.minecraft.banner.half_horizontal.brown": "Хӑмӑр ҫӳлти ҫурри",
  "block.minecraft.banner.half_horizontal.cyan": "Кăвак симӗс ҫӳлти ҫурри",
  "block.minecraft.banner.half_horizontal.gray": "Сӑрӑ ҫӳлти ҫурри",
  "block.minecraft.banner.half_horizontal.green": "Симӗс ҫӳлти ҫурри",
  "block.minecraft.banner.half_horizontal.light_blue": "Сенкер ҫӳлти ҫурри",
  "block.minecraft.banner.half_horizontal.light_gray": "Ҫутӑ сӑрӑ ҫӳлти ҫурри",
  "block.minecraft.banner.half_horizontal.lime": "Сарӑ симӗс ҫӳлти ҫурри",
  "block.minecraft.banner.half_horizontal.magenta": "Хӗрлӗ кӗрен ҫӳлти ҫурри",
  "block.minecraft.banner.half_horizontal.orange": "Хĕрлĕ сарă ҫӳлти ҫурри",
  "block.minecraft.banner.half_horizontal.pink": "Кĕрен ҫӳлти ҫурри",
  "block.minecraft.banner.half_horizontal.purple": "Хӗрлӗ кӑвак ҫӳлти ҫурри",
  "block.minecraft.banner.half_horizontal.red": "Хĕрлĕ ҫӳлти ҫурри",
  "block.minecraft.banner.half_horizontal.white": "Шурă ҫӳлти ҫурри",
  "block.minecraft.banner.half_horizontal.yellow": "Сарӑ ҫӳлти ҫурри",
  "block.minecraft.banner.half_horizontal_bottom.black": "Хура аялти ҫурри",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Кӑвак аялти ҫурри",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Хӑмӑр аялти ҫурри",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Кăвак симӗс аялти ҫурри",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Сӑрӑ аялти ҫурри",
  "block.minecraft.banner.half_horizontal_bottom.green": "Симӗс аялти ҫурри",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Сенкер аялти ҫурри",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Ҫутӑ-сӑрӑ аялти ҫурри",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Сарӑ симӗс аялти ҫурри",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Хӗрлӗ кӗрен аялти ҫурри",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Хĕрлĕ сарă аялти ҫурри",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Кĕрен аялти ҫурри",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Хӗрлӗ кӑвак аялти ҫурри",
  "block.minecraft.banner.half_horizontal_bottom.red": "Хĕрлĕ аялти ҫурри",
  "block.minecraft.banner.half_horizontal_bottom.white": "Шурă аялти ҫурри",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Сарӑ аялти ҫурри",
  "block.minecraft.banner.half_vertical.black": "Хура сулахай ҫурри",
  "block.minecraft.banner.half_vertical.blue": "Кăвак сулахай ҫурри",
  "block.minecraft.banner.half_vertical.brown": "Хăмăр сулахай ҫурри",
  "block.minecraft.banner.half_vertical.cyan": "Кăвак симӗс сулахай ҫурри",
  "block.minecraft.banner.half_vertical.gray": "Сӑрӑ сулахай ҫурри",
  "block.minecraft.banner.half_vertical.green": "Симӗс сулахай ҫурри",
  "block.minecraft.banner.half_vertical.light_blue": "Сенкер сулахай ҫурри",
  "block.minecraft.banner.half_vertical.light_gray": "Ҫутӑ сӑрӑ сулахай ҫурри",
  "block.minecraft.banner.half_vertical.lime": "Сарӑ симӗс сулахай ҫурри",
  "block.minecraft.banner.half_vertical.magenta": "Хӗрлӗ кӗрен сулахай ҫурри",
  "block.minecraft.banner.half_vertical.orange": "Хĕрлĕ сарă сулахай ҫурри",
  "block.minecraft.banner.half_vertical.pink": "Кĕрен сулахай ҫурри",
  "block.minecraft.banner.half_vertical.purple": "Хӗрлӗ кӑвак сулахай ҫурри",
  "block.minecraft.banner.half_vertical.red": "Хĕрлĕ сулахай ҫурри",
  "block.minecraft.banner.half_vertical.white": "Шурă сулахай ҫурри",
  "block.minecraft.banner.half_vertical.yellow": "Сарӑ сулахай ҫурри",
  "block.minecraft.banner.half_vertical_right.black": "Хура сылтăм ҫурри",
  "block.minecraft.banner.half_vertical_right.blue": "Кăвак сылтăм ҫурри",
  "block.minecraft.banner.half_vertical_right.brown": "Хăмăр сылтăм ҫурри",
  "block.minecraft.banner.half_vertical_right.cyan": "Кăвак симӗс сулахай ҫурри",
  "block.minecraft.banner.half_vertical_right.gray": "Сăрă сылтăм ҫурри",
  "block.minecraft.banner.half_vertical_right.green": "Симӗс сылтăм ҫурри",
  "block.minecraft.banner.half_vertical_right.light_blue": "Сенкер сылтăм ҫурри",
  "block.minecraft.banner.half_vertical_right.light_gray": "Ҫутӑ сӑрӑ сылтăм ҫурри",
  "block.minecraft.banner.half_vertical_right.lime": "Сарӑ симӗс сылтăм ҫурри",
  "block.minecraft.banner.half_vertical_right.magenta": "Хӗрлӗ кӗрен сылтăм ҫурри",
  "block.minecraft.banner.half_vertical_right.orange": "Хĕрлĕ сарă сылтăм ҫурри",
  "block.minecraft.banner.half_vertical_right.pink": "Кĕрен сылтăм ҫурри",
  "block.minecraft.banner.half_vertical_right.purple": "Хĕрлĕ кăвак сылтăм ҫурри",
  "block.minecraft.banner.half_vertical_right.red": "Хĕрлĕ сылтăм ҫурри",
  "block.minecraft.banner.half_vertical_right.white": "Шурă сылтăм ҫурри",
  "block.minecraft.banner.half_vertical_right.yellow": "Сарă сылтăм ҫурри",
  "block.minecraft.banner.mojang.black": "Хура темӗн",
  "block.minecraft.banner.mojang.blue": "Кӑвак темӗн",
  "block.minecraft.banner.mojang.brown": "Хӑмӑр темӗн",
  "block.minecraft.banner.mojang.cyan": "Кăвак симӗс темӗн",
  "block.minecraft.banner.mojang.gray": "Сӑрӑ темӗн",
  "block.minecraft.banner.mojang.green": "Симӗс темӗн",
  "block.minecraft.banner.mojang.light_blue": "Сенкер темӗн",
  "block.minecraft.banner.mojang.light_gray": "Ҫутӑ сӑрӑ темӗн",
  "block.minecraft.banner.mojang.lime": "Сарӑ симӗс темӗн",
  "block.minecraft.banner.mojang.magenta": "Хӗрлӗ кӗрен темӗн",
  "block.minecraft.banner.mojang.orange": "Хĕрлĕ сарă темӗн",
  "block.minecraft.banner.mojang.pink": "Кӗрен темӗн",
  "block.minecraft.banner.mojang.purple": "Хӗрлӗ кӑвак темӗн",
  "block.minecraft.banner.mojang.red": "Хӗрлӗ темӗн",
  "block.minecraft.banner.mojang.white": "Шурӑ темӗн",
  "block.minecraft.banner.mojang.yellow": "Сарӑ темӗн",
  "block.minecraft.banner.piglin.black": "Хура сӑмса",
  "block.minecraft.banner.piglin.blue": "Кăвак сӑмса",
  "block.minecraft.banner.piglin.brown": "Хăмăр сӑмса",
  "block.minecraft.banner.piglin.cyan": "Кăвак симӗс сӑмса",
  "block.minecraft.banner.piglin.gray": "Сăрă сӑмса",
  "block.minecraft.banner.piglin.green": "Симĕс сӑмса",
  "block.minecraft.banner.piglin.light_blue": "Сенкер сӑмса",
  "block.minecraft.banner.piglin.light_gray": "Ҫутӑ сӑрӑ сӑмса",
  "block.minecraft.banner.piglin.lime": "Сарӑ симӗс сӑмса",
  "block.minecraft.banner.piglin.magenta": "Хӗрлӗ кӗрен сӑмса",
  "block.minecraft.banner.piglin.orange": "Хĕрлĕ сарă сӑмса",
  "block.minecraft.banner.piglin.pink": "Кĕрен сӑмса",
  "block.minecraft.banner.piglin.purple": "Хĕрлĕ кăвак сӑмса",
  "block.minecraft.banner.piglin.red": "Хĕрлĕ сӑмса",
  "block.minecraft.banner.piglin.white": "Шурă сӑмса",
  "block.minecraft.banner.piglin.yellow": "Сарă сӑмса",
  "block.minecraft.banner.rhombus.black": "Хура ромб",
  "block.minecraft.banner.rhombus.blue": "Кăвак ромб",
  "block.minecraft.banner.rhombus.brown": "Хăмăр ромб",
  "block.minecraft.banner.rhombus.cyan": "Кӑвак симӗс ромб",
  "block.minecraft.banner.rhombus.gray": "Сăрă ромб",
  "block.minecraft.banner.rhombus.green": "Симĕс ромб",
  "block.minecraft.banner.rhombus.light_blue": "Сенкер ромб",
  "block.minecraft.banner.rhombus.light_gray": "Ҫутӑ сӑрӑ ромб",
  "block.minecraft.banner.rhombus.lime": "Сарӑ симӗс ромб",
  "block.minecraft.banner.rhombus.magenta": "Хӗрлӗ кӗрен ромб",
  "block.minecraft.banner.rhombus.orange": "Хӗрлӗ сарӑ ромб",
  "block.minecraft.banner.rhombus.pink": "Кĕрен ромб",
  "block.minecraft.banner.rhombus.purple": "Хӗрлӗ кӑвак ромб",
  "block.minecraft.banner.rhombus.red": "Хĕрлĕ ромб",
  "block.minecraft.banner.rhombus.white": "Шурă ромб",
  "block.minecraft.banner.rhombus.yellow": "Сарă ромб",
  "block.minecraft.banner.skull.black": "Хура пуҫ шӑмми",
  "block.minecraft.banner.skull.blue": "Кăвак пуҫ шӑмми",
  "block.minecraft.banner.skull.brown": "Хăмăр пуҫ шӑмми",
  "block.minecraft.banner.skull.cyan": "Кăвак симӗс пуҫ шӑмми",
  "block.minecraft.banner.skull.gray": "Сăрă пуҫ шӑмми",
  "block.minecraft.banner.skull.green": "Симӗс пуҫ шӑмми",
  "block.minecraft.banner.skull.light_blue": "Сенкер пуҫ шӑмми",
  "block.minecraft.banner.skull.light_gray": "Ҫутӑ сӑрӑ пуҫ шӑмми",
  "block.minecraft.banner.skull.lime": "Сарӑ симӗс пуҫ шӑмми",
  "block.minecraft.banner.skull.magenta": "Хӗрлӗ кӗрен пуҫ шӑмми",
  "block.minecraft.banner.skull.orange": "Хĕрлĕ сарă пуҫ шӑмми",
  "block.minecraft.banner.skull.pink": "Кĕрен пуҫ шӑмми",
  "block.minecraft.banner.skull.purple": "Хĕрлĕ кăвак пуҫ шӑмми",
  "block.minecraft.banner.skull.red": "Хĕрлĕ пуҫ шӑмми",
  "block.minecraft.banner.skull.white": "Шурă пуҫ шӑмми",
  "block.minecraft.banner.skull.yellow": "Сарă пуҫ шӑмми",
  "block.minecraft.banner.small_stripes.black": "Хура юпасем",
  "block.minecraft.banner.small_stripes.blue": "Кăвак юпасем",
  "block.minecraft.banner.small_stripes.brown": "Хăмăр юпасем",
  "block.minecraft.banner.small_stripes.cyan": "Кăвак симӗс юпасем",
  "block.minecraft.banner.small_stripes.gray": "Сăрă юпасем",
  "block.minecraft.banner.small_stripes.green": "Симӗс юпасем",
  "block.minecraft.banner.small_stripes.light_blue": "Сенкер юпасем",
  "block.minecraft.banner.small_stripes.light_gray": "Ҫутӑ сӑрӑ юпасем",
  "block.minecraft.banner.small_stripes.lime": "Сарӑ симӗс юпасем",
  "block.minecraft.banner.small_stripes.magenta": "Хӗрлӗ кӗрен юпасем",
  "block.minecraft.banner.small_stripes.orange": "Хĕрлĕ сарă юпасем",
  "block.minecraft.banner.small_stripes.pink": "Кĕрен юпасем",
  "block.minecraft.banner.small_stripes.purple": "Хĕрлĕ кăвак юпасем",
  "block.minecraft.banner.small_stripes.red": "Хĕрлĕ юпасем",
  "block.minecraft.banner.small_stripes.white": "Шурă юпасем",
  "block.minecraft.banner.small_stripes.yellow": "Сарă юпасем",
  "block.minecraft.banner.square_bottom_left.black": "Хура аялти сулахай кантон",
  "block.minecraft.banner.square_bottom_left.blue": "Кăвак аялти сулахай кантон",
  "block.minecraft.banner.square_bottom_left.brown": "Хăмăр аялти сулахай кантон",
  "block.minecraft.banner.square_bottom_left.cyan": "Кăвак симӗс аялти сулахай кантон",
  "block.minecraft.banner.square_bottom_left.gray": "Сăрă аялти сулахай кантон",
  "block.minecraft.banner.square_bottom_left.green": "Симӗс аялти сулахай кантон",
  "block.minecraft.banner.square_bottom_left.light_blue": "Сенкер аялти сулахай кантон",
  "block.minecraft.banner.square_bottom_left.light_gray": "Ҫутӑ сӑрӑ аялти сулахай кантон",
  "block.minecraft.banner.square_bottom_left.lime": "Сарӑ симӗс аялти сулахай кантон",
  "block.minecraft.banner.square_bottom_left.magenta": "Хӗрлӗ кӗрен аялти сулахай кантон",
  "block.minecraft.banner.square_bottom_left.orange": "Хĕрлĕ сарă аялти сулахай кантон",
  "block.minecraft.banner.square_bottom_left.pink": "Кĕрен аялти сулахай кантон",
  "block.minecraft.banner.square_bottom_left.purple": "Хĕрлĕ кăвак аялти сулахай кантон",
  "block.minecraft.banner.square_bottom_left.red": "Хĕрлĕ аялти сулахай кантон",
  "block.minecraft.banner.square_bottom_left.white": "Шурă аялти сулахай кантон",
  "block.minecraft.banner.square_bottom_left.yellow": "Сарă аялти сулахай кантон",
  "block.minecraft.banner.square_bottom_right.black": "Хура аялти сылтӑм кантон",
  "block.minecraft.banner.square_bottom_right.blue": "Кăвак аялти сылтӑм кантон",
  "block.minecraft.banner.square_bottom_right.brown": "Хăмăр аялти сылтӑм кантон",
  "block.minecraft.banner.square_bottom_right.cyan": "Кăвак симӗс аялти сылтӑм кантон",
  "block.minecraft.banner.square_bottom_right.gray": "Сăрă аялти сылтӑм кантон",
  "block.minecraft.banner.square_bottom_right.green": "Симӗс аялти сылтӑм кантон",
  "block.minecraft.banner.square_bottom_right.light_blue": "Сенкер аялти сылтӑм кантон",
  "block.minecraft.banner.square_bottom_right.light_gray": "Ҫутӑ сӑрӑ аялти сылтӑм кантон",
  "block.minecraft.banner.square_bottom_right.lime": "Сарӑ симӗс аялти сылтӑм кантон",
  "block.minecraft.banner.square_bottom_right.magenta": "Хӗрлӗ кӗрен аялти сылтӑм кантон",
  "block.minecraft.banner.square_bottom_right.orange": "Хĕрлĕ сарă аялти-сулахай кантăн",
  "block.minecraft.banner.square_bottom_right.pink": "Кĕрен аялти сылтӑм кантон",
  "block.minecraft.banner.square_bottom_right.purple": "Хĕрлĕ кăвак аялти сылтӑм кантон",
  "block.minecraft.banner.square_bottom_right.red": "Хĕрлĕ аялти сылтӑм кантон",
  "block.minecraft.banner.square_bottom_right.white": "Шурă аялти сылтӑм кантон",
  "block.minecraft.banner.square_bottom_right.yellow": "Сарă аялти сылтӑм кантон",
  "block.minecraft.banner.square_top_left.black": "Хура ҫӳлти сулахай кантон",
  "block.minecraft.banner.square_top_left.blue": "Кăвак ҫӳлти сулахай кантон",
  "block.minecraft.banner.square_top_left.brown": "Хăмăр ҫӳлти сулахай кантон",
  "block.minecraft.banner.square_top_left.cyan": "Кăвак симӗс ҫӳлти сулахай кантон",
  "block.minecraft.banner.square_top_left.gray": "Сăрă ҫӳлти сулахай кантон",
  "block.minecraft.banner.square_top_left.green": "Симӗс ҫӳлти сулахай кантон",
  "block.minecraft.banner.square_top_left.light_blue": "Сенкер ҫӳлти сулахай кантон",
  "block.minecraft.banner.square_top_left.light_gray": "Ҫутӑ сӑрӑ ҫӳлти сулахай кантон",
  "block.minecraft.banner.square_top_left.lime": "Сарӑ симӗс ҫӳлти сулахай кантон",
  "block.minecraft.banner.square_top_left.magenta": "Хӗрлӗ кӗрен ҫӳлти сулахай кантон",
  "block.minecraft.banner.square_top_left.orange": "Хĕрлĕ сарă ҫӳлти сулахай кантон",
  "block.minecraft.banner.square_top_left.pink": "Кĕрен ҫӳлти сулахай кантон",
  "block.minecraft.banner.square_top_left.purple": "Хĕрлĕ кăвак ҫӳлти сулахай кантон",
  "block.minecraft.banner.square_top_left.red": "Хĕрлĕ ҫӳлти сулахай кантон",
  "block.minecraft.banner.square_top_left.white": "Шурă ҫӳлти сулахай кантон",
  "block.minecraft.banner.square_top_left.yellow": "Сарă ҫӳлти сулахай кантон",
  "block.minecraft.banner.square_top_right.black": "Хура ҫӳлти сылтӑм кантон",
  "block.minecraft.banner.square_top_right.blue": "Кăвак ҫӳлти сылтӑм кантон",
  "block.minecraft.banner.square_top_right.brown": "Хăмăр ҫӳлти сылтӑм кантон",
  "block.minecraft.banner.square_top_right.cyan": "Кăвак симӗс ҫӳлти сылтӑм кантон",
  "block.minecraft.banner.square_top_right.gray": "Сăрă ҫӳлти сылтӑм кантон",
  "block.minecraft.banner.square_top_right.green": "Симӗс ҫӳлти сылтӑм кантон",
  "block.minecraft.banner.square_top_right.light_blue": "Сенкер ҫӳлти сылтӑм кантон",
  "block.minecraft.banner.square_top_right.light_gray": "Ҫутӑ сӑрӑ ҫӳлти сылтӑм кантон",
  "block.minecraft.banner.square_top_right.lime": "Сарӑ симӗс ҫӳлти сылтӑм кантон",
  "block.minecraft.banner.square_top_right.magenta": "Хӗрлӗ кӗрен ҫӳлти сылтӑм кантон",
  "block.minecraft.banner.square_top_right.orange": "Хĕрлĕ сарă ҫӳлти сылтӑм кантон",
  "block.minecraft.banner.square_top_right.pink": "Кĕрен ҫӳлти сылтӑм кантон",
  "block.minecraft.banner.square_top_right.purple": "Хĕрлĕ кăвак ҫӳлти сылтӑм кантон",
  "block.minecraft.banner.square_top_right.red": "Хĕрлĕ ҫӳлти сылтӑм кантон",
  "block.minecraft.banner.square_top_right.white": "Шурă ҫӳлти сылтӑм кантон",
  "block.minecraft.banner.square_top_right.yellow": "Сарă ҫӳлти сылтӑм кантон",
  "block.minecraft.banner.straight_cross.black": "Хура хӗрес",
  "block.minecraft.banner.straight_cross.blue": "Кӑвак хӗрес",
  "block.minecraft.banner.straight_cross.brown": "Хӑмӑр хӗрес",
  "block.minecraft.banner.straight_cross.cyan": "Кăвак симӗс хӗрес",
  "block.minecraft.banner.straight_cross.gray": "Сăрă хӗрес",
  "block.minecraft.banner.straight_cross.green": "Симӗс хӗрес",
  "block.minecraft.banner.straight_cross.light_blue": "Сенкер хӗрес",
  "block.minecraft.banner.straight_cross.light_gray": "Ҫутӑ сӑрӑ хӗрес",
  "block.minecraft.banner.straight_cross.lime": "Сарӑ симӗс хӗрес",
  "block.minecraft.banner.straight_cross.magenta": "Хӗрлӗ кӗрен хӗрес",
  "block.minecraft.banner.straight_cross.orange": "Хĕрлĕ сарă хӗрес",
  "block.minecraft.banner.straight_cross.pink": "Кӗрен хӗрес",
  "block.minecraft.banner.straight_cross.purple": "Хĕрлĕ кăвак хӗрес",
  "block.minecraft.banner.straight_cross.red": "Хӗрлӗ хӗрес",
  "block.minecraft.banner.straight_cross.white": "Шурӑ хӗрес",
  "block.minecraft.banner.straight_cross.yellow": "Сарӑ хӗрес",
  "block.minecraft.banner.stripe_bottom.black": "Хура никӗс",
  "block.minecraft.banner.stripe_bottom.blue": "Кӑвак никӗс",
  "block.minecraft.banner.stripe_bottom.brown": "Хӑмӑр никӗс",
  "block.minecraft.banner.stripe_bottom.cyan": "Кăвак симӗс никӗс",
  "block.minecraft.banner.stripe_bottom.gray": "Сăрă никӗс",
  "block.minecraft.banner.stripe_bottom.green": "Симӗс никӗс",
  "block.minecraft.banner.stripe_bottom.light_blue": "Сенкер никӗс",
  "block.minecraft.banner.stripe_bottom.light_gray": "Ҫутӑ сӑрӑ никӗс",
  "block.minecraft.banner.stripe_bottom.lime": "Сарӑ симӗс никӗс",
  "block.minecraft.banner.stripe_bottom.magenta": "Хӗрлӗ кӗрен никӗс",
  "block.minecraft.banner.stripe_bottom.orange": "Хĕрлĕ сарă никӗс",
  "block.minecraft.banner.stripe_bottom.pink": "Кӗрен никӗс",
  "block.minecraft.banner.stripe_bottom.purple": "Хĕрлĕ кăвак никӗс",
  "block.minecraft.banner.stripe_bottom.red": "Хӗрлӗ никӗс",
  "block.minecraft.banner.stripe_bottom.white": "Шурӑ никӗс",
  "block.minecraft.banner.stripe_bottom.yellow": "Сарӑ никӗс",
  "block.minecraft.banner.stripe_center.black": "Хура юпа",
  "block.minecraft.banner.stripe_center.blue": "Кăвак юпа",
  "block.minecraft.banner.stripe_center.brown": "Хăмăр юпа",
  "block.minecraft.banner.stripe_center.cyan": "Кăвак симӗс юпа",
  "block.minecraft.banner.stripe_center.gray": "Сăрă юпа",
  "block.minecraft.banner.stripe_center.green": "Симӗс юпа",
  "block.minecraft.banner.stripe_center.light_blue": "Сенкер юпа",
  "block.minecraft.banner.stripe_center.light_gray": "Ҫутӑ сӑрӑ юпа",
  "block.minecraft.banner.stripe_center.lime": "Сарӑ симӗс юпа",
  "block.minecraft.banner.stripe_center.magenta": "Хӗрлӗ кӗрен юпа",
  "block.minecraft.banner.stripe_center.orange": "Хĕрлĕ сарă юпа",
  "block.minecraft.banner.stripe_center.pink": "Кĕрен юпа",
  "block.minecraft.banner.stripe_center.purple": "Хĕрлĕ кăвак юпа",
  "block.minecraft.banner.stripe_center.red": "Хĕрлĕ юпа",
  "block.minecraft.banner.stripe_center.white": "Шурă юпа",
  "block.minecraft.banner.stripe_center.yellow": "Сарă юпа",
  "block.minecraft.banner.stripe_downleft.black": "Хура сылтӑм чалӑш",
  "block.minecraft.banner.stripe_downleft.blue": "Кăвак сылтӑм чалӑш",
  "block.minecraft.banner.stripe_downleft.brown": "Хăмăр сылтӑм чалӑш",
  "block.minecraft.banner.stripe_downleft.cyan": "Кӑвак симӗс сылтӑм чалӑш",
  "block.minecraft.banner.stripe_downleft.gray": "Сăрă сылтӑм чалӑш",
  "block.minecraft.banner.stripe_downleft.green": "Симӗс сылтӑм чалӑш",
  "block.minecraft.banner.stripe_downleft.light_blue": "Сенкер сылтӑм чалӑш",
  "block.minecraft.banner.stripe_downleft.light_gray": "Ҫутӑ сӑрӑ сылтӑм чалӑш",
  "block.minecraft.banner.stripe_downleft.lime": "Сарӑ симӗс сылтӑм чалӑш",
  "block.minecraft.banner.stripe_downleft.magenta": "Хӗрлӗ кӗрен сылтӑм чалӑш",
  "block.minecraft.banner.stripe_downleft.orange": "Хĕрлĕ сарă сылтӑм чалӑш",
  "block.minecraft.banner.stripe_downleft.pink": "Кĕрен сылтӑм чалӑш",
  "block.minecraft.banner.stripe_downleft.purple": "Хĕрлĕ кăвак сылтӑм чалӑш",
  "block.minecraft.banner.stripe_downleft.red": "Хĕрлĕ сылтӑм чалӑш",
  "block.minecraft.banner.stripe_downleft.white": "Шурă сылтӑм чалӑш",
  "block.minecraft.banner.stripe_downleft.yellow": "Сарă сылтӑм чалӑш",
  "block.minecraft.banner.stripe_downright.black": "Хура сулахай чалӑш",
  "block.minecraft.banner.stripe_downright.blue": "Кăвак сулахай чалӑш",
  "block.minecraft.banner.stripe_downright.brown": "Хăмăр сулахай чалӑш",
  "block.minecraft.banner.stripe_downright.cyan": "Кӑвак симӗс сулахай чалӑш",
  "block.minecraft.banner.stripe_downright.gray": "Сăрă сулахай чалӑш",
  "block.minecraft.banner.stripe_downright.green": "Симӗс сулахай чалӑш",
  "block.minecraft.banner.stripe_downright.light_blue": "Сенкер сулахай чалӑш",
  "block.minecraft.banner.stripe_downright.light_gray": "Ҫутӑ сӑрӑ сулахай чалӑш",
  "block.minecraft.banner.stripe_downright.lime": "Сарӑ симӗс сулахай чалӑш",
  "block.minecraft.banner.stripe_downright.magenta": "Хӗрлӗ кӗрен сулахай чалӑш",
  "block.minecraft.banner.stripe_downright.orange": "Хĕрлĕ сарă сулахай чалӑш",
  "block.minecraft.banner.stripe_downright.pink": "Кĕрен сулахай чалӑш",
  "block.minecraft.banner.stripe_downright.purple": "Хĕрлĕ кăвак сулахай чалӑш",
  "block.minecraft.banner.stripe_downright.red": "Хĕрлĕ сулахай чалӑш",
  "block.minecraft.banner.stripe_downright.white": "Шурă сулахай чалӑш",
  "block.minecraft.banner.stripe_downright.yellow": "Сарă сулахай чалӑш",
  "block.minecraft.banner.stripe_left.black": "Хура сулахай юпа",
  "block.minecraft.banner.stripe_left.blue": "Кӑвак сулахай юпа",
  "block.minecraft.banner.stripe_left.brown": "Хӑмӑр сулахай юпа",
  "block.minecraft.banner.stripe_left.cyan": "Кӑвак симӗс сулахай юпа",
  "block.minecraft.banner.stripe_left.gray": "Сӑрӑ сулахай юпа",
  "block.minecraft.banner.stripe_left.green": "Симӗс сулахай юпа",
  "block.minecraft.banner.stripe_left.light_blue": "Сенкер сулахай юпа",
  "block.minecraft.banner.stripe_left.light_gray": "Ҫутӑ сӑрӑ сулахай юпа",
  "block.minecraft.banner.stripe_left.lime": "Сарӑ симӗс сулахай юпа",
  "block.minecraft.banner.stripe_left.magenta": "Хӗрлӗ кӗрен сулахай юпа",
  "block.minecraft.banner.stripe_left.orange": "Хӗрлӗ сарӑ сулахай юпа",
  "block.minecraft.banner.stripe_left.pink": "Кӗрен сулахай юпа",
  "block.minecraft.banner.stripe_left.purple": "Хӗрлӗ кӑвак сулахай юпа",
  "block.minecraft.banner.stripe_left.red": "Хӗрлӗ сулахай юпа",
  "block.minecraft.banner.stripe_left.white": "Шурӑ сулахай юпа",
  "block.minecraft.banner.stripe_left.yellow": "Сарӑ сулахай юпа",
  "block.minecraft.banner.stripe_middle.black": "Хура йӗр",
  "block.minecraft.banner.stripe_middle.blue": "Кăвак йӗр",
  "block.minecraft.banner.stripe_middle.brown": "Хăмăр йӗр",
  "block.minecraft.banner.stripe_middle.cyan": "Кăвак симӗс йӗр",
  "block.minecraft.banner.stripe_middle.gray": "Сăрă йӗр",
  "block.minecraft.banner.stripe_middle.green": "Симӗс йӗр",
  "block.minecraft.banner.stripe_middle.light_blue": "Сенкер йӗр",
  "block.minecraft.banner.stripe_middle.light_gray": "Ҫутӑ сӑрӑ йӗр",
  "block.minecraft.banner.stripe_middle.lime": "Сарӑ симӗс йӗр",
  "block.minecraft.banner.stripe_middle.magenta": "Хӗрлӗ кӗрен йӗр",
  "block.minecraft.banner.stripe_middle.orange": "Хӗрлӗ сарӑ йӗр",
  "block.minecraft.banner.stripe_middle.pink": "Кӗрен йӗр",
  "block.minecraft.banner.stripe_middle.purple": "Хĕрлĕ кăвак йӗр",
  "block.minecraft.banner.stripe_middle.red": "Хĕрлĕ йӗр",
  "block.minecraft.banner.stripe_middle.white": "Шурă йӗр",
  "block.minecraft.banner.stripe_middle.yellow": "Сарă йӗр",
  "block.minecraft.banner.stripe_right.black": "Хура сылтӑм юпа",
  "block.minecraft.banner.stripe_right.blue": "Кӑвак сылтӑм юпа",
  "block.minecraft.banner.stripe_right.brown": "Хӑмӑр сылтӑм юпа",
  "block.minecraft.banner.stripe_right.cyan": "Кӑвак симӗс сылтӑм юпа",
  "block.minecraft.banner.stripe_right.gray": "Сӑрӑ сылтӑм юпа",
  "block.minecraft.banner.stripe_right.green": "Симӗс сылтӑм юпа",
  "block.minecraft.banner.stripe_right.light_blue": "Сенкер сылтӑм юпа",
  "block.minecraft.banner.stripe_right.light_gray": "Ҫутӑ сӑрӑ сылтӑм юпа",
  "block.minecraft.banner.stripe_right.lime": "Сарӑ симӗс сылтӑм юпа",
  "block.minecraft.banner.stripe_right.magenta": "Хӗрлӗ кӗрен сылтӑм юпа",
  "block.minecraft.banner.stripe_right.orange": "Хӗрлӗ сарӑ сылтӑм юпа",
  "block.minecraft.banner.stripe_right.pink": "Кӗрен сылтӑм юпа",
  "block.minecraft.banner.stripe_right.purple": "Хӗрлӗ кӑвак сылтӑм юпа",
  "block.minecraft.banner.stripe_right.red": "Хӗрлӗ сылтӑм юпа",
  "block.minecraft.banner.stripe_right.white": "Шурӑ сылтӑм юпа",
  "block.minecraft.banner.stripe_right.yellow": "Сарӑ сылтӑм юпа",
  "block.minecraft.banner.stripe_top.black": "Хура мачча",
  "block.minecraft.banner.stripe_top.blue": "Кăвак мачча",
  "block.minecraft.banner.stripe_top.brown": "Хăмăр мачча",
  "block.minecraft.banner.stripe_top.cyan": "Кăвак симӗс мачча",
  "block.minecraft.banner.stripe_top.gray": "Сăрă мачча",
  "block.minecraft.banner.stripe_top.green": "Симӗс мачча",
  "block.minecraft.banner.stripe_top.light_blue": "Сенкер мачча",
  "block.minecraft.banner.stripe_top.light_gray": "Ҫутӑ сӑрӑ мачча",
  "block.minecraft.banner.stripe_top.lime": "Сарӑ симӗс мачча",
  "block.minecraft.banner.stripe_top.magenta": "Хӗрлӗ кӗрен мачча",
  "block.minecraft.banner.stripe_top.orange": "Хĕрлĕ сарă мачча",
  "block.minecraft.banner.stripe_top.pink": "Кĕрен мачча",
  "block.minecraft.banner.stripe_top.purple": "Хĕрлĕ кăвак мачча",
  "block.minecraft.banner.stripe_top.red": "Хĕрлĕ мачча",
  "block.minecraft.banner.stripe_top.white": "Шурă мачча",
  "block.minecraft.banner.stripe_top.yellow": "Сарă мачча",
  "block.minecraft.banner.triangle_bottom.black": "Хура аялти виҫ кӗтеслӗх",
  "block.minecraft.banner.triangle_bottom.blue": "Кăвак аялти виҫ кӗтеслӗх",
  "block.minecraft.banner.triangle_bottom.brown": "Хăмăр аялти виҫ кӗтеслӗх",
  "block.minecraft.banner.triangle_bottom.cyan": "Кăвак симӗс аялти виҫ кӗтеслӗх",
  "block.minecraft.banner.triangle_bottom.gray": "Сăрă аялти виҫ кӗтеслӗх",
  "block.minecraft.banner.triangle_bottom.green": "Симӗс аялти виҫ кӗтеслӗх",
  "block.minecraft.banner.triangle_bottom.light_blue": "Сенкер аялти виҫ кӗтеслӗх",
  "block.minecraft.banner.triangle_bottom.light_gray": "Ҫутӑ сӑрӑ аялти виҫ кӗтеслӗх",
  "block.minecraft.banner.triangle_bottom.lime": "Сарӑ симӗс аялти виҫ кӗтеслӗх",
  "block.minecraft.banner.triangle_bottom.magenta": "Хӗрлӗ кӗрен аялти виҫ кӗтеслӗх",
  "block.minecraft.banner.triangle_bottom.orange": "Хĕрлĕ сарă аялти виҫ кӗтеслӗх",
  "block.minecraft.banner.triangle_bottom.pink": "Кĕрен аялти виҫ кӗтеслӗх",
  "block.minecraft.banner.triangle_bottom.purple": "Хĕрлĕ кăвак аялти виҫ кӗтеслӗх",
  "block.minecraft.banner.triangle_bottom.red": "Хĕрлĕ аялти виҫ кӗтеслӗх",
  "block.minecraft.banner.triangle_bottom.white": "Шурă аялти виҫ кӗтеслӗх",
  "block.minecraft.banner.triangle_bottom.yellow": "Сарă аялти виҫ кӗтеслӗх",
  "block.minecraft.banner.triangle_top.black": "Хура ҫӳлти виҫ кӗтеслӗх",
  "block.minecraft.banner.triangle_top.blue": "Кăвак ҫӳлти виҫ кӗтеслӗх",
  "block.minecraft.banner.triangle_top.brown": "Хăмăр ҫӳлти виҫ кӗтеслӗх",
  "block.minecraft.banner.triangle_top.cyan": "Кăвак симӗс ҫӳлти виҫ кӗтеслӗх",
  "block.minecraft.banner.triangle_top.gray": "Сăрă ҫӳлти виҫ кӗтеслӗх",
  "block.minecraft.banner.triangle_top.green": "Симӗс ҫӳлти виҫ кӗтеслӗх",
  "block.minecraft.banner.triangle_top.light_blue": "Сенкер ҫӳлти виҫ кӗтеслӗх",
  "block.minecraft.banner.triangle_top.light_gray": "Ҫутӑ сӑрӑ ҫӳлти виҫ кӗтеслӗх",
  "block.minecraft.banner.triangle_top.lime": "Сарӑ симӗс ҫӳлти виҫ кӗтеслӗх",
  "block.minecraft.banner.triangle_top.magenta": "Хӗрлӗ кӗрен ҫӳлти виҫ кӗтеслӗх",
  "block.minecraft.banner.triangle_top.orange": "Хĕрлĕ сарă ҫӳлти виҫ кӗтеслӗх",
  "block.minecraft.banner.triangle_top.pink": "Кĕрен ҫӳлти виҫ кӗтеслӗх",
  "block.minecraft.banner.triangle_top.purple": "Хĕрлĕ кăвак ҫӳлти виҫ кӗтеслӗх",
  "block.minecraft.banner.triangle_top.red": "Хĕрлĕ ҫӳлти виҫ кӗтеслӗх",
  "block.minecraft.banner.triangle_top.white": "Шурă ҫӳлти виҫ кӗтеслӗх",
  "block.minecraft.banner.triangle_top.yellow": "Сарă ҫӳлти виҫ кӗтеслӗх",
  "block.minecraft.banner.triangles_bottom.black": "Хура шӑллӑ аял",
  "block.minecraft.banner.triangles_bottom.blue": "Кăвак шӑллӑ аял",
  "block.minecraft.banner.triangles_bottom.brown": "Хăмăр шӑллӑ аял",
  "block.minecraft.banner.triangles_bottom.cyan": "Кăвак симӗс шӑллӑ аял",
  "block.minecraft.banner.triangles_bottom.gray": "Сăрă шӑллӑ аял",
  "block.minecraft.banner.triangles_bottom.green": "Симӗс шӑллӑ аял",
  "block.minecraft.banner.triangles_bottom.light_blue": "Сенкер шӑллӑ аял",
  "block.minecraft.banner.triangles_bottom.light_gray": "Ҫутӑ сӑрӑ шӑллӑ аял",
  "block.minecraft.banner.triangles_bottom.lime": "Сарӑ симӗс шӑллӑ аял",
  "block.minecraft.banner.triangles_bottom.magenta": "Хӗрлӗ кӗрен шӑллӑ аял",
  "block.minecraft.banner.triangles_bottom.orange": "Хĕрлĕ сарă шӑллӑ аял",
  "block.minecraft.banner.triangles_bottom.pink": "Кĕрен шӑллӑ аял",
  "block.minecraft.banner.triangles_bottom.purple": "Хĕрлĕ кăвак шӑллӑ аял",
  "block.minecraft.banner.triangles_bottom.red": "Хĕрлĕ шӑллӑ аял",
  "block.minecraft.banner.triangles_bottom.white": "Шурă шӑллӑ аял",
  "block.minecraft.banner.triangles_bottom.yellow": "Сарă шӑллӑ аял",
  "block.minecraft.banner.triangles_top.black": "Хура шӑллӑ ҫӳл",
  "block.minecraft.banner.triangles_top.blue": "Кăвак шӑллӑ ҫӳл",
  "block.minecraft.banner.triangles_top.brown": "Хăмăр шӑллӑ ҫӳл",
  "block.minecraft.banner.triangles_top.cyan": "Кăвак симӗс шӑллӑ ҫӳл",
  "block.minecraft.banner.triangles_top.gray": "Сăрă шӑллӑ ҫӳл",
  "block.minecraft.banner.triangles_top.green": "Симӗс шӑллӑ ҫӳл",
  "block.minecraft.banner.triangles_top.light_blue": "Сенкер шӑллӑ ҫӳл",
  "block.minecraft.banner.triangles_top.light_gray": "Ҫутӑ сӑрӑ шӑллӑ ҫӳл",
  "block.minecraft.banner.triangles_top.lime": "Сарӑ симӗс шӑллӑ ҫӳл",
  "block.minecraft.banner.triangles_top.magenta": "Хӗрлӗ кӗрен шӑллӑ ҫӳл",
  "block.minecraft.banner.triangles_top.orange": "Хĕрлĕ сарă шӑллӑ ҫӳл",
  "block.minecraft.banner.triangles_top.pink": "Кĕрен шӑллӑ ҫӳл",
  "block.minecraft.banner.triangles_top.purple": "Хĕрлĕ кăвак шӑллӑ ҫӳл",
  "block.minecraft.banner.triangles_top.red": "Хĕрлĕ шӑллӑ ҫӳл",
  "block.minecraft.banner.triangles_top.white": "Шурă шӑллӑ ҫӳл",
  "block.minecraft.banner.triangles_top.yellow": "Сарă шӑллӑ ҫӳл",
  "block.minecraft.barrel": "Пичке",
  "block.minecraft.barrier": "Чарак",
  "block.minecraft.basalt": "Базальт",
  "block.minecraft.beacon": "Маяк",
  "block.minecraft.beacon.primary": "Пӗрремӗшле витӗм",
  "block.minecraft.beacon.secondary": "Иккӗмӗшле витӗм",
  "block.minecraft.bed.no_sleep": "Ҫӗрле е аслатиллӗ ҫумӑр чухне ҫеҫ ҫывӑрма пулать",
  "block.minecraft.bed.not_safe": "Эсӗ ҫывӑраймастӑн: юнашар монстрсем пур",
  "block.minecraft.bed.obstructed": "Ку кравать патне ҫул кăткăслатнă",
  "block.minecraft.bed.occupied": "Ку кравать йышӑннӑ",
  "block.minecraft.bed.too_far_away": "Эсӗ ҫывӑраймастӑн: кравать ытла инҫе",
  "block.minecraft.bedrock": "Бедрок",
  "block.minecraft.bee_nest": "Хурт йӑви",
  "block.minecraft.beehive": "Вĕлле",
  "block.minecraft.beetroots": "Кăшман",
  "block.minecraft.bell": "Чан",
  "block.minecraft.big_dripleaf": "Пысӑк тумлам ҫулҫӑ",
  "block.minecraft.big_dripleaf_stem": "Пысӑк тумлам ҫулҫӑ туни",
  "block.minecraft.birch_button": "Хурӑн пускăч",
  "block.minecraft.birch_door": "Хурӑн алӑк",
  "block.minecraft.birch_fence": "Хурăн карта",
  "block.minecraft.birch_fence_gate": "Хурăн калинкке",
  "block.minecraft.birch_hanging_sign": "Хурӑн ҫакмалли паллӑ",
  "block.minecraft.birch_leaves": "Хурӑн ҫулҫи",
  "block.minecraft.birch_log": "Хурӑн пӗрене",
  "block.minecraft.birch_planks": "Хурӑн хӑма",
  "block.minecraft.birch_pressure_plate": "Хурӑн пусмалли плита",
  "block.minecraft.birch_sapling": "Хурӑн хунавӗ",
  "block.minecraft.birch_shelf": "Хурӑн ҫӳлӗк",
  "block.minecraft.birch_sign": "Хурӑн паллӑ",
  "block.minecraft.birch_slab": "Хурӑн плита",
  "block.minecraft.birch_stairs": "Хурӑн картлашка",
  "block.minecraft.birch_trapdoor": "Хурӑн люк",
  "block.minecraft.birch_wall_hanging_sign": "Хӳмери хурӑн ҫакмалли паллӑ",
  "block.minecraft.birch_wall_sign": "Хӳмери хурӑн паллӑ",
  "block.minecraft.birch_wood": "Хурӑн йывӑҫ",
  "block.minecraft.black_banner": "Хура ялав",
  "block.minecraft.black_bed": "Хура кравать",
  "block.minecraft.black_candle": "Хура ҫурта",
  "block.minecraft.black_candle_cake": "Хура ҫурталлӑ торт",
  "block.minecraft.black_carpet": "Хура кавир",
  "block.minecraft.black_concrete": "Хура бетон",
  "block.minecraft.black_concrete_powder": "Хура типĕ бетон",
  "block.minecraft.black_glazed_terracotta": "Хура глазурьленĕ керамика",
  "block.minecraft.black_shulker_box": "Хура шалкер арчи",
  "block.minecraft.black_stained_glass": "Хура кантӑк",
  "block.minecraft.black_stained_glass_pane": "Хура ҫӳхе кантӑк",
  "block.minecraft.black_terracotta": "Хура керамика",
  "block.minecraft.black_wool": "Хура ҫӑм",
  "block.minecraft.blackstone": "Хура чул",
  "block.minecraft.blackstone_slab": "Хура чул плита",
  "block.minecraft.blackstone_stairs": "Хура чул картлашка",
  "block.minecraft.blackstone_wall": "Хура чул карта",
  "block.minecraft.blast_furnace": "Шăратмалли кăмака",
  "block.minecraft.blue_banner": "Кӑвак ялав",
  "block.minecraft.blue_bed": "Кӑвак кравать",
  "block.minecraft.blue_candle": "Кăвак ҫурта",
  "block.minecraft.blue_candle_cake": "Кăвак ҫурталлă торт",
  "block.minecraft.blue_carpet": "Кӑвак кавир",
  "block.minecraft.blue_concrete": "Кӑвак бетон",
  "block.minecraft.blue_concrete_powder": "Кăвак типĕ бетон",
  "block.minecraft.blue_glazed_terracotta": "Кӑвак глазурьленӗ керамика",
  "block.minecraft.blue_ice": "Кӑвак пӑр",
  "block.minecraft.blue_orchid": "Кӑвак орхидея",
  "block.minecraft.blue_shulker_box": "Кӑвак шалкер арчи",
  "block.minecraft.blue_stained_glass": "Кӑвак кантӑк",
  "block.minecraft.blue_stained_glass_pane": "Кӑвак ҫӳхе кантӑк",
  "block.minecraft.blue_terracotta": "Кăвак керамика",
  "block.minecraft.blue_wool": "Кӑвак ҫӑм",
  "block.minecraft.bone_block": "Шăмă блокĕ",
  "block.minecraft.bookshelf": "Кӗнеке ҫӳлӗкӗ",
  "block.minecraft.brain_coral": "Миме мерчен",
  "block.minecraft.brain_coral_block": "Миме мерчен блок",
  "block.minecraft.brain_coral_fan": "Веерле миме мерчен",
  "block.minecraft.brain_coral_wall_fan": "Хӳмери веерле миме мерчен",
  "block.minecraft.brewing_stand": "Им вӗреткӗч",
  "block.minecraft.brick_slab": "Кирпӗч плита",
  "block.minecraft.brick_stairs": "Кирпӗч картлашка",
  "block.minecraft.brick_wall": "Кирпӗч карта",
  "block.minecraft.bricks": "Кирпӗч",
  "block.minecraft.brown_banner": "Хăмăр ялав",
  "block.minecraft.brown_bed": "Хӑмӑр кравать",
  "block.minecraft.brown_candle": "Хӑмӑр ҫурта",
  "block.minecraft.brown_candle_cake": "Хӑмӑр ҫурталлӑ торт",
  "block.minecraft.brown_carpet": "Хӑмӑр кавир",
  "block.minecraft.brown_concrete": "Хӑмӑр бетон",
  "block.minecraft.brown_concrete_powder": "Хăмăр типĕ бетон",
  "block.minecraft.brown_glazed_terracotta": "Хӑмӑр глазурьленӗ керамика",
  "block.minecraft.brown_mushroom": "Хăмăр кăмпа",
  "block.minecraft.brown_mushroom_block": "Хăмăр кăмпа блокӗ",
  "block.minecraft.brown_shulker_box": "Хӑмӑр шалкер арчи",
  "block.minecraft.brown_stained_glass": "Хӑмӑр кантӑк",
  "block.minecraft.brown_stained_glass_pane": "Хӑмӑр ҫӳхе кантӑк",
  "block.minecraft.brown_terracotta": "Хăмăр керамика",
  "block.minecraft.brown_wool": "Хӑмӑр ҫӑм",
  "block.minecraft.bubble_column": "Хӑмпӑ юпи",
  "block.minecraft.bubble_coral": "Хӑмпӑллӑ мерчен",
  "block.minecraft.bubble_coral_block": "Хӑмпӑллӑ мерчен блок",
  "block.minecraft.bubble_coral_fan": "Веерле хӑмпӑллӑ мерчен блокĕ",
  "block.minecraft.bubble_coral_wall_fan": "Хӳмери веерле хӑмпӑллӑ мерчен",
  "block.minecraft.budding_amethyst": "Папкаланакан аметист",
  "block.minecraft.bush": "Тӗмӗ",
  "block.minecraft.cactus": "Кактус",
  "block.minecraft.cactus_flower": "Кактус чечекӗ",
  "block.minecraft.cake": "Торт",
  "block.minecraft.calcite": "Кальцит",
  "block.minecraft.calibrated_sculk_sensor": "Йӗркеленӗ скалк сенсорӗ",
  "block.minecraft.campfire": "Кӑвайт",
  "block.minecraft.candle": "Ҫурта",
  "block.minecraft.candle_cake": "Ҫурталлӑ торт",
  "block.minecraft.carrots": "Кишӗр",
  "block.minecraft.cartography_table": "Карттӑҫӑ сӗтелӗ",
  "block.minecraft.carved_pumpkin": "Каснӑ кавӑн",
  "block.minecraft.cauldron": "Хуран",
  "block.minecraft.cave_air": "Ҫӗр хӑвӑлӗ сывлӑшӗ",
  "block.minecraft.cave_vines": "Ҫӗр хӑвӑлӗ лиани",
  "block.minecraft.cave_vines_plant": "Ҫӗр хӑвӑлӗ лиани туни",
  "block.minecraft.chain": "Сăнчăр",
  "block.minecraft.chain_command_block": "Сӑнчӑрлӑ команда блокӗ",
  "block.minecraft.cherry_button": "Чие пускӑч",
  "block.minecraft.cherry_door": "Чие алӑк",
  "block.minecraft.cherry_fence": "Чие карта",
  "block.minecraft.cherry_fence_gate": "Чие калинкке",
  "block.minecraft.cherry_hanging_sign": "Чие ҫакмалли паллӑ",
  "block.minecraft.cherry_leaves": "Чие ҫулҫи",
  "block.minecraft.cherry_log": "Чие пӗрене",
  "block.minecraft.cherry_planks": "Чие хӑма",
  "block.minecraft.cherry_pressure_plate": "Чие пусмалли плита",
  "block.minecraft.cherry_sapling": "Чие хунавӗ",
  "block.minecraft.cherry_shelf": "Чие ҫӳлӗк",
  "block.minecraft.cherry_sign": "Чие паллӑ",
  "block.minecraft.cherry_slab": "Чие плита",
  "block.minecraft.cherry_stairs": "Чие картлашка",
  "block.minecraft.cherry_trapdoor": "Чие люк",
  "block.minecraft.cherry_wall_hanging_sign": "Хӳмери чие ҫакмалли паллӑ",
  "block.minecraft.cherry_wall_sign": "Хӳмери чие паллӑ",
  "block.minecraft.cherry_wood": "Чие йывӑҫ",
  "block.minecraft.chest": "Арча",
  "block.minecraft.chipped_anvil": "Катӑлнӑ сунтал",
  "block.minecraft.chiseled_bookshelf": "Тӗрӗллӗ кӗнеке ҫӳлӗкӗ",
  "block.minecraft.chiseled_copper": "Тӗрӗллӗ пӑхӑр блок",
  "block.minecraft.chiseled_deepslate": "Хӑйранӑ тарӑн сий чул",
  "block.minecraft.chiseled_nether_bricks": "Хӑйранӑ незер кирпӗч",
  "block.minecraft.chiseled_polished_blackstone": "Хӑйранӑ якатнӑ хура чул",
  "block.minecraft.chiseled_quartz_block": "Хӑйранӑ кварц блок",
  "block.minecraft.chiseled_red_sandstone": "Хӑйранӑ хӗрлӗ хӑйӑр чул",
  "block.minecraft.chiseled_resin_bricks": "Хӑйранӑ сухӑр кирпӗч",
  "block.minecraft.chiseled_sandstone": "Хӑйранӑ хӑйӑр чул",
  "block.minecraft.chiseled_stone_bricks": "Хӑйранӑ чул кирпӗч",
  "block.minecraft.chiseled_tuff": "Хӑйранӑ туф",
  "block.minecraft.chiseled_tuff_bricks": "Хӑйранӑ туф кирпӗч",
  "block.minecraft.chorus_flower": "Хорус чечекӗ",
  "block.minecraft.chorus_plant": "Хорус",
  "block.minecraft.clay": "Тӑм",
  "block.minecraft.closed_eyeblossom": "Хупӑ куҫ чечек",
  "block.minecraft.coal_block": "Кӑмрӑк блок",
  "block.minecraft.coal_ore": "Кӑмрӑк тӑпри",
  "block.minecraft.coarse_dirt": "Чуллӑ тӑпра",
  "block.minecraft.cobbled_deepslate": "Чӑмӑр тарӑн сий чул",
  "block.minecraft.cobbled_deepslate_slab": "Чӑмӑр тарӑн сий чул плита",
  "block.minecraft.cobbled_deepslate_stairs": "Чӑмӑр тарӑн сий чул картлашка",
  "block.minecraft.cobbled_deepslate_wall": "Чӑмӑр тарӑн сий чул карта",
  "block.minecraft.cobblestone": "Чӑмӑр чул",
  "block.minecraft.cobblestone_slab": "Чӑмӑр чул плита",
  "block.minecraft.cobblestone_stairs": "Чӑмӑр чул картлашка",
  "block.minecraft.cobblestone_wall": "Чӑмӑр чул карта",
  "block.minecraft.cobweb": "Эрешмен карти",
  "block.minecraft.cocoa": "Какао",
  "block.minecraft.command_block": "Команда блокӗ",
  "block.minecraft.comparator": "Редстоун компараторӗ",
  "block.minecraft.composter": "Компостер",
  "block.minecraft.conduit": "Тинӗс ҫӑлкуҫӗ",
  "block.minecraft.copper_bars": "Пӑхӑр хулӑ",
  "block.minecraft.copper_block": "Пӑхӑр блок",
  "block.minecraft.copper_bulb": "Пӑхӑр хунар",
  "block.minecraft.copper_chain": "Пӑхӑр сӑнчӑр",
  "block.minecraft.copper_chest": "Пӑхӑр арча",
  "block.minecraft.copper_door": "Пӑхӑр алӑк",
  "block.minecraft.copper_golem_statue": "Пӑхӑр голем кӗлетки",
  "block.minecraft.copper_grate": "Пӑхӑр чӗнтӗр",
  "block.minecraft.copper_lantern": "Пӑхӑр хунар",
  "block.minecraft.copper_ore": "Пӑхӑр тӑпри",
  "block.minecraft.copper_torch": "Пӑхӑр ҫункӑҫ",
  "block.minecraft.copper_trapdoor": "Пӑхӑр люк",
  "block.minecraft.copper_wall_torch": "Хӳмери пӑхӑр ҫункӑҫ",
  "block.minecraft.cornflower": "Кӑвак утмӑл турат",
  "block.minecraft.cracked_deepslate_bricks": "Ҫуркаланнӑ тарӑн сий чул кирпӗч",
  "block.minecraft.cracked_deepslate_tiles": "Ҫуркаланнӑ лаптак тарӑн сий чул",
  "block.minecraft.cracked_nether_bricks": "Ҫуркаланнӑ незер кирпӗч",
  "block.minecraft.cracked_polished_blackstone_bricks": "Ҫуркаланнӑ якатнӑ хура чул кирпӗч",
  "block.minecraft.cracked_stone_bricks": "Ҫуркаланнӑ чул кирпӗч",
  "block.minecraft.crafter": "Пуҫтаркӑч",
  "block.minecraft.crafting_table": "Ӗҫ сӗтелӗ",
  "block.minecraft.creaking_heart": "Чӗриклетчӗк чӗри",
  "block.minecraft.creeper_head": "Крипер пуҫӗ",
  "block.minecraft.creeper_wall_head": "Хӳмери крипер пуҫӗ",
  "block.minecraft.crimson_button": "Хӗмлӗ пускӑч",
  "block.minecraft.crimson_door": "Хӗмлӗ алӑк",
  "block.minecraft.crimson_fence": "Хӗмлӗ карта",
  "block.minecraft.crimson_fence_gate": "Хӗмлӗ калинкке",
  "block.minecraft.crimson_fungus": "Хӗмлӗ кӑмпа",
  "block.minecraft.crimson_hanging_sign": "Хӗмлӗ ҫакмалли паллӑ",
  "block.minecraft.crimson_hyphae": "Хӗмлӗ гифа",
  "block.minecraft.crimson_nylium": "Хӗмлӗ нилий",
  "block.minecraft.crimson_planks": "Хӗмлӗ хӑма",
  "block.minecraft.crimson_pressure_plate": "Хӗмлӗ пусмалли плита",
  "block.minecraft.crimson_roots": "Хӗмлӗ тымар",
  "block.minecraft.crimson_shelf": "Хӗмлӗ ҫӳлӗк",
  "block.minecraft.crimson_sign": "Хӗмлӗ паллӑ",
  "block.minecraft.crimson_slab": "Хӗмлӗ плита",
  "block.minecraft.crimson_stairs": "Хӗмлӗ картлашка",
  "block.minecraft.crimson_stem": "Хӗмлӗ туна",
  "block.minecraft.crimson_trapdoor": "Хӗмлӗ люк",
  "block.minecraft.crimson_wall_hanging_sign": "Хӳмери хӗмлӗ ҫакмалли паллӑ",
  "block.minecraft.crimson_wall_sign": "Хӳмери хӗмлӗ паллӑ",
  "block.minecraft.crying_obsidian": "Йӗрекен обсидиан",
  "block.minecraft.cut_copper": "Каснӑ пӑхӑр",
  "block.minecraft.cut_copper_slab": "Каснӑ пӑхӑр плита",
  "block.minecraft.cut_copper_stairs": "Каснӑ пӑхӑр картлашка",
  "block.minecraft.cut_red_sandstone": "Каснӑ хӗрлӗ хӑйӑр чул",
  "block.minecraft.cut_red_sandstone_slab": "Каснӑ хӗрлӗ хӑйӑр чул плита",
  "block.minecraft.cut_sandstone": "Каснӑ хӑйӑр чул",
  "block.minecraft.cut_sandstone_slab": "Каснӑ хӑйӑр чул",
  "block.minecraft.cyan_banner": "Кӑвак симӗс ялав",
  "block.minecraft.cyan_bed": "Кӑвак симӗс кравать",
  "block.minecraft.cyan_candle": "Кӑвак симӗс ҫурта",
  "block.minecraft.cyan_candle_cake": "Кӑвак симӗс ҫурталлӑ торт",
  "block.minecraft.cyan_carpet": "Кӑвак симӗс кавир",
  "block.minecraft.cyan_concrete": "Кӑвак симӗс бетон",
  "block.minecraft.cyan_concrete_powder": "Кӑвак симӗс типӗ бетон",
  "block.minecraft.cyan_glazed_terracotta": "Кӑвак симӗс глазурьленĕ керамика",
  "block.minecraft.cyan_shulker_box": "Кӑвак симӗс шалкер арчи",
  "block.minecraft.cyan_stained_glass": "Кӑвак симӗс кантӑк",
  "block.minecraft.cyan_stained_glass_pane": "Кӑвак симӗс ҫӳхе кантӑк",
  "block.minecraft.cyan_terracotta": "Кӑвак симӗс керамика",
  "block.minecraft.cyan_wool": "Кӑвак симӗс ҫӑм",
  "block.minecraft.damaged_anvil": "Ваннӑ сунтал",
  "block.minecraft.dandelion": "Кукша пуҫ",
  "block.minecraft.dark_oak_button": "Тӗттӗм юман пускӑч",
  "block.minecraft.dark_oak_door": "Тӗттӗм юман алӑк",
  "block.minecraft.dark_oak_fence": "Тӗттӗм юман карта",
  "block.minecraft.dark_oak_fence_gate": "Тĕттĕм юман калинкке",
  "block.minecraft.dark_oak_hanging_sign": "Тӗттӗм юман ҫакмалли паллӑ",
  "block.minecraft.dark_oak_leaves": "Тӗттӗм юман ҫулҫи",
  "block.minecraft.dark_oak_log": "Тӗттӗм юман пӗрене",
  "block.minecraft.dark_oak_planks": "Тӗттӗм юман хӑма",
  "block.minecraft.dark_oak_pressure_plate": "Тĕттĕм юман пусмалли плита",
  "block.minecraft.dark_oak_sapling": "Тӗттӗм юман хунавӗ",
  "block.minecraft.dark_oak_shelf": "Тӗттӗм юман ҫӳлӗк",
  "block.minecraft.dark_oak_sign": "Тӗттӗм юман паллӑ",
  "block.minecraft.dark_oak_slab": "Тӗттӗм юман плита",
  "block.minecraft.dark_oak_stairs": "Тӗттӗм юман картлашка",
  "block.minecraft.dark_oak_trapdoor": "Тӗттӗм юман люк",
  "block.minecraft.dark_oak_wall_hanging_sign": "Хӳмери тӗттӗм юман ҫакмалли паллӑ",
  "block.minecraft.dark_oak_wall_sign": "Хӳмери тӗттӗм юман паллӑ",
  "block.minecraft.dark_oak_wood": "Тӗттӗм юман йывӑҫ",
  "block.minecraft.dark_prismarine": "Тӗттӗм призмарин",
  "block.minecraft.dark_prismarine_slab": "Хура призмарин плита",
  "block.minecraft.dark_prismarine_stairs": "Хура призмарин картлашка",
  "block.minecraft.daylight_detector": "Кун ҫути детекторӗ",
  "block.minecraft.dead_brain_coral": "Вилнӗ миме мерчен",
  "block.minecraft.dead_brain_coral_block": "Вилнӗ миме мерчен блок",
  "block.minecraft.dead_brain_coral_fan": "Вилнĕ веерле миме мерчен",
  "block.minecraft.dead_brain_coral_wall_fan": "Хӳмери вилнӗ веерле миме мерчен",
  "block.minecraft.dead_bubble_coral": "Вилнӗ хӑмпӑллӑ мерчен",
  "block.minecraft.dead_bubble_coral_block": "Вилнӗ хӑмпӑллӑ мерчен блок",
  "block.minecraft.dead_bubble_coral_fan": "Вилнӗ веерле хӑмпӑллӑ мерчен",
  "block.minecraft.dead_bubble_coral_wall_fan": "Хӳмери вилнӗ веерле хӑмпӑллӑ мерчен",
  "block.minecraft.dead_bush": "Хӑрӑк тӗмӗ",
  "block.minecraft.dead_fire_coral": "Вилнӗ вут мерчен",
  "block.minecraft.dead_fire_coral_block": "Вилнӗ вут мерчен блок",
  "block.minecraft.dead_fire_coral_fan": "Вилнӗ веерле вут мерчен",
  "block.minecraft.dead_fire_coral_wall_fan": "Хӳмери вилнӗ веерле вут мерчен",
  "block.minecraft.dead_horn_coral": "Вилнӗ мӑйрака мерчен",
  "block.minecraft.dead_horn_coral_block": "Вилнӗ мӑйрака мерчен блок",
  "block.minecraft.dead_horn_coral_fan": "Вилнӗ веерле мӑйрака мерчен",
  "block.minecraft.dead_horn_coral_wall_fan": "Хӳмери вилнӗ веерле мӑйрака мерчен",
  "block.minecraft.dead_tube_coral": "Вилнӗ чӗлӗм мерчен",
  "block.minecraft.dead_tube_coral_block": "Вилнӗ чӗлӗм мерчен блок",
  "block.minecraft.dead_tube_coral_fan": "Вилнӗ веерле чӗлӗм мерчен",
  "block.minecraft.dead_tube_coral_wall_fan": "Хӳмери вилнӗ веерле чӗлӗм мерчен",
  "block.minecraft.decorated_pot": "Эрешлӗ чӳлмек",
  "block.minecraft.deepslate": "Тарӑн сий чул",
  "block.minecraft.deepslate_brick_slab": "Тарӑн сий чул кирпӗч плита",
  "block.minecraft.deepslate_brick_stairs": "Тарӑн сий чул кирпӗч картлашка",
  "block.minecraft.deepslate_brick_wall": "Тарӑн сий чул кирпӗч карта",
  "block.minecraft.deepslate_bricks": "Тарӑн сий чул кирпӗч",
  "block.minecraft.deepslate_coal_ore": "Тарӑн сий чул кӑмрӑк тӑпри",
  "block.minecraft.deepslate_copper_ore": "Тарӑн сий чул пӑхӑр тӑпри",
  "block.minecraft.deepslate_diamond_ore": "Тарӑн сий чул алмас тӑпри",
  "block.minecraft.deepslate_emerald_ore": "Тарӑн сий чул изумруд тӑпри",
  "block.minecraft.deepslate_gold_ore": "Тарӑн сий чул ылтӑн тӑпри",
  "block.minecraft.deepslate_iron_ore": "Тарӑн сий чул тимӗр тӑпри",
  "block.minecraft.deepslate_lapis_ore": "Тарӑн сий чул лазурит тӑпри",
  "block.minecraft.deepslate_redstone_ore": "Тарӑн сий чул редстоун тӑпри",
  "block.minecraft.deepslate_tile_slab": "Лаптак тарӑн сий чул плита",
  "block.minecraft.deepslate_tile_stairs": "Лаптак тарӑн сий чул картлашка",
  "block.minecraft.deepslate_tile_wall": "Лаптак тарӑн сий чул карта",
  "block.minecraft.deepslate_tiles": "Лаптак тарӑн сий чул",
  "block.minecraft.detector_rail": "Детекторлӑ рельс",
  "block.minecraft.diamond_block": "Алмас блок",
  "block.minecraft.diamond_ore": "Алмас тӑпри",
  "block.minecraft.diorite": "Диорит",
  "block.minecraft.diorite_slab": "Диорит плита",
  "block.minecraft.diorite_stairs": "Диорит картлашка",
  "block.minecraft.diorite_wall": "Диорит карта",
  "block.minecraft.dirt": "Тӑпра",
  "block.minecraft.dirt_path": "Сукмак",
  "block.minecraft.dispenser": "Валеҫкӗч",
  "block.minecraft.dragon_egg": "Аҫтаха ҫӑмарти",
  "block.minecraft.dragon_head": "Аҫтаха пуҫӗ",
  "block.minecraft.dragon_wall_head": "Хӳмери аҫтаха пуҫӗ",
  "block.minecraft.dried_ghast": "Типӗ гаст",
  "block.minecraft.dried_kelp_block": "Типӗтнӗ ламинари блок",
  "block.minecraft.dripstone_block": "Тармак",
  "block.minecraft.dropper": "Пӑрахкӑч",
  "block.minecraft.emerald_block": "Изумруд блок",
  "block.minecraft.emerald_ore": "Изумруд тӑпри",
  "block.minecraft.enchanting_table": "Ӑрӑм сӗтелӗ",
  "block.minecraft.end_gateway": "Энд хапхи",
  "block.minecraft.end_portal": "Энд порталӗ",
  "block.minecraft.end_portal_frame": "Энд порталӗ хашакӗ",
  "block.minecraft.end_rod": "Энд кашти",
  "block.minecraft.end_stone": "Эндер чул",
  "block.minecraft.end_stone_brick_slab": "Эндер чул кирпӗч плита",
  "block.minecraft.end_stone_brick_stairs": "Эндер чул кирпӗч картлашка",
  "block.minecraft.end_stone_brick_wall": "Эндер чул кирпӗч карта",
  "block.minecraft.end_stone_bricks": "Эндер чул кирпӗч",
  "block.minecraft.ender_chest": "Эндер арча",
  "block.minecraft.exposed_chiseled_copper": "Тӗксӗмленнӗ хӑйранӑ пӑхӑр",
  "block.minecraft.exposed_copper": "Тӗксӗмленнӗ пӑхӑр",
  "block.minecraft.exposed_copper_bars": "Тӗксӗмленнӗ пӑхӑр хулӑ",
  "block.minecraft.exposed_copper_bulb": "Тӗксӗмленнӗ пӑхӑр хунар",
  "block.minecraft.exposed_copper_chain": "Тӗксӗмленнӗ пӑхӑр сӑнчӑр",
  "block.minecraft.exposed_copper_chest": "Тӗксӗмленнӗ пӑхӑр арча",
  "block.minecraft.exposed_copper_door": "Тӗксӗмленнӗ пăхăр алăк",
  "block.minecraft.exposed_copper_golem_statue": "Тӗксӗмленнӗ пӑхӑр голем кӗлетки",
  "block.minecraft.exposed_copper_grate": "Тӗксӗмленнӗ пӑхӑр чӗнтӗр",
  "block.minecraft.exposed_copper_lantern": "Тӗксӗмленнӗ пӑхӑр хунар",
  "block.minecraft.exposed_copper_trapdoor": "Тӗксӗмленнӗ пӑхӑр люк",
  "block.minecraft.exposed_cut_copper": "Тӗксӗмленнӗ каснӑ пӑхӑр",
  "block.minecraft.exposed_cut_copper_slab": "Тӗксӗмленнӗ каснӑ пӑхӑр плита",
  "block.minecraft.exposed_cut_copper_stairs": "Тӗксӗмленнӗ каснӑ пӑхӑр картлашка",
  "block.minecraft.exposed_lightning_rod": "Тӗксӗмленнӗ ҫиҫӗм сирӳҫи",
  "block.minecraft.farmland": "Ана",
  "block.minecraft.fern": "Упа сарри",
  "block.minecraft.fire": "Ҫулӑм",
  "block.minecraft.fire_coral": "Вут мерчен",
  "block.minecraft.fire_coral_block": "Вут мерчен блок",
  "block.minecraft.fire_coral_fan": "Веерле вут мерчен",
  "block.minecraft.fire_coral_wall_fan": "Хӳмери веерле вут мерчен",
  "block.minecraft.firefly_bush": "Ҫутӑ хуртлӑ тӗмӗ",
  "block.minecraft.fletching_table": "Ухӑҫӑ сӗтелӗ",
  "block.minecraft.flower_pot": "Чечек чӳлмекӗ",
  "block.minecraft.flowering_azalea": "Чечек кӑларан азали",
  "block.minecraft.flowering_azalea_leaves": "Чечек кӑларан азали ҫулҫи",
  "block.minecraft.frogspawn": "Шапа вӑлчи",
  "block.minecraft.frosted_ice": "Сӗлкӗш пӑр",
  "block.minecraft.furnace": "Кӑмака",
  "block.minecraft.gilded_blackstone": "Ылтӑнланӑ хура чул",
  "block.minecraft.glass": "Кантӑк",
  "block.minecraft.glass_pane": "Ҫӳхе кантӑк",
  "block.minecraft.glow_lichen": "Ҫутӑ мӑк",
  "block.minecraft.glowstone": "Ҫутӑ чул",
  "block.minecraft.gold_block": "Ылтӑн блок",
  "block.minecraft.gold_ore": "Ылтӑн тӑпри",
  "block.minecraft.golden_dandelion": "Ылтӑн кукша пуҫ",
  "block.minecraft.granite": "Гранит",
  "block.minecraft.granite_slab": "Гранит плита",
  "block.minecraft.granite_stairs": "Гранит картлашка",
  "block.minecraft.granite_wall": "Гранит карта",
  "block.minecraft.grass": "Курӑк",
  "block.minecraft.grass_block": "Ҫерем",
  "block.minecraft.gravel": "Вӗтӗ чул",
  "block.minecraft.gray_banner": "Сăрă ялав",
  "block.minecraft.gray_bed": "Сӑрӑ кравать",
  "block.minecraft.gray_candle": "Сӑрӑ ҫурта",
  "block.minecraft.gray_candle_cake": "Сӑрӑ ҫурталлӑ торт",
  "block.minecraft.gray_carpet": "Сӑрӑ кавир",
  "block.minecraft.gray_concrete": "Сӑрӑ бетон",
  "block.minecraft.gray_concrete_powder": "Сăрă типĕ бетон",
  "block.minecraft.gray_glazed_terracotta": "Сӑрӑ глазурьленӗ керамика",
  "block.minecraft.gray_shulker_box": "Сӑрӑ шалкер арчи",
  "block.minecraft.gray_stained_glass": "Сӑрӑ кантӑк",
  "block.minecraft.gray_stained_glass_pane": "Сӑрӑ ҫӳхе кантӑк",
  "block.minecraft.gray_terracotta": "Сӑрӑ керамика",
  "block.minecraft.gray_wool": "Сӑрӑ ҫӑм",
  "block.minecraft.green_banner": "Симӗс ялав",
  "block.minecraft.green_bed": "Симӗс кравать",
  "block.minecraft.green_candle": "Симӗс ҫурта",
  "block.minecraft.green_candle_cake": "Симӗс ҫурталлӑ торт",
  "block.minecraft.green_carpet": "Симӗс кавир",
  "block.minecraft.green_concrete": "Симӗс бетон",
  "block.minecraft.green_concrete_powder": "Симĕс типĕ бетон",
  "block.minecraft.green_glazed_terracotta": "Симӗс глазурьленӗ керамика",
  "block.minecraft.green_shulker_box": "Симӗс шалкер арчи",
  "block.minecraft.green_stained_glass": "Симӗс кантӑк",
  "block.minecraft.green_stained_glass_pane": "Симӗс ҫӳхе кантӑк",
  "block.minecraft.green_terracotta": "Симӗс керамика",
  "block.minecraft.green_wool": "Симӗс ҫӑм",
  "block.minecraft.grindstone": "Хӑйра",
  "block.minecraft.hanging_roots": "Усӑнса тӑран тымар",
  "block.minecraft.hay_block": "Утӑ кӗлти",
  "block.minecraft.heavy_core": "Йывӑр тӑршӑ",
  "block.minecraft.heavy_weighted_pressure_plate": "Йывӑррӑн пусмалли плита",
  "block.minecraft.honey_block": "Пыл блок",
  "block.minecraft.honeycomb_block": "Карас блок",
  "block.minecraft.hopper": "Варинкке",
  "block.minecraft.horn_coral": "Мӑйрака мерчен",
  "block.minecraft.horn_coral_block": "Мӑйрака мерчен блок",
  "block.minecraft.horn_coral_fan": "Веерле мӑйрака мерчен",
  "block.minecraft.horn_coral_wall_fan": "Хӳмери веерле мӑйрака мерчен",
  "block.minecraft.ice": "Пӑр",
  "block.minecraft.infested_chiseled_stone_bricks": "Наркӑмӑшланнӑ хӑйранӑ чул кирпӗч",
  "block.minecraft.infested_cobblestone": "Наркӑмӑшланнӑ чӑмӑр чул",
  "block.minecraft.infested_cracked_stone_bricks": "Наркӑмӑшланнӑ ҫуркаланнӑ чул кирпӗч",
  "block.minecraft.infested_deepslate": "Наркӑмӑшланнӑ тарӑн сий чул",
  "block.minecraft.infested_mossy_stone_bricks": "Наркӑмӑшланнӑ мӑклӑ чул кирпӗч",
  "block.minecraft.infested_stone": "Наркӑмӑшланнӑ чул",
  "block.minecraft.infested_stone_bricks": "Наркӑмӑшланнӑ чул кирпӗч",
  "block.minecraft.iron_bars": "Тимĕр хулӑ",
  "block.minecraft.iron_block": "Тимӗр блок",
  "block.minecraft.iron_chain": "Тимӗр сӑнчӑр",
  "block.minecraft.iron_door": "Тимӗр алӑк",
  "block.minecraft.iron_ore": "Тимӗр тӑпри",
  "block.minecraft.iron_trapdoor": "Тимӗр люк",
  "block.minecraft.jack_o_lantern": "Кавӑн хунарӗ",
  "block.minecraft.jigsaw": "Пазл блокӗ",
  "block.minecraft.jukebox": "Калаттаркӑч",
  "block.minecraft.jungle_button": "Тропик йывӑҫ пускӑч",
  "block.minecraft.jungle_door": "Тропик йывӑҫ алӑк",
  "block.minecraft.jungle_fence": "Тропик йывӑҫ карта",
  "block.minecraft.jungle_fence_gate": "Тропик йывӑҫ калинкке",
  "block.minecraft.jungle_hanging_sign": "Тропик йывӑҫ ҫакмалли паллӑ",
  "block.minecraft.jungle_leaves": "Тропик йывӑҫ ҫулҫи",
  "block.minecraft.jungle_log": "Тропик йывӑҫ пӗрене",
  "block.minecraft.jungle_planks": "Тропик йывӑҫ хӑма",
  "block.minecraft.jungle_pressure_plate": "Тропик йывӑҫ пусмалли плита",
  "block.minecraft.jungle_sapling": "Тропик йывӑҫ хунавӗ",
  "block.minecraft.jungle_shelf": "Тропик йывӑҫ ҫӳлӗк",
  "block.minecraft.jungle_sign": "Тропик йывӑҫ паллӑ",
  "block.minecraft.jungle_slab": "Тропик йывӑҫ плита",
  "block.minecraft.jungle_stairs": "Тропик йывӑҫ картлашка",
  "block.minecraft.jungle_trapdoor": "Тропик йывӑҫ люк",
  "block.minecraft.jungle_wall_hanging_sign": "Хӳмери тропик йывӑҫ ҫакмалли паллӑ",
  "block.minecraft.jungle_wall_sign": "Хӳмӗри тропик йывӑҫ паллӑ",
  "block.minecraft.jungle_wood": "Тропик йывӑҫ йывӑҫ",
  "block.minecraft.kelp": "Ламинари",
  "block.minecraft.kelp_plant": "Ламинари туни",
  "block.minecraft.ladder": "Пусма",
  "block.minecraft.lantern": "Хунар",
  "block.minecraft.lapis_block": "Лазурит блок",
  "block.minecraft.lapis_ore": "Лазурит тӑпри",
  "block.minecraft.large_amethyst_bud": "Мӑн аметист папки",
  "block.minecraft.large_fern": "Мӑн упа сарри",
  "block.minecraft.lava": "Лава",
  "block.minecraft.lava_cauldron": "Лава хуранӗ",
  "block.minecraft.leaf_litter": "Типнӗ ҫулҫă",
  "block.minecraft.lectern": "Кафедра",
  "block.minecraft.lever": "Кӳсек",
  "block.minecraft.light": "Ҫутӑ",
  "block.minecraft.light_blue_banner": "Сенкер ялав",
  "block.minecraft.light_blue_bed": "Сенкер кравать",
  "block.minecraft.light_blue_candle": "Сенкер ҫурта",
  "block.minecraft.light_blue_candle_cake": "Сенкер ҫурталлӑ торт",
  "block.minecraft.light_blue_carpet": "Сенкер кавир",
  "block.minecraft.light_blue_concrete": "Сенкер бетон",
  "block.minecraft.light_blue_concrete_powder": "Сенкер типĕ бетон",
  "block.minecraft.light_blue_glazed_terracotta": "Сенкер глазурьленӗ керамика",
  "block.minecraft.light_blue_shulker_box": "Сенкер шалкер арчи",
  "block.minecraft.light_blue_stained_glass": "Сенкер кантӑк",
  "block.minecraft.light_blue_stained_glass_pane": "Сенкер ҫӳхе кантӑк",
  "block.minecraft.light_blue_terracotta": "Сенкер керамика",
  "block.minecraft.light_blue_wool": "Сенкер ҫӑм",
  "block.minecraft.light_gray_banner": "Ҫутӑ сӑрӑ ялав",
  "block.minecraft.light_gray_bed": "Ҫутӑ сӑрӑ кравать",
  "block.minecraft.light_gray_candle": "Ҫутӑ сӑрӑ ҫурта",
  "block.minecraft.light_gray_candle_cake": "Ҫутӑ сӑрӑ ҫурталлӑ торт",
  "block.minecraft.light_gray_carpet": "Ҫутӑ сӑрӑ кавир",
  "block.minecraft.light_gray_concrete": "Ҫутӑ сӑрӑ бетон",
  "block.minecraft.light_gray_concrete_powder": "Ҫутӑ сӑрӑ типĕ бетон",
  "block.minecraft.light_gray_glazed_terracotta": "Ҫутӑ сӑрӑ глазурьленӗ керамика",
  "block.minecraft.light_gray_shulker_box": "Ҫутӑ сӑрӑ шалкер арчи",
  "block.minecraft.light_gray_stained_glass": "Ҫутӑ сӑрӑ кантӑк",
  "block.minecraft.light_gray_stained_glass_pane": "Ҫутӑ сӑрӑ ҫӳхе кантӑк",
  "block.minecraft.light_gray_terracotta": "Ҫутă сăрă керамика",
  "block.minecraft.light_gray_wool": "Ҫутӑ сӑрӑ ҫӑм",
  "block.minecraft.light_weighted_pressure_plate": "Ҫӑмӑллӑн пусмалли плита",
  "block.minecraft.lightning_rod": "Ҫиҫӗм сирӳҫи",
  "block.minecraft.lilac": "Сирень",
  "block.minecraft.lily_of_the_valley": "Мулкач хӑлхи",
  "block.minecraft.lily_pad": "Кӳкӗрчен",
  "block.minecraft.lime_banner": "Сарӑ симӗс ялав",
  "block.minecraft.lime_bed": "Сарӑ симӗс кровать",
  "block.minecraft.lime_candle": "Сарӑ симӗс ҫурта",
  "block.minecraft.lime_candle_cake": "Сарӑ симӗс ҫурталлӑ торт",
  "block.minecraft.lime_carpet": "Сарӑ симӗс кавир",
  "block.minecraft.lime_concrete": "Сарӑ симӗс бетон",
  "block.minecraft.lime_concrete_powder": "Сарă симĕс типĕ бетон",
  "block.minecraft.lime_glazed_terracotta": "Сарӑ симӗс глазурьленӗ керамика",
  "block.minecraft.lime_shulker_box": "Сарӑ симӗс шалкер арчи",
  "block.minecraft.lime_stained_glass": "Сарӑ симӗс кантӑк",
  "block.minecraft.lime_stained_glass_pane": "Сарӑ симӗс ҫӳхе кантӑк",
  "block.minecraft.lime_terracotta": "Сарӑ симӗс керамика",
  "block.minecraft.lime_wool": "Сарӑ симӗс ҫӑм",
  "block.minecraft.lodestone": "Магнетит",
  "block.minecraft.loom": "Пир станӗ",
  "block.minecraft.magenta_banner": "Хӗрлӗ кӗрен ялав",
  "block.minecraft.magenta_bed": "Хӗрлӗ кӗрен кравать",
  "block.minecraft.magenta_candle": "Хӗрлӗ кӗрен ҫурта",
  "block.minecraft.magenta_candle_cake": "Хӗрлӗ кӗрен ҫурталлӑ торт",
  "block.minecraft.magenta_carpet": "Хӗрлӗ кӗрен кавир",
  "block.minecraft.magenta_concrete": "Хӗрлӗ кӗрен бетон",
  "block.minecraft.magenta_concrete_powder": "Хĕрлӗ кĕрен типĕ бетон",
  "block.minecraft.magenta_glazed_terracotta": "Хӗрлӗ кӗрен глазурьленӗ керамика",
  "block.minecraft.magenta_shulker_box": "Хӗрлӗ кӗрен шалкер арчи",
  "block.minecraft.magenta_stained_glass": "Хӗрлӗ кӗрен кантӑк",
  "block.minecraft.magenta_stained_glass_pane": "Хӗрлӗ кӗрен ҫӳхе кантӑк",
  "block.minecraft.magenta_terracotta": "Хӗрлӗ кӗрен керамика",
  "block.minecraft.magenta_wool": "Хӗрлӗ кӗрен ҫӑм",
  "block.minecraft.magma_block": "Магма",
  "block.minecraft.mangrove_button": "Мангр пускӑч",
  "block.minecraft.mangrove_door": "Мангр алӑк",
  "block.minecraft.mangrove_fence": "Мангр карта",
  "block.minecraft.mangrove_fence_gate": "Мангр калинкке",
  "block.minecraft.mangrove_hanging_sign": "Мангр ҫакмалли паллӑ",
  "block.minecraft.mangrove_leaves": "Мангр ҫулҫи",
  "block.minecraft.mangrove_log": "Мангр пӗрене",
  "block.minecraft.mangrove_planks": "Мангр хӑма",
  "block.minecraft.mangrove_pressure_plate": "Мангр пусмалли плита",
  "block.minecraft.mangrove_propagule": "Мангр хунавӗ",
  "block.minecraft.mangrove_roots": "Мангр тымарӗ",
  "block.minecraft.mangrove_shelf": "Мангр ҫӳлӗк",
  "block.minecraft.mangrove_sign": "Мангр паллӑ",
  "block.minecraft.mangrove_slab": "Мангр плита",
  "block.minecraft.mangrove_stairs": "Мангр картлашка",
  "block.minecraft.mangrove_trapdoor": "Мангр люк",
  "block.minecraft.mangrove_wall_hanging_sign": "Хӳмери мангр ҫакмалли паллӑ",
  "block.minecraft.mangrove_wall_sign": "Хӳмӗри мангр паллӑ",
  "block.minecraft.mangrove_wood": "Мангр йывӑҫ",
  "block.minecraft.medium_amethyst_bud": "Вӑта аметист папки",
  "block.minecraft.melon": "Арпус",
  "block.minecraft.melon_stem": "Арпус туни",
  "block.minecraft.moss_block": "Мӑк блок",
  "block.minecraft.moss_carpet": "Мӑк кавир",
  "block.minecraft.mossy_cobblestone": "Мӑклӑ чӑмӑр чул",
  "block.minecraft.mossy_cobblestone_slab": "Мӑклӑ чӑмӑр чул плита",
  "block.minecraft.mossy_cobblestone_stairs": "Мӑклӑ чӑмӑр чул картлашка",
  "block.minecraft.mossy_cobblestone_wall": "Мӑклӑ чӑмӑр чул карта",
  "block.minecraft.mossy_stone_brick_slab": "Мӑклӑ чул кирпӗч плита",
  "block.minecraft.mossy_stone_brick_stairs": "Мӑклӑ чул кирпӗч картлашка",
  "block.minecraft.mossy_stone_brick_wall": "Мӑклӑ чул кирпӗч карта",
  "block.minecraft.mossy_stone_bricks": "Мӑклӑ чул кирпӗч",
  "block.minecraft.moving_piston": "Куҫкалакан хурсӑ",
  "block.minecraft.mud": "Пылчӑк",
  "block.minecraft.mud_brick_slab": "Саман кирпӗч плита",
  "block.minecraft.mud_brick_stairs": "Саман кирпӗч картлашка",
  "block.minecraft.mud_brick_wall": "Саман кирпӗч карта",
  "block.minecraft.mud_bricks": "Саман кирпӗч",
  "block.minecraft.muddy_mangrove_roots": "Пылчӑклӑ мангр тымарӗ",
  "block.minecraft.mushroom_stem": "Кăмпа туни",
  "block.minecraft.mycelium": "Кӑмпа тымарӗ",
  "block.minecraft.nether_brick_fence": "Незер кирпӗч карта",
  "block.minecraft.nether_brick_slab": "Незер кирпӗч плита",
  "block.minecraft.nether_brick_stairs": "Незер кирпӗч картлашка",
  "block.minecraft.nether_brick_wall": "Незер кирпӗч карта",
  "block.minecraft.nether_bricks": "Незер кирпӗч",
  "block.minecraft.nether_gold_ore": "Незер ылтӑн тӑпри",
  "block.minecraft.nether_portal": "Незер порталӗ",
  "block.minecraft.nether_quartz_ore": "Незер кварцӗ тăпри",
  "block.minecraft.nether_sprouts": "Незер хунавӗ",
  "block.minecraft.nether_wart": "Незер мӑкӑлӗ",
  "block.minecraft.nether_wart_block": "Незер мӑкӑлӗ блок",
  "block.minecraft.netherite_block": "Незерит блок",
  "block.minecraft.netherrack": "Незерак",
  "block.minecraft.note_block": "Нота блокӗ",
  "block.minecraft.oak_button": "Юман пускӑч",
  "block.minecraft.oak_door": "Юман алӑк",
  "block.minecraft.oak_fence": "Юман карта",
  "block.minecraft.oak_fence_gate": "Юман калинкке",
  "block.minecraft.oak_hanging_sign": "Юман ҫакмалли паллӑ",
  "block.minecraft.oak_leaves": "Юман ҫулҫи",
  "block.minecraft.oak_log": "Юман пӗрене",
  "block.minecraft.oak_planks": "Юман хӑма",
  "block.minecraft.oak_pressure_plate": "Юман пусмалли плита",
  "block.minecraft.oak_sapling": "Юман хунавӗ",
  "block.minecraft.oak_shelf": "Юман ҫӳлӗк",
  "block.minecraft.oak_sign": "Юман паллӑ",
  "block.minecraft.oak_slab": "Юман плита",
  "block.minecraft.oak_stairs": "Юман картлашка",
  "block.minecraft.oak_trapdoor": "Юман люк",
  "block.minecraft.oak_wall_hanging_sign": "Хӳмери юман ҫакмалли паллӑ",
  "block.minecraft.oak_wall_sign": "Хӳмери юман паллӑ",
  "block.minecraft.oak_wood": "Юман йывӑҫ",
  "block.minecraft.observer": "Сӑнакӑч",
  "block.minecraft.obsidian": "Обсидиан",
  "block.minecraft.ochre_froglight": "Охра шапа ҫути",
  "block.minecraft.ominous_banner": "Хӑрушӑ ялав",
  "block.minecraft.open_eyeblossom": "Уҫӑ куҫ чечек",
  "block.minecraft.orange_banner": "Хĕрлĕ сарă ялав",
  "block.minecraft.orange_bed": "Хӗрлӗ сарӑ кравать",
  "block.minecraft.orange_candle": "Хӗрлӗ сарӑ ҫурта",
  "block.minecraft.orange_candle_cake": "Хӗрлӗ сарӑ ҫурталлӑ тăрт",
  "block.minecraft.orange_carpet": "Хӗрлӗ сарӑ кавир",
  "block.minecraft.orange_concrete": "Хӗрлӗ сарӑ бетон",
  "block.minecraft.orange_concrete_powder": "Хĕрлӗ сарă типĕ бетон",
  "block.minecraft.orange_glazed_terracotta": "Хӗрлӗ сарӑ глазурьленӗ керамика",
  "block.minecraft.orange_shulker_box": "Хӗрлӗ сарӑ шалкер арчи",
  "block.minecraft.orange_stained_glass": "Хӗрлӗ сарӑ кантӑк",
  "block.minecraft.orange_stained_glass_pane": "Хӗрлӗ сарӑ ҫӳхе кантӑк",
  "block.minecraft.orange_terracotta": "Хӗрлӗ сарӑ керамика",
  "block.minecraft.orange_tulip": "Хӗрлӗ сарӑ тюльпан",
  "block.minecraft.orange_wool": "Хӗрлӗ сарӑ ҫӑм",
  "block.minecraft.oxeye_daisy": "Салтак тӳми",
  "block.minecraft.oxidized_chiseled_copper": "Йӳҫекленнӗ хӑйранӑ пӑхӑр",
  "block.minecraft.oxidized_copper": "Йӳҫекленнӗ пӑхӑр",
  "block.minecraft.oxidized_copper_bars": "Йӳҫекленнӗ пӑхӑр хулӑ",
  "block.minecraft.oxidized_copper_bulb": "Йӳҫекленнӗ пӑхӑр хунар",
  "block.minecraft.oxidized_copper_chain": "Йӳҫекленнӗ пӑхӑр сӑнчӑр",
  "block.minecraft.oxidized_copper_chest": "Йӳҫекленнӗ пӑхӑр арча",
  "block.minecraft.oxidized_copper_door": "Йӳҫекленнӗ пӑхӑр алӑк",
  "block.minecraft.oxidized_copper_golem_statue": "Йӳҫекленнӗ пӑхӑр голем кӗлетки",
  "block.minecraft.oxidized_copper_grate": "Йӳҫекленнӗ пӑхӑр чӗнтӗр",
  "block.minecraft.oxidized_copper_lantern": "Йӳҫекленнӗ пӑхӑр хунар",
  "block.minecraft.oxidized_copper_trapdoor": "Йӳҫекленнӗ пӑхӑр люк",
  "block.minecraft.oxidized_cut_copper": "Йӳҫекленнӗ каснӑ пӑхӑр",
  "block.minecraft.oxidized_cut_copper_slab": "Йӳҫекленнӗ каснӑ пӑхӑр плита",
  "block.minecraft.oxidized_cut_copper_stairs": "Йӳҫекленнӗ каснӑ пӑхӑр картлашка",
  "block.minecraft.oxidized_lightning_rod": "Йӳҫекленнӗ ҫиҫӗм сирӳҫи",
  "block.minecraft.packed_ice": "Хулӑн пӑр",
  "block.minecraft.packed_mud": "Саман",
  "block.minecraft.pale_hanging_moss": "Ҫакма шуранка мӑк",
  "block.minecraft.pale_moss_block": "Шуранка мӑк блок",
  "block.minecraft.pale_moss_carpet": "Шуранка мӑк кавир",
  "block.minecraft.pale_oak_button": "Шуранка юман пускӑч",
  "block.minecraft.pale_oak_door": "Шуранка юман алӑк",
  "block.minecraft.pale_oak_fence": "Шуранка юман карта",
  "block.minecraft.pale_oak_fence_gate": "Шуранка юман калинкке",
  "block.minecraft.pale_oak_hanging_sign": "Шуранка юман ҫакмалли паллӑ",
  "block.minecraft.pale_oak_leaves": "Шуранка юман ҫулҫи",
  "block.minecraft.pale_oak_log": "Шуранка юман пӗрене",
  "block.minecraft.pale_oak_planks": "Шуранка юман хӑма",
  "block.minecraft.pale_oak_pressure_plate": "Шуранка юман пусмалли плита",
  "block.minecraft.pale_oak_sapling": "Шуранка юман хунавӗ",
  "block.minecraft.pale_oak_shelf": "Шуранка юман ҫӳлӗк",
  "block.minecraft.pale_oak_sign": "Шуранка юман паллӑ",
  "block.minecraft.pale_oak_slab": "Шуранка юман плита",
  "block.minecraft.pale_oak_stairs": "Шуранка юман картлашка",
  "block.minecraft.pale_oak_trapdoor": "Шуранка юман люк",
  "block.minecraft.pale_oak_wall_hanging_sign": "Хӳмери шуранка юман ҫакмалли паллӑ",
  "block.minecraft.pale_oak_wall_sign": "Хӳмери шуранка юман паллӑ",
  "block.minecraft.pale_oak_wood": "Шуранка юман",
  "block.minecraft.pearlescent_froglight": "Ӗнчӗ шапа ҫути",
  "block.minecraft.peony": "Пион",
  "block.minecraft.petrified_oak_slab": "Чулланнӑ юман плита",
  "block.minecraft.piglin_head": "Пиглин пуҫӗ",
  "block.minecraft.piglin_wall_head": "Хӳмери пиглин пуҫӗ",
  "block.minecraft.pink_banner": "Кĕрен ялав",
  "block.minecraft.pink_bed": "Кӗрен кравать",
  "block.minecraft.pink_candle": "Кӗрен ҫурта",
  "block.minecraft.pink_candle_cake": "Кӗрен ҫурталлӑ торт",
  "block.minecraft.pink_carpet": "Кӗрен кавир",
  "block.minecraft.pink_concrete": "Кӗрен бетон",
  "block.minecraft.pink_concrete_powder": "Кĕрен типĕ бетон",
  "block.minecraft.pink_glazed_terracotta": "Кӗрен глазурьленӗ керамика",
  "block.minecraft.pink_petals": "Кӗрен ҫеҫке",
  "block.minecraft.pink_shulker_box": "Кӗрен шалкер арчи",
  "block.minecraft.pink_stained_glass": "Кӗрен кантӑк",
  "block.minecraft.pink_stained_glass_pane": "Кӗрен ҫӳхе кантӑк",
  "block.minecraft.pink_terracotta": "Кӗрен керамика",
  "block.minecraft.pink_tulip": "Кӗрен тюльпан",
  "block.minecraft.pink_wool": "Кӗрен ҫӑм",
  "block.minecraft.piston": "Хурсӑ",
  "block.minecraft.piston_head": "Хурсӑ пуҫӗ",
  "block.minecraft.pitcher_crop": "Кӑкшӑм курӑкӗ хунавӗ",
  "block.minecraft.pitcher_plant": "Кӑкшӑм курӑкӗ",
  "block.minecraft.player_head": "Вӑйӑҫӑ пуҫӗ",
  "block.minecraft.player_head.named": "%s пуҫӗ",
  "block.minecraft.player_wall_head": "Хӳмери вӑйӑҫӑ пуҫӗ",
  "block.minecraft.podzol": "Вӑрман тӑпри",
  "block.minecraft.pointed_dripstone": "Шӗвӗр тармак",
  "block.minecraft.polished_andesite": "Якатнӑ андезит",
  "block.minecraft.polished_andesite_slab": "Якатнӑ андезит плита",
  "block.minecraft.polished_andesite_stairs": "Якатнӑ андезит картлашка",
  "block.minecraft.polished_basalt": "Якатнӑ базальт",
  "block.minecraft.polished_blackstone": "Якатнӑ хура чул",
  "block.minecraft.polished_blackstone_brick_slab": "Якатнӑ хура чул кирпӗч плита",
  "block.minecraft.polished_blackstone_brick_stairs": "Якатнӑ хура чул кирпӗч картлашка",
  "block.minecraft.polished_blackstone_brick_wall": "Якатнӑ хура чул кирпӗч карта",
  "block.minecraft.polished_blackstone_bricks": "Якатнӑ хура чул кирпӗч",
  "block.minecraft.polished_blackstone_button": "Якатнӑ хура чул пускӑч",
  "block.minecraft.polished_blackstone_pressure_plate": "Якатнӑ хура чул пусмалли плита",
  "block.minecraft.polished_blackstone_slab": "Якатнӑ хура чул плита",
  "block.minecraft.polished_blackstone_stairs": "Якатнӑ хура чул картлашка",
  "block.minecraft.polished_blackstone_wall": "Якатнӑ хура чул карта",
  "block.minecraft.polished_deepslate": "Якатнӑ тарӑн сий чул",
  "block.minecraft.polished_deepslate_slab": "Якатнӑ тарӑн сий чул плита",
  "block.minecraft.polished_deepslate_stairs": "Якатнӑ тарӑн сий чул картлашка",
  "block.minecraft.polished_deepslate_wall": "Якатнӑ тарӑн сий чул карта",
  "block.minecraft.polished_diorite": "Якатнӑ диорит",
  "block.minecraft.polished_diorite_slab": "Якатнӑ диорит плита",
  "block.minecraft.polished_diorite_stairs": "Якатнӑ диорит картлашка",
  "block.minecraft.polished_granite": "Якатнӑ гранит",
  "block.minecraft.polished_granite_slab": "Якатнӑ гранит плита",
  "block.minecraft.polished_granite_stairs": "Якатнӑ гранит картлашка",
  "block.minecraft.polished_tuff": "Якатнӑ туф",
  "block.minecraft.polished_tuff_slab": "Якатнӑ туф плита",
  "block.minecraft.polished_tuff_stairs": "Якатнӑ туф картлашка",
  "block.minecraft.polished_tuff_wall": "Якатнӑ туф карта",
  "block.minecraft.poppy": "Мӑкӑнь",
  "block.minecraft.potatoes": "Ҫӗр улми",
  "block.minecraft.potted_acacia_sapling": "Чӳлмекри акаци хунавӗ",
  "block.minecraft.potted_allium": "Чӳлмекри сухан",
  "block.minecraft.potted_azalea_bush": "Чӳлмекри азали",
  "block.minecraft.potted_azure_bluet": "Чӳлмекри хаустони",
  "block.minecraft.potted_bamboo": "Чӳлмекри бамбук",
  "block.minecraft.potted_birch_sapling": "Чӳлмекри хурӑн хунавӗ",
  "block.minecraft.potted_blue_orchid": "Чӳлмекри кӑвак орхидея",
  "block.minecraft.potted_brown_mushroom": "Чӳлмекри хӑмӑр кӑмпа",
  "block.minecraft.potted_cactus": "Чӳлмекри кактус",
  "block.minecraft.potted_cherry_sapling": "Чӳлмекри чие хунавӗ",
  "block.minecraft.potted_closed_eyeblossom": "Чӳлмекри хупӑ куҫ чечек",
  "block.minecraft.potted_cornflower": "Чӳлмекри кӑвак утмӑл турат",
  "block.minecraft.potted_crimson_fungus": "Чӳлмекри хӗмлӗ кӑмпа",
  "block.minecraft.potted_crimson_roots": "Чӳлмекри хӗмлӗ тымар",
  "block.minecraft.potted_dandelion": "Чӳлмекри кукша пуҫ",
  "block.minecraft.potted_dark_oak_sapling": "Чӳлмекри тӗттӗм юман хунавӗ",
  "block.minecraft.potted_dead_bush": "Чӳлмекри хӑрӑк тӗмӗ",
  "block.minecraft.potted_fern": "Чӳлмекри упа сарри",
  "block.minecraft.potted_flowering_azalea_bush": "Чӳлмекри чечек кӑларан азали",
  "block.minecraft.potted_golden_dandelion": "Чӳлмекри ылтӑн кукша пуҫ",
  "block.minecraft.potted_jungle_sapling": "Чӳлмекри тропик йывӑҫ хунавӗ",
  "block.minecraft.potted_lily_of_the_valley": "Чӳлмекри мулкач хӑлхи",
  "block.minecraft.potted_mangrove_propagule": "Чӳлмекри мангр хунавӗ",
  "block.minecraft.potted_oak_sapling": "Чӳлмекри юман хунавӗ",
  "block.minecraft.potted_open_eyeblossom": "Чӳлмекри уҫӑ куҫ чечек",
  "block.minecraft.potted_orange_tulip": "Чӳлмекри хӗрлӗ сарӑ тюльпан",
  "block.minecraft.potted_oxeye_daisy": "Чӳлмекри салтак тӳми",
  "block.minecraft.potted_pale_oak_sapling": "Чӳлмекри шуранка юман хунавӗ",
  "block.minecraft.potted_pink_tulip": "Чӳлмекри кӗрен тюльпан",
  "block.minecraft.potted_poppy": "Чӳлмекри мӑкӑнь",
  "block.minecraft.potted_red_mushroom": "Чӳлмекри хӗрлӗ кӑмпа",
  "block.minecraft.potted_red_tulip": "Чӳлмекри хӗрлӗ тюльпан",
  "block.minecraft.potted_spruce_sapling": "Чӳлмекри чӑрӑш хунавӗ",
  "block.minecraft.potted_torchflower": "Чӳлмекри ҫункӑҫ чечек",
  "block.minecraft.potted_warped_fungus": "Чӳлмекри пӑсӑк кӑмпа",
  "block.minecraft.potted_warped_roots": "Чӳлмекри пӑсӑк тымар",
  "block.minecraft.potted_white_tulip": "Чӳлмекри шурӑ тюльпан",
  "block.minecraft.potted_wither_rose": "Чӳлмекри визер кӗл чечек",
  "block.minecraft.powder_snow": "Кӑпӑш юр",
  "block.minecraft.powder_snow_cauldron": "Кӑпӑш юр хуранӗ",
  "block.minecraft.powered_rail": "Энергиллӗ рельс",
  "block.minecraft.prismarine": "Призмарин",
  "block.minecraft.prismarine_brick_slab": "Призмарин кирпӗч плита",
  "block.minecraft.prismarine_brick_stairs": "Призмарин кирпӗч картлашка",
  "block.minecraft.prismarine_bricks": "Призмарин кирпӗч",
  "block.minecraft.prismarine_slab": "Призмарин плита",
  "block.minecraft.prismarine_stairs": "Призмарин картлашка",
  "block.minecraft.prismarine_wall": "Призмарин карта",
  "block.minecraft.pumpkin": "Кавăн",
  "block.minecraft.pumpkin_stem": "Кавăн туни",
  "block.minecraft.purple_banner": "Хĕрлĕ кăвак ялав",
  "block.minecraft.purple_bed": "Хӗрлӗ кӑвак кравать",
  "block.minecraft.purple_candle": "Хӗрлӗ кӑвак ҫурта",
  "block.minecraft.purple_candle_cake": "Хĕрлĕ кăвак ҫурталлӑ торт",
  "block.minecraft.purple_carpet": "Хӗрлӗ кӑвак кавир",
  "block.minecraft.purple_concrete": "Хӗрлӗ кӑвак бетон",
  "block.minecraft.purple_concrete_powder": "Хĕрлӗ кăвак типĕ бетон",
  "block.minecraft.purple_glazed_terracotta": "Хӗрлӗ кӑвак глазурьленӗ керамика",
  "block.minecraft.purple_shulker_box": "Хӗрлӗ кӑвак шалкер арчи",
  "block.minecraft.purple_stained_glass": "Хӗрлӗ кӑвак кантӑк",
  "block.minecraft.purple_stained_glass_pane": "Хӗрлӗ кӑвак ҫӳхе кантӑк",
  "block.minecraft.purple_terracotta": "Хӗрлӗ кӑвак керамика",
  "block.minecraft.purple_wool": "Хӗрлӗ кӑвак ҫӑм",
  "block.minecraft.purpur_block": "Пурпур",
  "block.minecraft.purpur_pillar": "Пурпур юпа",
  "block.minecraft.purpur_slab": "Пурпур плита",
  "block.minecraft.purpur_stairs": "Пурпур картлашка",
  "block.minecraft.quartz_block": "Кварц блок",
  "block.minecraft.quartz_bricks": "Кварц кирпӗч",
  "block.minecraft.quartz_pillar": "Кварц юпа",
  "block.minecraft.quartz_slab": "Кварц плита",
  "block.minecraft.quartz_stairs": "Кварц картлашка",
  "block.minecraft.rail": "Рельс",
  "block.minecraft.raw_copper_block": "Чӗрӗ пӑхӑр блок",
  "block.minecraft.raw_gold_block": "Чӗрӗ ылтӑн блок",
  "block.minecraft.raw_iron_block": "Чӗрӗ тимӗр блок",
  "block.minecraft.red_banner": "Хӗрлӗ ялав",
  "block.minecraft.red_bed": "Хӗрлӗ кравать",
  "block.minecraft.red_candle": "Хӗрлӗ ҫурта",
  "block.minecraft.red_candle_cake": "Хĕрлĕ ҫурталлӑ торт",
  "block.minecraft.red_carpet": "Хӗрлӗ кавир",
  "block.minecraft.red_concrete": "Хӗрлӗ бетон",
  "block.minecraft.red_concrete_powder": "Хĕрлĕ типĕ бетон",
  "block.minecraft.red_glazed_terracotta": "Хĕрлĕ глазурьленӗ керамика",
  "block.minecraft.red_mushroom": "Хӗрлӗ кӑмпа",
  "block.minecraft.red_mushroom_block": "Хĕрлĕ кăмпа блокӗ",
  "block.minecraft.red_nether_brick_slab": "Хĕрлĕ незер кирпӗч плита",
  "block.minecraft.red_nether_brick_stairs": "Хӗрлӗ незер кирпӗч картлашка",
  "block.minecraft.red_nether_brick_wall": "Хӗрлӗ незер кирпӗч карта",
  "block.minecraft.red_nether_bricks": "Хӗрлӗ незер кирпӗч",
  "block.minecraft.red_sand": "Хӗрлӗ хӑйӑр",
  "block.minecraft.red_sandstone": "Хӗрлӗ хӑйӑр чул",
  "block.minecraft.red_sandstone_slab": "Хӗрлӗ хӑйӑр чул плита",
  "block.minecraft.red_sandstone_stairs": "Хӗрлӗ хӑйӑр чул картлашка",
  "block.minecraft.red_sandstone_wall": "Хӗрлӗ хӑйӑр чул карта",
  "block.minecraft.red_shulker_box": "Хӗрлӗ шалкер арчи",
  "block.minecraft.red_stained_glass": "Хӗрлӗ кантӑк",
  "block.minecraft.red_stained_glass_pane": "Хӗрлӗ ҫӳхе кантӑк",
  "block.minecraft.red_terracotta": "Хӗрлӗ керамика",
  "block.minecraft.red_tulip": "Хӗрлӗ тюльпан",
  "block.minecraft.red_wool": "Хӗрлӗ ҫӑм",
  "block.minecraft.redstone_block": "Редстоун блок",
  "block.minecraft.redstone_lamp": "Редстоун хунар",
  "block.minecraft.redstone_ore": "Редстоун тӑпри",
  "block.minecraft.redstone_torch": "Редстоун ҫункӑҫӗ",
  "block.minecraft.redstone_wall_torch": "Хӳмери редстоун ҫункӑҫӗ",
  "block.minecraft.redstone_wire": "Редстоун пралукӗ",
  "block.minecraft.reinforced_deepslate": "Ҫирӗплетнӗ тарӑн сий чул",
  "block.minecraft.repeater": "Редстоун тӑскӑчӗ",
  "block.minecraft.repeating_command_block": "Тӑсакан команда блокӗ",
  "block.minecraft.resin_block": "Сухӑр блок",
  "block.minecraft.resin_brick_slab": "Сухӑр кирпӗч плита",
  "block.minecraft.resin_brick_stairs": "Сухӑр кирпӗч картлашка",
  "block.minecraft.resin_brick_wall": "Сухӑр кирпӗч карта",
  "block.minecraft.resin_bricks": "Сухӑр кирпӗч",
  "block.minecraft.resin_clump": "Сухӑр муклашки",
  "block.minecraft.respawn_anchor": "Чӗрӗлӳ якорӗ",
  "block.minecraft.rooted_dirt": "Тымарлӑ тӑпра",
  "block.minecraft.rose_bush": "Кӗл чечек тӗмӗ",
  "block.minecraft.sand": "Хӑйӑр",
  "block.minecraft.sandstone": "Хӑйӑр чул",
  "block.minecraft.sandstone_slab": "Хӑйӑр чул плита",
  "block.minecraft.sandstone_stairs": "Хӑйӑр чул картлашка",
  "block.minecraft.sandstone_wall": "Хӑйӑр чул карта",
  "block.minecraft.scaffolding": "Такан",
  "block.minecraft.sculk": "Скалк",
  "block.minecraft.sculk_catalyst": "Скалк катализаторӗ",
  "block.minecraft.sculk_sensor": "Скалк сенсорӗ",
  "block.minecraft.sculk_shrieker": "Скалк кӑшкӑркӑчӗ",
  "block.minecraft.sculk_vein": "Скалк шӑнӑрӗ",
  "block.minecraft.sea_lantern": "Тинӗс хунарӗ",
  "block.minecraft.sea_pickle": "Тинĕс хăярӗ",
  "block.minecraft.seagrass": "Тинӗс курӑкӗ",
  "block.minecraft.set_spawn": "Чӗрӗлӳ вырӑнӗ палӑртнӑ",
  "block.minecraft.short_dry_grass": "Лутра типӗ курӑк",
  "block.minecraft.short_grass": "Лутра курӑк",
  "block.minecraft.shroomlight": "Кӑмпа ҫут",
  "block.minecraft.shulker_box": "Шалкер арчи",
  "block.minecraft.skeleton_skull": "Пуҫ шӑмми",
  "block.minecraft.skeleton_wall_skull": "Хӳмери пуҫ шӑмми",
  "block.minecraft.slime_block": "Лӑйма блок",
  "block.minecraft.small_amethyst_bud": "Пӗчӗк аметист папки",
  "block.minecraft.small_dripleaf": "Пӗчӗк тумлам ҫулҫӑ",
  "block.minecraft.smithing_table": "Тимӗрҫӗ сӗтелӗ",
  "block.minecraft.smoker": "Тӗтӗрмелли кӑмака",
  "block.minecraft.smooth_basalt": "Яка базальт",
  "block.minecraft.smooth_quartz": "Яка кварц блокӗ",
  "block.minecraft.smooth_quartz_slab": "Яка кварц плита",
  "block.minecraft.smooth_quartz_stairs": "Яка кварц картлашка",
  "block.minecraft.smooth_red_sandstone": "Яка хӗрлӗ хӑйӑр чул",
  "block.minecraft.smooth_red_sandstone_slab": "Яка хӗрлӗ хӑйӑр чул плита",
  "block.minecraft.smooth_red_sandstone_stairs": "Яка хӗрлӗ хӑйӑр чул картлашка",
  "block.minecraft.smooth_sandstone": "Яка хӑйӑр чул",
  "block.minecraft.smooth_sandstone_slab": "Яка хӑйӑр чул плита",
  "block.minecraft.smooth_sandstone_stairs": "Яка хӑйӑр чул картлашка",
  "block.minecraft.smooth_stone": "Яка чул",
  "block.minecraft.smooth_stone_slab": "Яка чул плита",
  "block.minecraft.sniffer_egg": "Шӑршлан ҫӑмарти",
  "block.minecraft.snow": "Юр",
  "block.minecraft.snow_block": "Юр блок",
  "block.minecraft.soul_campfire": "Чун кӑвайчӗ",
  "block.minecraft.soul_fire": "Чун вучӗ",
  "block.minecraft.soul_lantern": "Чун хунарӗ",
  "block.minecraft.soul_sand": "Чун хӑйӑрӗ",
  "block.minecraft.soul_soil": "Чун тӑпри",
  "block.minecraft.soul_torch": "Чун ҫункӑҫӗ",
  "block.minecraft.soul_wall_torch": "Хӳмери чун ҫункӑҫӗ",
  "block.minecraft.spawn.not_valid": "Санӑн кравать е авăрланă чӗрӗлӳ якорӗ ҫук, е вӗсем патне ҫул кăткăслатнă",
  "block.minecraft.spawner": "Монстр ҫураткӑчӗ",
  "block.minecraft.spawner.desc1": "Ҫурату ҫӑмартипе хире-хирĕҫ ҫыхăнни:",
  "block.minecraft.spawner.desc2": "Моб тӗсне палӑртать",
  "block.minecraft.sponge": "Губка",
  "block.minecraft.spore_blossom": "Спора чечекӗ",
  "block.minecraft.spruce_button": "Чӑрӑш пускӑч",
  "block.minecraft.spruce_door": "Чӑрӑш алӑк",
  "block.minecraft.spruce_fence": "Чăрăш карта",
  "block.minecraft.spruce_fence_gate": "Чăрăш калинкке",
  "block.minecraft.spruce_hanging_sign": "Чӑрӑш ҫакмалли паллӑ",
  "block.minecraft.spruce_leaves": "Чӑрӑш ҫулҫи",
  "block.minecraft.spruce_log": "Чӑрӑш пӗрене",
  "block.minecraft.spruce_planks": "Чӑрӑш хӑма",
  "block.minecraft.spruce_pressure_plate": "Чăрăш пусмалли плита",
  "block.minecraft.spruce_sapling": "Чӑрӑш хунавӗ",
  "block.minecraft.spruce_shelf": "Чӑрӑш ҫӳлӗк",
  "block.minecraft.spruce_sign": "Чӑрӑш паллӑ",
  "block.minecraft.spruce_slab": "Чӑрӑш плита",
  "block.minecraft.spruce_stairs": "Чӑрӑш картлашка",
  "block.minecraft.spruce_trapdoor": "Чӑрӑш люк",
  "block.minecraft.spruce_wall_hanging_sign": "Хӳмери чӑрӑш ҫакмалли паллӑ",
  "block.minecraft.spruce_wall_sign": "Хӳмери чӑрӑш паллӑ",
  "block.minecraft.spruce_wood": "Чӑрӑш йывӑҫ",
  "block.minecraft.sticky_piston": "Ҫыпҫӑнчӑк хурсӑ",
  "block.minecraft.stone": "Чул",
  "block.minecraft.stone_brick_slab": "Чул кирпĕч плита",
  "block.minecraft.stone_brick_stairs": "Чул кирпĕч картлашка",
  "block.minecraft.stone_brick_wall": "Чул кирпĕч карта",
  "block.minecraft.stone_bricks": "Чул кирпӗч",
  "block.minecraft.stone_button": "Чул пускӑч",
  "block.minecraft.stone_pressure_plate": "Чул пусмалли плита",
  "block.minecraft.stone_slab": "Чул плита",
  "block.minecraft.stone_stairs": "Чул картлашка",
  "block.minecraft.stonecutter": "Чул каскӑч",
  "block.minecraft.stripped_acacia_log": "Чутланӑ акаци пӗрене",
  "block.minecraft.stripped_acacia_wood": "Чутланӑ акаци йывӑҫ",
  "block.minecraft.stripped_bamboo_block": "Чутланӑ бамбук блок",
  "block.minecraft.stripped_birch_log": "Чутланӑ хурӑн пӗрене",
  "block.minecraft.stripped_birch_wood": "Чутланӑ хурӑн йывӑҫ",
  "block.minecraft.stripped_cherry_log": "Чутланӑ чие пӗрене",
  "block.minecraft.stripped_cherry_wood": "Чутланӑ чие йывӑҫ",
  "block.minecraft.stripped_crimson_hyphae": "Чутланӑ хӗмлӗ гифа",
  "block.minecraft.stripped_crimson_stem": "Чутланӑ хӗмлӗ туна",
  "block.minecraft.stripped_dark_oak_log": "Чутланӑ тӗттӗм юман пӗрене",
  "block.minecraft.stripped_dark_oak_wood": "Чутланӑ тӗттӗм юман йывӑҫ",
  "block.minecraft.stripped_jungle_log": "Чутланӑ тропик йывӑҫ пӗрене",
  "block.minecraft.stripped_jungle_wood": "Чутланӑ тропик йывӑҫ йывӑҫ",
  "block.minecraft.stripped_mangrove_log": "Чутланӑ мангр пӗрене",
  "block.minecraft.stripped_mangrove_wood": "Чутланӑ мангр йывӑҫ",
  "block.minecraft.stripped_oak_log": "Чутланӑ юман пӗрене",
  "block.minecraft.stripped_oak_wood": "Чутланӑ юман йывӑҫ",
  "block.minecraft.stripped_pale_oak_log": "Чутланӑ шуранка юман пӗрене",
  "block.minecraft.stripped_pale_oak_wood": "Чутланӑ шуранка юман йывӑҫ",
  "block.minecraft.stripped_spruce_log": "Чутланӑ чӑрӑш пӗрене",
  "block.minecraft.stripped_spruce_wood": "Чутланӑ чӑрӑш йывӑҫ",
  "block.minecraft.stripped_warped_hyphae": "Чутланӑ пӑсӑк гифа",
  "block.minecraft.stripped_warped_stem": "Чутланӑ пӑсӑк туна",
  "block.minecraft.structure_block": "Хуралтӑ блокӗ",
  "block.minecraft.structure_void": "Хуралтӑ пушӑлӑхӗ",
  "block.minecraft.sugar_cane": "Сахӑр хӑмӑшӗ",
  "block.minecraft.sunflower": "Хӗвел ҫаврӑнӑш",
  "block.minecraft.suspicious_gravel": "Шиклӗ вӗтӗ чул",
  "block.minecraft.suspicious_sand": "Шиклӗ хӑйӑр",
  "block.minecraft.sweet_berry_bush": "Пылак ҫырла тӗмӗ",
  "block.minecraft.tall_dry_grass": "Вӑрӑм типӗ курӑк",
  "block.minecraft.tall_grass": "Вӑрӑм курӑк",
  "block.minecraft.tall_seagrass": "Вӑрӑм тинӗс курӑкӗ",
  "block.minecraft.target": "Мишень",
  "block.minecraft.terracotta": "Керамика",
  "block.minecraft.test_block": "Тест блокӗ",
  "block.minecraft.test_instance_block": "Тест экземплярӗ блокӗ",
  "block.minecraft.tinted_glass": "Тӗттӗмлетнӗ кантӑк",
  "block.minecraft.tnt": "Динамит",
  "block.minecraft.tnt.disabled": "Динамит сирпӗнни сӳнтернӗ",
  "block.minecraft.torch": "Ҫункӑҫ",
  "block.minecraft.torchflower": "Ҫункӑҫ чечек",
  "block.minecraft.torchflower_crop": "Ҫункӑҫ чечек хунавӗ",
  "block.minecraft.trapped_chest": "Капкӑн арча",
  "block.minecraft.trial_spawner": "Тӗрӗслев ҫураткӑчӗ",
  "block.minecraft.tripwire": "Капкӑн ҫиппи",
  "block.minecraft.tripwire_hook": "Ҫекӗл",
  "block.minecraft.tube_coral": "Чӗлӗм мерчен",
  "block.minecraft.tube_coral_block": "Чӗлӗм мерчен блок",
  "block.minecraft.tube_coral_fan": "Веерле чӗлӗм мерчен",
  "block.minecraft.tube_coral_wall_fan": "Хӳмери веерле чӗлӗм мерчен",
  "block.minecraft.tuff": "Туф",
  "block.minecraft.tuff_brick_slab": "Туф кирпӗч плита",
  "block.minecraft.tuff_brick_stairs": "Туф кирпӗч картлашка",
  "block.minecraft.tuff_brick_wall": "Туф кирпӗч карта",
  "block.minecraft.tuff_bricks": "Туф кирпӗч",
  "block.minecraft.tuff_slab": "Туф плити",
  "block.minecraft.tuff_stairs": "Туф картлашка",
  "block.minecraft.tuff_wall": "Туф карта",
  "block.minecraft.turtle_egg": "Тимӗр шапа ҫӑмарти",
  "block.minecraft.twisting_vines": "Явӑнчӑк лиана",
  "block.minecraft.twisting_vines_plant": "Явӑнчӑк лиана туни",
  "block.minecraft.vault": "Усрав",
  "block.minecraft.verdant_froglight": "Малахит шапа ҫути",
  "block.minecraft.vine": "Лиана",
  "block.minecraft.void_air": "Пушлӑх сывлӑшӗ",
  "block.minecraft.wall_torch": "Хӳме ҫункӑҫ",
  "block.minecraft.warped_button": "Пӑсӑк пускӑч",
  "block.minecraft.warped_door": "Пӑсӑк алӑк",
  "block.minecraft.warped_fence": "Пӑсӑк карта",
  "block.minecraft.warped_fence_gate": "Пӑсӑк калинкке",
  "block.minecraft.warped_fungus": "Пӑсӑк кӑмпа",
  "block.minecraft.warped_hanging_sign": "Пӑсӑк ҫакмалли паллӑ",
  "block.minecraft.warped_hyphae": "Пӑсӑк гифа",
  "block.minecraft.warped_nylium": "Пӑсӑк нилий",
  "block.minecraft.warped_planks": "Пӑсӑк хӑма",
  "block.minecraft.warped_pressure_plate": "Пӑсӑк пусмалли плита",
  "block.minecraft.warped_roots": "Пӑсӑк тымар",
  "block.minecraft.warped_shelf": "Пӑсӑк ҫӳлӗк",
  "block.minecraft.warped_sign": "Пӑсӑк паллӑ",
  "block.minecraft.warped_slab": "Пӑсӑк плита",
  "block.minecraft.warped_stairs": "Пӑсӑк картлашка",
  "block.minecraft.warped_stem": "Пӑсӑк туна",
  "block.minecraft.warped_trapdoor": "Пăсăк люк",
  "block.minecraft.warped_wall_hanging_sign": "Хӳмери пӑсӑк ҫакмалли паллӑ",
  "block.minecraft.warped_wall_sign": "Хӳмери пӑсӑк паллӑ",
  "block.minecraft.warped_wart_block": "Пӑсӑк мӑкӑль блок",
  "block.minecraft.water": "Шыв",
  "block.minecraft.water_cauldron": "Шыв хуранӗ",
  "block.minecraft.waxed_chiseled_copper": "Ӑвӑсланӑ хӑйранӑ пӑхӑр",
  "block.minecraft.waxed_copper_bars": "Ӑвӑсланӑ пӑхӑр хулӑ",
  "block.minecraft.waxed_copper_block": "Ӑвӑсланӑ пӑхӑр блок",
  "block.minecraft.waxed_copper_bulb": "Ӑвӑсланӑ пӑхӑр хунар",
  "block.minecraft.waxed_copper_chain": "Ӑвӑсланӑ пӑхӑр сӑнчӑр",
  "block.minecraft.waxed_copper_chest": "Ӑвӑсланӑ пӑхӑр арча",
  "block.minecraft.waxed_copper_door": "Ӑвӑсланӑ пӑхӑр алӑк",
  "block.minecraft.waxed_copper_golem_statue": "Ӑвӑсланӑ пӑхӑр голем кӗлетки",
  "block.minecraft.waxed_copper_grate": "Ӑвӑсланӑ пӑхӑр чӗнтӗр",
  "block.minecraft.waxed_copper_lantern": "Ӑвӑсланӑ пӑхӑр хунар",
  "block.minecraft.waxed_copper_trapdoor": "Ӑвӑсланӑ пӑхӑр люк",
  "block.minecraft.waxed_cut_copper": "Ӑвӑсланӑ каснӑ пӑхӑр",
  "block.minecraft.waxed_cut_copper_slab": "Ӑвӑсланӑ каснӑ пӑхӑр плита",
  "block.minecraft.waxed_cut_copper_stairs": "Ӑвӑсланӑ каснӑ пӑхӑр картлашка",
  "block.minecraft.waxed_exposed_chiseled_copper": "Ӑвӑсланӑ тӗксӗмленнӗ хӑйранӑ пӑхӑр",
  "block.minecraft.waxed_exposed_copper": "Ӑвӑсланӑ тӗксӗмленнӗ пӑхӑр",
  "block.minecraft.waxed_exposed_copper_bars": "Ӑвӑсланӑ тӗксӗмленнӗ пӑхӑр хулӑ",
  "block.minecraft.waxed_exposed_copper_bulb": "Ӑвӑсланӑ тӗксӗмленнӗ пӑхӑр хунар",
  "block.minecraft.waxed_exposed_copper_chain": "Ӑвӑсланӑ тӗксӗмленнӗ пӑхӑр сӑнчӑр",
  "block.minecraft.waxed_exposed_copper_chest": "Ӑвӑсланӑ тӗксӗмленнӗ пӑхӑр арча",
  "block.minecraft.waxed_exposed_copper_door": "Ӑвӑсланӑ тӗксӗмленнӗ пӑхӑр алӑк",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Ӑвӑсланӑ тӗксӗмленнӗ пӑхӑр голем кӗлетки",
  "block.minecraft.waxed_exposed_copper_grate": "Ӑвӑсланӑ тӗксӗмленнӗ пӑхӑр чӗнтӗр",
  "block.minecraft.waxed_exposed_copper_lantern": "Ӑвӑсланӑ тӗксӗмленнӗ пӑхӑр хунар",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Ăвăсланӑ тӗксӗмленнӗ пăхăр люк",
  "block.minecraft.waxed_exposed_cut_copper": "Ӑвӑсланӑ тӗксӗмленнӗ каснӑ пӑхӑр",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Ӑвӑсланӑ тӗксӗмленнӗ каснӑ пӑхӑр плита",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Ӑвӑсланӑ тӗксӗмленнӗ каснӑ пӑхӑр картлашка",
  "block.minecraft.waxed_exposed_lightning_rod": "Ӑвӑсланӑ тӗксӗмленнӗ ҫиҫӗм сирӳҫи",
  "block.minecraft.waxed_lightning_rod": "Ӑвӑсланӑ ҫиҫӗм сирӳҫи",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Ӑвӑсланӑ йӳҫекленнӗ хӑйранӑ пӑхӑр",
  "block.minecraft.waxed_oxidized_copper": "Ӑвӑсланӑ йӳҫекленнӗ пӑхӑр",
  "block.minecraft.waxed_oxidized_copper_bars": "Ӑвӑсланӑ йӳҫекленнӗ пӑхӑр хулӑ",
  "block.minecraft.waxed_oxidized_copper_bulb": "Ӑвӑсланӑ йӳҫекленнӗ пӑхӑр хунар",
  "block.minecraft.waxed_oxidized_copper_chain": "Ӑвӑсланӑ йӳҫекленнӗ пӑхӑр сӑнчӑр",
  "block.minecraft.waxed_oxidized_copper_chest": "Ӑвӑсланӑ йӳҫекленнӗ пӑхӑр арча",
  "block.minecraft.waxed_oxidized_copper_door": "Ӑвӑсланӑ йӳҫекленнӗ пӑхӑр алӑк",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Ӑвӑсланӑ йӳҫекленнӗ пӑхӑр голем кӗлетки",
  "block.minecraft.waxed_oxidized_copper_grate": "Ӑвӑсланӑ йӳҫекленнӗ пӑхӑр чӗнтӗр",
  "block.minecraft.waxed_oxidized_copper_lantern": "Ӑвӑсланӑ йӳҫекленнӗ пӑхӑр хунар",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Ăвăс йӳҫекленнӗ пӑхӑр люк",
  "block.minecraft.waxed_oxidized_cut_copper": "Ӑвӑсланӑ йӳҫекленнӗ каснӑ пӑхӑр",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Ӑвӑсланӑ йӳҫекленнӗ каснӑ пӑхӑр плита",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Ӑвӑсланӑ йӳҫекленнӗ каснӑ пӑхӑр картлашка",
  "block.minecraft.waxed_oxidized_lightning_rod": "Ӑвӑсланӑ йӳҫекленнӗ ҫиҫӗм сирӳҫи",
  "block.minecraft.waxed_weathered_chiseled_copper": "Ӑвӑсланӑ кивелнӗ хӑйранӑ пӑхӑр",
  "block.minecraft.waxed_weathered_copper": "Ӑвӑсланӑ кивелнӗ пӑхӑр",
  "block.minecraft.waxed_weathered_copper_bars": "Ӑвӑсланӑ кивелнӗ пӑхӑр хулӑ",
  "block.minecraft.waxed_weathered_copper_bulb": "Ӑвӑсланӑ кивелнӗ пӑхӑр хунар",
  "block.minecraft.waxed_weathered_copper_chain": "Ӑвӑсланӑ кивелнӗ пӑхӑр сӑнчӑр",
  "block.minecraft.waxed_weathered_copper_chest": "Ӑвӑсланӑ кивелнӗ пӑхӑр арча",
  "block.minecraft.waxed_weathered_copper_door": "Ӑвӑсланӑ кивелнӗ пӑхӑр алӑк",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Ӑвӑсланӑ кивелнӗ пӑхӑр голем кӗлетки",
  "block.minecraft.waxed_weathered_copper_grate": "Ӑвӑсланӑ кивелнӗ пӑхӑр чӗнтӗр",
  "block.minecraft.waxed_weathered_copper_lantern": "Ӑвӑсланӑ кивелнӗ пӑхӑр хунар",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Ăвăсланӑ кивелнӗ пăхăр люк",
  "block.minecraft.waxed_weathered_cut_copper": "Ӑвӑсланӑ кивелнӗ каснӑ пӑхӑр",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Ӑвӑсланӑ кивелнӗ каснӑ пӑхӑр плита",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Ӑвӑсланӑ кивелнӗ каснӑ пӑхӑр картлашка",
  "block.minecraft.waxed_weathered_lightning_rod": "Ӑвӑсланӑ кивелнӗ ҫиҫӗм сирӳҫи",
  "block.minecraft.weathered_chiseled_copper": "Ӑвӑсланӑ хӑйранӑ пӑхӑр",
  "block.minecraft.weathered_copper": "Кивелнӗ пӑхӑр",
  "block.minecraft.weathered_copper_bars": "Кивелнӗ пӑхӑр хулӑ",
  "block.minecraft.weathered_copper_bulb": "Кивелнӗ пӑхӑр хунар",
  "block.minecraft.weathered_copper_chain": "Кивелнӗ пӑхӑр сӑнчӑр",
  "block.minecraft.weathered_copper_chest": "Кивелнӗ пӑхӑр арча",
  "block.minecraft.weathered_copper_door": "Кивелнӗ пӑхӑр алӑк",
  "block.minecraft.weathered_copper_golem_statue": "Кивелнӗ пӑхӑр голем кӗлетки",
  "block.minecraft.weathered_copper_grate": "Кивелнӗ пӑхӑр чӗнтӗр",
  "block.minecraft.weathered_copper_lantern": "Кивелнӗ пӑхӑр хунар",
  "block.minecraft.weathered_copper_trapdoor": "Кивелнӗ пăхăр люк",
  "block.minecraft.weathered_cut_copper": "Кивелнӗ каснӑ пӑхӑр",
  "block.minecraft.weathered_cut_copper_slab": "Кивелнӗ каснӑ пӑхӑр плита",
  "block.minecraft.weathered_cut_copper_stairs": "Кивелнӗ каснӑ пӑхӑр картлашка",
  "block.minecraft.weathered_lightning_rod": "Кивелнӗ ҫиҫӗм сирӳҫи",
  "block.minecraft.weeping_vines": "Йӗренчӗк лиана",
  "block.minecraft.weeping_vines_plant": "Йӗренчӗк лиана туни",
  "block.minecraft.wet_sponge": "Йӗпе губка",
  "block.minecraft.wheat": "Тулӑ хунавӗ",
  "block.minecraft.white_banner": "Шурă ялав",
  "block.minecraft.white_bed": "Шурӑ кравать",
  "block.minecraft.white_candle": "Шурӑ ҫурта",
  "block.minecraft.white_candle_cake": "Шурӑ ҫурталлӑ торт",
  "block.minecraft.white_carpet": "Шурӑ кавир",
  "block.minecraft.white_concrete": "Шурӑ бетон",
  "block.minecraft.white_concrete_powder": "Шурă типĕ бетон",
  "block.minecraft.white_glazed_terracotta": "Шурӑ глазурьленӗ керамика",
  "block.minecraft.white_shulker_box": "Шурӑ шалкер арчи",
  "block.minecraft.white_stained_glass": "Шурӑ кантăк",
  "block.minecraft.white_stained_glass_pane": "Шурӑ ҫӳхе кантăк",
  "block.minecraft.white_terracotta": "Шурă керамика",
  "block.minecraft.white_tulip": "Шурӑ тюльпан",
  "block.minecraft.white_wool": "Шурӑ ҫӑм",
  "block.minecraft.wildflowers": "Уй чечекӗ",
  "block.minecraft.wither_rose": "Визер кӗл чечек",
  "block.minecraft.wither_skeleton_skull": "Визер шӑм-шак пуҫ шӑмми",
  "block.minecraft.wither_skeleton_wall_skull": "Хӳмери визер шӑм-шак пуҫ шӑмми",
  "block.minecraft.yellow_banner": "Сарă ялав",
  "block.minecraft.yellow_bed": "Сарӑ кравать",
  "block.minecraft.yellow_candle": "Сарӑ ҫурта",
  "block.minecraft.yellow_candle_cake": "Сарӑ ҫурталлӑ торт",
  "block.minecraft.yellow_carpet": "Сарӑ кавир",
  "block.minecraft.yellow_concrete": "Сарӑ бетон",
  "block.minecraft.yellow_concrete_powder": "Сарă типĕ бетон",
  "block.minecraft.yellow_glazed_terracotta": "Сарӑ глазурьленӗ керамика",
  "block.minecraft.yellow_shulker_box": "Сарӑ шалкер арчи",
  "block.minecraft.yellow_stained_glass": "Сарӑ кантӑк",
  "block.minecraft.yellow_stained_glass_pane": "Сарӑ ҫӳхе кантӑк",
  "block.minecraft.yellow_terracotta": "Сарă керамика",
  "block.minecraft.yellow_wool": "Сарӑ ҫӑм",
  "block.minecraft.zombie_head": "Зомби пуҫӗ",
  "block.minecraft.zombie_wall_head": "Хӳмери зомби пуҫӗ",
  "item.minecraft.acacia_boat": "Акаци кимӗ",
  "item.minecraft.acacia_chest_boat": "Арчаллӑ акаци кимӗ",
  "item.minecraft.allay_spawn_egg": "Лӑпкан ҫурату ҫӑмарти",
  "item.minecraft.amethyst_shard": "Аметист ванчӑкӗ",
  "item.minecraft.angler_pottery_shard": "«Пулӑҫӑ» тӑм чӳлмек катӑкӗ",
  "item.minecraft.angler_pottery_sherd": "«Пулӑҫӑ» тӑм чӳлмек катӑкӗ",
  "item.minecraft.apple": "Пан улми",
  "item.minecraft.archer_pottery_shard": "«Ухӑҫӑ» тӑм чӳлмек катӑкӗ",
  "item.minecraft.archer_pottery_sherd": "«Ухӑҫӑ» тӑм чӳлмек катӑкӗ",
  "item.minecraft.armadillo_scute": "Броненосец хуппин катӑкӗ",
  "item.minecraft.armadillo_spawn_egg": "Броненосец ҫурату ҫӑмарти",
  "item.minecraft.armor_stand": "Броня тӗревӗ",
  "item.minecraft.arms_up_pottery_shard": "«Аллусене ҫӳлелле ҫӗкле» тӑм чӳлмек катӑкӗ",
  "item.minecraft.arms_up_pottery_sherd": "«Аллусене ҫӳлелле ҫӗкле» тӑм чӳлмек катӑкӗ",
  "item.minecraft.arrow": "Ҫӗмрен",
  "item.minecraft.axolotl_bucket": "Витрери аксолотль",
  "item.minecraft.axolotl_spawn_egg": "Аксолотль ҫурату ҫӑмарти",
  "item.minecraft.baked_potato": "Пӗҫернӗ ҫӗр улми",
  "item.minecraft.bamboo_chest_raft": "Арчаллӑ бамбук сулӑ",
  "item.minecraft.bamboo_raft": "Бамбук сулӑ",
  "item.minecraft.bat_spawn_egg": "Ҫара ҫерҫи сурату ҫӑмарти",
  "item.minecraft.bee_spawn_egg": "Вӗлле хурчӗ ҫурату ҫӑмарти",
  "item.minecraft.beef": "Чӗрӗ ӗне ашӗ",
  "item.minecraft.beetroot": "Кӑшман",
  "item.minecraft.beetroot_seeds": "Кӑшман вӑрлӑхӗ",
  "item.minecraft.beetroot_soup": "Кӑшман яшки",
  "item.minecraft.birch_boat": "Хурӑн кимӗ",
  "item.minecraft.birch_chest_boat": "Арчаллӑ хурӑн кимӗ",
  "item.minecraft.black_bundle": "Хура михӗ",
  "item.minecraft.black_dye": "Хура сӑрӑ",
  "item.minecraft.black_harness": "Хура гаст таврашӗ",
  "item.minecraft.blade_pottery_shard": "«Хĕҫ» тӑм чӳлмек катӑкӗ",
  "item.minecraft.blade_pottery_sherd": "«Хĕҫ» тӑм чӳлмек катӑкӗ",
  "item.minecraft.blaze_powder": "Вутлак ҫӑнӑхӗ",
  "item.minecraft.blaze_rod": "Вутлак патакӗ",
  "item.minecraft.blaze_spawn_egg": "Вутлак ҫурату ҫӑмарти",
  "item.minecraft.blue_bundle": "Кӑвак михӗ",
  "item.minecraft.blue_dye": "Кӑвак сӑрӑ",
  "item.minecraft.blue_egg": "Сенкер ҫӑмарта",
  "item.minecraft.blue_harness": "Кӑвак гаст таврашӗ",
  "item.minecraft.bogged_spawn_egg": "Лакан ҫурату ҫӑмарти",
  "item.minecraft.bolt_armor_trim_smithing_template": "Тимӗрҫӗ ӗлки",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "«Тӗнӗл» эрешĕ",
  "item.minecraft.bone": "Шӑмӑ",
  "item.minecraft.bone_meal": "Шӑмӑ ҫӑнӑхӗ",
  "item.minecraft.book": "Кӗнеке",
  "item.minecraft.bordure_indented_banner_pattern": "«Шӑллӑ хӑю» ялав тӗрри",
  "item.minecraft.bow": "Ухӑ",
  "item.minecraft.bowl": "Чашăк",
  "item.minecraft.bread": "Ҫӑкӑр",
  "item.minecraft.breeze_rod": "Ҫавра ҫил патакӗ",
  "item.minecraft.breeze_spawn_egg": "Ҫавра ҫил ҫурату ҫӑмарти",
  "item.minecraft.brewer_pottery_shard": "«Имҫӗ» тӑм чӳлмек катӑкӗ",
  "item.minecraft.brewer_pottery_sherd": "«Имҫӗ» тӑм чӳлмек катӑкӗ",
  "item.minecraft.brewing_stand": "Им вӗреткӗч",
  "item.minecraft.brick": "Кирпӗч",
  "item.minecraft.brown_bundle": "Хӑмӑр михӗ",
  "item.minecraft.brown_dye": "Хӑмӑр сӑрӑ",
  "item.minecraft.brown_egg": "Хӑмӑр ҫӑмарта",
  "item.minecraft.brown_harness": "Хӑмӑр гаст таврашӗ",
  "item.minecraft.brush": "Киҫтӗк",
  "item.minecraft.bucket": "Витре",
  "item.minecraft.bundle": "Михӗ",
  "item.minecraft.bundle.empty": "Пушӑ",
  "item.minecraft.bundle.empty.description": "Тӗрлӗ япаласен купине упрама пултарать",
  "item.minecraft.bundle.full": "Тулли",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "«Ҫулӑм» тӑм чӳлмек катӑкӗ",
  "item.minecraft.burn_pottery_sherd": "«Ҫулӑм» тӑм чӳлмек катӑкӗ",
  "item.minecraft.camel_husk_spawn_egg": "Виселен тӗве ҫурату ҫӑмарти",
  "item.minecraft.camel_spawn_egg": "Тӗве ҫурату ҫӑмарти",
  "item.minecraft.carrot": "Кишӗр",
  "item.minecraft.carrot_on_a_stick": "Кишĕрлĕ вăлта",
  "item.minecraft.cat_spawn_egg": "Кушак ҫурату ҫӑмарти",
  "item.minecraft.cauldron": "Хуран",
  "item.minecraft.cave_spider_spawn_egg": "Ҫӗр хӑвӑлӗ эрешменĕ ҫурату ҫӑмарти",
  "item.minecraft.chainmail_boots": "Тимӗр вӑчӑра атӑ",
  "item.minecraft.chainmail_chestplate": "Тимӗр вӑчӑра кӑкӑрлӑх",
  "item.minecraft.chainmail_helmet": "Тимӗр вӑчӑра ҫĕлĕк",
  "item.minecraft.chainmail_leggings": "Тимӗр вӑчӑра йĕм",
  "item.minecraft.charcoal": "Йывӑҫ кӑмрӑкӗ",
  "item.minecraft.cherry_boat": "Чие кимӗ",
  "item.minecraft.cherry_chest_boat": "Арчаллӑ чие кимӗ",
  "item.minecraft.chest_minecart": "Арчаллӑ вакун",
  "item.minecraft.chicken": "Чӗрӗ чӑх ашӗ",
  "item.minecraft.chicken_spawn_egg": "Чӑх ҫурату ҫӑмарти",
  "item.minecraft.chorus_fruit": "Хорус ҫимӗҫӗ",
  "item.minecraft.clay_ball": "Тӑм чӑмӑркки",
  "item.minecraft.clock": "Сехет",
  "item.minecraft.coal": "Кӑмрӑк",
  "item.minecraft.coast_armor_trim_smithing_template": "Тимӗрҫӗ ӗлки",
  "item.minecraft.coast_armor_trim_smithing_template.new": "«Шыв хӗрри» эрешĕ",
  "item.minecraft.cocoa_beans": "Какао вӑрри",
  "item.minecraft.cod": "Чӗрӗ треска",
  "item.minecraft.cod_bucket": "Витрери треска",
  "item.minecraft.cod_spawn_egg": "Треска ҫурату ҫӑмарти",
  "item.minecraft.command_block_minecart": "Команда блокӗллӗ вакун",
  "item.minecraft.compass": "Компас",
  "item.minecraft.cooked_beef": "Ӑшаланӑ ӗне ашӗ",
  "item.minecraft.cooked_chicken": "Ӑшаланӑ чӑх ашӗ",
  "item.minecraft.cooked_cod": "Ӑшаланӑ треска",
  "item.minecraft.cooked_mutton": "Ӑшаланӑ сурӑх ашӗ",
  "item.minecraft.cooked_porkchop": "Ӑшаланӑ сысна ашӗ",
  "item.minecraft.cooked_rabbit": "Ӑшаланӑ куян ашӗ",
  "item.minecraft.cooked_salmon": "Ӑшаланӑ лосось",
  "item.minecraft.cookie": "Печени",
  "item.minecraft.copper_axe": "Пӑхӑр пуртӑ",
  "item.minecraft.copper_boots": "Пӑхӑр атӑ",
  "item.minecraft.copper_chestplate": "Пӑхӑр кӑкӑрлӑх",
  "item.minecraft.copper_golem_spawn_egg": "Пӑхӑр голем ҫурату ҫӑмарти",
  "item.minecraft.copper_helmet": "Пӑхӑр ҫӗлӗк",
  "item.minecraft.copper_hoe": "Пӑхӑр катмак",
  "item.minecraft.copper_horse_armor": "Пӑхӑр лаша брони",
  "item.minecraft.copper_ingot": "Пӑхӑр катӑкӗ",
  "item.minecraft.copper_leggings": "Пӑхӑр йӗм",
  "item.minecraft.copper_nautilus_armor": "Пӑхӑр наутилус брони",
  "item.minecraft.copper_nugget": "Пӑхӑр татӑкӗ",
  "item.minecraft.copper_pickaxe": "Пӑхӑр кайла",
  "item.minecraft.copper_shovel": "Пӑхӑр кӗреҫе",
  "item.minecraft.copper_spear": "Пӑхӑр сӑнӑ",
  "item.minecraft.copper_sword": "Пӑхӑр хӗҫ",
  "item.minecraft.cow_spawn_egg": "Ӗне ҫурату ҫӑмарти",
  "item.minecraft.creaking_spawn_egg": "Чӗриклетчӗк ҫурату ҫӑмарти",
  "item.minecraft.creeper_banner_pattern": "Ялав тӗрри",
  "item.minecraft.creeper_banner_pattern.desc": "Крипер",
  "item.minecraft.creeper_banner_pattern.new": "«Крипер» ялав тӗрри",
  "item.minecraft.creeper_spawn_egg": "Крипер ҫурату ҫӑмарти",
  "item.minecraft.crossbow": "Арбалет",
  "item.minecraft.crossbow.projectile": "Йĕтре:",
  "item.minecraft.crossbow.projectile.multiple": "Йӗтре: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Йӗтре: %s",
  "item.minecraft.cyan_bundle": "Кӑвак симӗс михӗ",
  "item.minecraft.cyan_dye": "Кӑвак симӗс сӑрӑ",
  "item.minecraft.cyan_harness": "Кӑвак симӗс гаст таврашӗ",
  "item.minecraft.danger_pottery_shard": "«Юнав» тӑм чӳлмек катӑкӗ",
  "item.minecraft.danger_pottery_sherd": "«Юнав» тӑм чӳлмек катӑкӗ",
  "item.minecraft.dark_oak_boat": "Тӗттӗм юман кимӗ",
  "item.minecraft.dark_oak_chest_boat": "Арчаллӑ тӗттӗм юман кимӗ",
  "item.minecraft.debug_stick": "Тӳрлетӳ патакӗ",
  "item.minecraft.debug_stick.empty": "%s япалан уйрӑмлӑх ҫук",
  "item.minecraft.debug_stick.select": "«%s» (%s) суйланӑ",
  "item.minecraft.debug_stick.update": "«%s» -> %s",
  "item.minecraft.diamond": "Алмас",
  "item.minecraft.diamond_axe": "Алмас пуртӑ",
  "item.minecraft.diamond_boots": "Алмас атӑ",
  "item.minecraft.diamond_chestplate": "Алмас кӑкӑрлӑх",
  "item.minecraft.diamond_helmet": "Алмас ҫӗлӗк",
  "item.minecraft.diamond_hoe": "Алмас катмак",
  "item.minecraft.diamond_horse_armor": "Алмас лаша брони",
  "item.minecraft.diamond_leggings": "Алмас йӗм",
  "item.minecraft.diamond_nautilus_armor": "Алмас наутилус брони",
  "item.minecraft.diamond_pickaxe": "Алмас кайла",
  "item.minecraft.diamond_shovel": "Алмас кӗреҫе",
  "item.minecraft.diamond_spear": "Алмас сӑнӑ",
  "item.minecraft.diamond_sword": "Алмас хӗҫ",
  "item.minecraft.disc_fragment_5": "Пластинка катӑкӗ",
  "item.minecraft.disc_fragment_5.desc": "Пластинка — 5",
  "item.minecraft.dolphin_spawn_egg": "Дельфин ҫурату ҫӑмарти",
  "item.minecraft.donkey_spawn_egg": "Ашак ҫурату ҫӑмарти",
  "item.minecraft.dragon_breath": "Аҫтаха сывлавӗ",
  "item.minecraft.dried_kelp": "Типӗтнӗ ламинари",
  "item.minecraft.drowned_spawn_egg": "Путан ҫурату ҫӑмарти",
  "item.minecraft.dune_armor_trim_smithing_template": "Тимӗрҫӗ ӗлки",
  "item.minecraft.dune_armor_trim_smithing_template.new": "«Хӑйӑр сӑрчӗ» эрешĕ",
  "item.minecraft.echo_shard": "Ахрӑм ванчӑкӗ",
  "item.minecraft.egg": "Ҫӑмарта",
  "item.minecraft.elder_guardian_spawn_egg": "Авалхи хуралҫӑ ҫурату ҫӑмарти",
  "item.minecraft.elytra": "Элитра",
  "item.minecraft.emerald": "Изумруд",
  "item.minecraft.enchanted_book": "Ӑрӑм кӗнеки",
  "item.minecraft.enchanted_golden_apple": "Ӑрӑмланӑ ылтӑн пан улми",
  "item.minecraft.end_crystal": "Энд кристалĕ",
  "item.minecraft.ender_dragon_spawn_egg": "Эндер аҫтаха ҫурату ҫӑмарти",
  "item.minecraft.ender_eye": "Эндер куҫӗ",
  "item.minecraft.ender_pearl": "Эндер ӗнчӗ",
  "item.minecraft.enderman_spawn_egg": "Эндермен ҫурату ҫӑмарти",
  "item.minecraft.endermite_spawn_egg": "Эндермит ҫурату ҫӑмарти",
  "item.minecraft.evoker_spawn_egg": "Вӗрӳҫӗ ҫурату ҫӑмарти",
  "item.minecraft.experience_bottle": "Хӑнӑху кӗленчи",
  "item.minecraft.explorer_pottery_shard": "«Тӗпчевҫӗ» тӑм чӳлмек катӑкӗ",
  "item.minecraft.explorer_pottery_sherd": "«Тӗпчевҫӗ» тӑм чӳлмек катӑкӗ",
  "item.minecraft.eye_armor_trim_smithing_template": "Тимӗрҫӗ ӗлки",
  "item.minecraft.eye_armor_trim_smithing_template.new": "«Куҫ» эрешĕ",
  "item.minecraft.feather": "Тӗк",
  "item.minecraft.fermented_spider_eye": "Маринадланӑ эрешмен куҫӗ",
  "item.minecraft.field_masoned_banner_pattern": "«Кирпӗч» ялав тӗрри",
  "item.minecraft.filled_map": "Карттӑ",
  "item.minecraft.fire_charge": "Вут йӗтри",
  "item.minecraft.firework_rocket": "Фейерверк",
  "item.minecraft.firework_rocket.flight": "Вӗҫев вӑрӑмӑшӗ:",
  "item.minecraft.firework_rocket.multiple_stars": "%s × %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Фейерверк ҫӑлтӑрӗ",
  "item.minecraft.firework_star.black": "Хура",
  "item.minecraft.firework_star.blue": "Кӑвак",
  "item.minecraft.firework_star.brown": "Хӑмӑр",
  "item.minecraft.firework_star.custom_color": "Усӑ кураканӑн",
  "item.minecraft.firework_star.cyan": "Кӑвак симӗс",
  "item.minecraft.firework_star.fade_to": "Сӳнӳ тӗсӗ:",
  "item.minecraft.firework_star.flicker": "Йӑлтлату",
  "item.minecraft.firework_star.gray": "Сӑрӑ",
  "item.minecraft.firework_star.green": "Симӗс",
  "item.minecraft.firework_star.light_blue": "Сенкер",
  "item.minecraft.firework_star.light_gray": "Ҫутӑ сӑрӑ",
  "item.minecraft.firework_star.lime": "Сарӑ симӗс",
  "item.minecraft.firework_star.magenta": "Хӗрлӗ кӗрен",
  "item.minecraft.firework_star.orange": "Хӗрлӗ сарӑ",
  "item.minecraft.firework_star.pink": "Кӗрен",
  "item.minecraft.firework_star.purple": "Хӗрлӗ кӑвак",
  "item.minecraft.firework_star.red": "Хӗрлӗ",
  "item.minecraft.firework_star.shape": "Паллӑ мар капаш",
  "item.minecraft.firework_star.shape.burst": "Ҫиҫӳ",
  "item.minecraft.firework_star.shape.creeper": "Крипер евӗрлӗ",
  "item.minecraft.firework_star.shape.large_ball": "Пысӑк чӑмӑр",
  "item.minecraft.firework_star.shape.small_ball": "Пӗчӗк чӑмӑр",
  "item.minecraft.firework_star.shape.star": "Ҫӑлтӑр евӗрлӗ",
  "item.minecraft.firework_star.trail": "Йӗр",
  "item.minecraft.firework_star.white": "Шурӑ",
  "item.minecraft.firework_star.yellow": "Сарӑ",
  "item.minecraft.fishing_rod": "Вӑлта",
  "item.minecraft.flint": "Вут чулӗ",
  "item.minecraft.flint_and_steel": "Ҫулу",
  "item.minecraft.flow_armor_trim_smithing_template": "Тимӗрҫӗ ӗлки",
  "item.minecraft.flow_armor_trim_smithing_template.new": "«Ҫил юхӑмӗ» эрешĕ",
  "item.minecraft.flow_banner_pattern": "Ялав тӗрри",
  "item.minecraft.flow_banner_pattern.desc": "Вӑркӑш",
  "item.minecraft.flow_banner_pattern.new": "«Вӑркӑш» ялав тӗрри",
  "item.minecraft.flow_pottery_sherd": "«Ҫил юхӑмӗ» тӑм чӳлмек катӑкӗ",
  "item.minecraft.flower_banner_pattern": "Ялав тӗрри",
  "item.minecraft.flower_banner_pattern.desc": "Чечек",
  "item.minecraft.flower_banner_pattern.new": "«Чечек» ялав тӗрри",
  "item.minecraft.flower_pot": "Чечек чӳлмекӗ",
  "item.minecraft.fox_spawn_egg": "Тилӗ ҫурату ҫӑмарти",
  "item.minecraft.friend_pottery_shard": "«Тус» тӑм чӳлмек катӑкӗ",
  "item.minecraft.friend_pottery_sherd": "«Тус» тӑм чӳлмек катӑкӗ",
  "item.minecraft.frog_spawn_egg": "Шапа ҫурату ҫӑмарти",
  "item.minecraft.furnace_minecart": "Кӑмакаллӑ вакун",
  "item.minecraft.ghast_spawn_egg": "Гаст ҫурату ҫӑмарти",
  "item.minecraft.ghast_tear": "Гаст куҫҫулӗ",
  "item.minecraft.glass_bottle": "Кĕленче",
  "item.minecraft.glistering_melon_slice": "Йӑлтӑркка арпус чӗлли",
  "item.minecraft.globe_banner_pattern": "Ялав тӗрри",
  "item.minecraft.globe_banner_pattern.desc": "Ҫӗр чӑмӑрӗ",
  "item.minecraft.globe_banner_pattern.new": "«Ҫӗр чӑмӑрӗ» ялав тӗрри",
  "item.minecraft.glow_berries": "Ҫуталакан ҫырла",
  "item.minecraft.glow_ink_sac": "Ҫутӑ чернил миххи",
  "item.minecraft.glow_item_frame": "Ҫутӑ хашак",
  "item.minecraft.glow_squid_spawn_egg": "Ҫуталакан сакӑр ура ҫурату ҫӑмарти",
  "item.minecraft.glowstone_dust": "Ҫутӑ чул тусанӗ",
  "item.minecraft.goat_horn": "Качака мӑйраки",
  "item.minecraft.goat_spawn_egg": "Качака ҫурату ҫӑмарти",
  "item.minecraft.gold_ingot": "Ылтӑн катăкĕ",
  "item.minecraft.gold_nugget": "Ылтӑн татӑкӗ",
  "item.minecraft.golden_apple": "Ылтӑн пан улми",
  "item.minecraft.golden_axe": "Ылтӑн пуртӑ",
  "item.minecraft.golden_boots": "Ылтӑн атӑ",
  "item.minecraft.golden_carrot": "Ылтӑн кишӗр",
  "item.minecraft.golden_chestplate": "Ылтӑн кӑкӑрлӑх",
  "item.minecraft.golden_helmet": "Ылтӑн ҫӗлӗк",
  "item.minecraft.golden_hoe": "Ылтӑн катмак",
  "item.minecraft.golden_horse_armor": "Ылтӑн лаша брони",
  "item.minecraft.golden_leggings": "Ылтӑн йӗм",
  "item.minecraft.golden_nautilus_armor": "Ылтӑн наутилус брони",
  "item.minecraft.golden_pickaxe": "Ылтӑн кайла",
  "item.minecraft.golden_shovel": "Ылтӑн кӗреҫе",
  "item.minecraft.golden_spear": "Ылтӑн сӑнӑ",
  "item.minecraft.golden_sword": "Ылтӑн хӗҫ",
  "item.minecraft.gray_bundle": "Сӑрӑ михӗ",
  "item.minecraft.gray_dye": "Сӑрӑ сӑрӑ",
  "item.minecraft.gray_harness": "Сӑрӑ гаст таврашӗ",
  "item.minecraft.green_bundle": "Симӗс михӗ",
  "item.minecraft.green_dye": "Симӗс сӑрӑ",
  "item.minecraft.green_harness": "Симӗс гаст таврашӗ",
  "item.minecraft.guardian_spawn_egg": "Хуралҫӑ ҫурату ҫӑмарти",
  "item.minecraft.gunpowder": "Тар",
  "item.minecraft.guster_banner_pattern": "Ялав тӗрри",
  "item.minecraft.guster_banner_pattern.desc": "Ҫавра ҫил",
  "item.minecraft.guster_banner_pattern.new": "«Ҫавра ҫил» ялав тӗрри",
  "item.minecraft.guster_pottery_sherd": "«Ҫил юхӑмӗ» тӑм чӳлмек катӑкӗ",
  "item.minecraft.happy_ghast_spawn_egg": "Телейлӗ гаст ҫурату ҫӑмарти",
  "item.minecraft.harness": "Гаст таврашӗ",
  "item.minecraft.heart_of_the_sea": "Тинӗс чӗри",
  "item.minecraft.heart_pottery_shard": "«Чӗре» тӑм чӳлмек катӑкӗ",
  "item.minecraft.heart_pottery_sherd": "«Чӗре» тӑм чӳлмек катӑкӗ",
  "item.minecraft.heartbreak_pottery_shard": "«Ҫӗмӗрӗлнӗ чӗре» тӑм чӳлмек катӑкӗ",
  "item.minecraft.heartbreak_pottery_sherd": "«Ҫӗмӗрӗлнӗ чӗре» тӑм чӳлмек катӑкӗ",
  "item.minecraft.hoglin_spawn_egg": "Хоглин ҫурату ҫӑмарти",
  "item.minecraft.honey_bottle": "Пыл кӗленчи",
  "item.minecraft.honeycomb": "Пыл карасĕ",
  "item.minecraft.hopper_minecart": "Варинккеллӗ вакун",
  "item.minecraft.horse_spawn_egg": "Лаша ҫурату ҫӑмарти",
  "item.minecraft.host_armor_trim_smithing_template": "Тимӗрҫӗ ӗлки",
  "item.minecraft.host_armor_trim_smithing_template.new": "«Ҫул пуҫ» эрешĕ",
  "item.minecraft.howl_pottery_shard": "«Ула» тӑм чӳлмек катӑкӗ",
  "item.minecraft.howl_pottery_sherd": "«Улу» тӑм чӳлмек катӑкӗ",
  "item.minecraft.husk_spawn_egg": "Виселен ҫурату ҫӑмарти",
  "item.minecraft.ink_sac": "Чернил миххи",
  "item.minecraft.iron_axe": "Тимӗр пуртӑ",
  "item.minecraft.iron_boots": "Тимӗр атӑ",
  "item.minecraft.iron_chestplate": "Тимӗр кӑкӑрлӑх",
  "item.minecraft.iron_golem_spawn_egg": "Тимӗр голем ҫурату ҫӑмарти",
  "item.minecraft.iron_helmet": "Тимӗр ҫӗлӗк",
  "item.minecraft.iron_hoe": "Тимӗр катмак",
  "item.minecraft.iron_horse_armor": "Тимӗр лаша брони",
  "item.minecraft.iron_ingot": "Тимӗр катăкĕ",
  "item.minecraft.iron_leggings": "Тимӗр йӗм",
  "item.minecraft.iron_nautilus_armor": "Тимӗр наутилус брони",
  "item.minecraft.iron_nugget": "Тимӗр татӑкӗ",
  "item.minecraft.iron_pickaxe": "Тимӗр кайла",
  "item.minecraft.iron_shovel": "Тимӗр кӗреҫе",
  "item.minecraft.iron_spear": "Тимӗр сӑнӑ",
  "item.minecraft.iron_sword": "Тимӗр хӗҫ",
  "item.minecraft.item_frame": "Хашак",
  "item.minecraft.jungle_boat": "Тропик йывӑҫ кимӗ",
  "item.minecraft.jungle_chest_boat": "Арчаллӑ тропик йывӑҫ кимӗ",
  "item.minecraft.knowledge_book": "Пӗлӳ кӗнеки",
  "item.minecraft.lapis_lazuli": "Лазурит",
  "item.minecraft.lava_bucket": "Лава витри",
  "item.minecraft.lead": "Чӗлпӗр",
  "item.minecraft.leather": "Тир",
  "item.minecraft.leather_boots": "Сӑран атӑ",
  "item.minecraft.leather_chestplate": "Сӑран кипке",
  "item.minecraft.leather_helmet": "Сӑран ҫӗлӗк",
  "item.minecraft.leather_horse_armor": "Сӑран лаша брони",
  "item.minecraft.leather_leggings": "Сӑран йӗм",
  "item.minecraft.light_blue_bundle": "Сенкер михӗ",
  "item.minecraft.light_blue_dye": "Сенкер сӑрӑ",
  "item.minecraft.light_blue_harness": "Сенкер гаст таврашӗ",
  "item.minecraft.light_gray_bundle": "Ҫутӑ сӑрӑ михӗ",
  "item.minecraft.light_gray_dye": "Ҫутӑ сӑрӑ сӑрӑ",
  "item.minecraft.light_gray_harness": "Ҫутӑ сӑрӑ гаст таврашӗ",
  "item.minecraft.lime_bundle": "Сарӑ симӗс михӗ",
  "item.minecraft.lime_dye": "Сарӑ симӗс сӑрӑ",
  "item.minecraft.lime_harness": "Сарӑ симӗс гаст таврашӗ",
  "item.minecraft.lingering_potion": "Тӗтреллӗ им",
  "item.minecraft.lingering_potion.effect.awkward": "Пӑтранчӑк тӗтреллӗ им",
  "item.minecraft.lingering_potion.effect.empty": "Пултарайман тӗтреллӗ им",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Тӗтреллӗ ҫунманлӑх имӗ",
  "item.minecraft.lingering_potion.effect.harming": "Тӗтреллӗ сиен имӗ",
  "item.minecraft.lingering_potion.effect.healing": "Тӗтреллӗ сиплев имӗ",
  "item.minecraft.lingering_potion.effect.infested": "Тӗтреллӗ чирлетӳ имӗ",
  "item.minecraft.lingering_potion.effect.invisibility": "Тӗтреллӗ курӑнманлӑх имӗ",
  "item.minecraft.lingering_potion.effect.leaping": "Тӗтреллӗ сикӗ имӗ",
  "item.minecraft.lingering_potion.effect.levitation": "Тӗтреллӗ ӳкменлӗх имӗ",
  "item.minecraft.lingering_potion.effect.luck": "Тӗтреллӗ ӑнӑҫу имӗ",
  "item.minecraft.lingering_potion.effect.mundane": "Тӗтреллӗ ахаль им",
  "item.minecraft.lingering_potion.effect.night_vision": "Тӗтреллӗ ҫӗрлехи куҫ имӗ",
  "item.minecraft.lingering_potion.effect.oozing": "Тӗтреллӗ путхахлӑх имӗ",
  "item.minecraft.lingering_potion.effect.poison": "Тӗтреллӗ наркӑмӑшлану имӗ",
  "item.minecraft.lingering_potion.effect.regeneration": "Тӗтреллӗ сывату имӗ",
  "item.minecraft.lingering_potion.effect.slow_falling": "Тӗтреллӗ тикӗс ӳкни имӗ",
  "item.minecraft.lingering_potion.effect.slowness": "Тӗтреллӗ вӑрахлату имӗ",
  "item.minecraft.lingering_potion.effect.strength": "Тӗтреллӗ вӑй имӗ",
  "item.minecraft.lingering_potion.effect.swiftness": "Тӗтреллӗ хӑвӑртлӑх имӗ",
  "item.minecraft.lingering_potion.effect.thick": "Тӗтреллӗ ҫӑра им",
  "item.minecraft.lingering_potion.effect.turtle_master": "Тӗтреллӗ тимӗр шапа хӑвачӗ имӗ",
  "item.minecraft.lingering_potion.effect.water": "Тӗтреллӗ шыв кӗленчи",
  "item.minecraft.lingering_potion.effect.water_breathing": "Тӗтреллӗ шыври сывлав имӗ",
  "item.minecraft.lingering_potion.effect.weakness": "Тӗтреллӗ вӑйсӑрлӑх имӗ",
  "item.minecraft.lingering_potion.effect.weaving": "Тӗтреллӗ ҫыху имӗ",
  "item.minecraft.lingering_potion.effect.wind_charged": "Тӗтреллӗ ҫил иӗтри имӗ",
  "item.minecraft.llama_spawn_egg": "Лама ҫурату ҫӑмарти",
  "item.minecraft.lodestone_compass": "Магнитланӑ компас",
  "item.minecraft.mace": "Чукмар",
  "item.minecraft.magenta_bundle": "Хӗрлӗ кӗрен михӗ",
  "item.minecraft.magenta_dye": "Хӗрлӗ кӗрен сӑрӑ",
  "item.minecraft.magenta_harness": "Хӗрлӗ кӗрен гаст таврашӗ",
  "item.minecraft.magma_cream": "Магма муклашки",
  "item.minecraft.magma_cube_spawn_egg": "Магма кубӗ ҫурату ҫӑмарти",
  "item.minecraft.mangrove_boat": "Мангр кимӗ",
  "item.minecraft.mangrove_chest_boat": "Арчаллӑ мангр кимӗ",
  "item.minecraft.map": "Пушӑ карттӑ",
  "item.minecraft.melon_seeds": "Арпус вӑрри",
  "item.minecraft.melon_slice": "Арпус чĕлли",
  "item.minecraft.milk_bucket": "Сӗт витри",
  "item.minecraft.minecart": "Вакун",
  "item.minecraft.miner_pottery_shard": "«Шахтӑҫӑ» тӑм чӳлмек катӑкӗ",
  "item.minecraft.miner_pottery_sherd": "«Шахтӑҫӑ» тӑм чӳлмек катӑкӗ",
  "item.minecraft.mojang_banner_pattern": "Ялав тӗрри",
  "item.minecraft.mojang_banner_pattern.desc": "Темӗн",
  "item.minecraft.mojang_banner_pattern.new": "«Темӗн» ялав тӗрри",
  "item.minecraft.mooshroom_spawn_egg": "Мушрум ҫурату ҫӑмарти",
  "item.minecraft.mourner_pottery_shard": "«Хурлӑх» тӑм чӳлмек катӑкӗ",
  "item.minecraft.mourner_pottery_sherd": "«Хурлӑх» тӑм чӳлмек катӑкӗ",
  "item.minecraft.mule_spawn_egg": "Мул ҫурату ҫӑмарти",
  "item.minecraft.mushroom_stew": "Пӑшӑхланӑ кӑмпа",
  "item.minecraft.music_disc_11": "Пластинка",
  "item.minecraft.music_disc_11.desc": "C418 — 11",
  "item.minecraft.music_disc_13": "Пластинка",
  "item.minecraft.music_disc_13.desc": "C418 — 13",
  "item.minecraft.music_disc_5": "Пластинка",
  "item.minecraft.music_disc_5.desc": "Самуэль Оберг — 5",
  "item.minecraft.music_disc_blocks": "Пластинка",
  "item.minecraft.music_disc_blocks.desc": "C418 — blocks",
  "item.minecraft.music_disc_cat": "Пластинка",
  "item.minecraft.music_disc_cat.desc": "C418 — cat",
  "item.minecraft.music_disc_chirp": "Пластинка",
  "item.minecraft.music_disc_chirp.desc": "C418 — chirp",
  "item.minecraft.music_disc_creator": "Пластинка",
  "item.minecraft.music_disc_creator.desc": "Лена Рейн – Creator",
  "item.minecraft.music_disc_creator_music_box": "Пластинка",
  "item.minecraft.music_disc_creator_music_box.desc": "Лена Рейн — Creator (Музыка арчи)",
  "item.minecraft.music_disc_far": "Пластинка",
  "item.minecraft.music_disc_far.desc": "C418 — far",
  "item.minecraft.music_disc_lava_chicken": "Пластинка",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions — Lava Chicken",
  "item.minecraft.music_disc_mall": "Пластинка",
  "item.minecraft.music_disc_mall.desc": "C418 — mall",
  "item.minecraft.music_disc_mellohi": "Пластинка",
  "item.minecraft.music_disc_mellohi.desc": "C418 — mellohi",
  "item.minecraft.music_disc_otherside": "Пластинка",
  "item.minecraft.music_disc_otherside.desc": "Лена Рейн — otherside",
  "item.minecraft.music_disc_pigstep": "Пластинка",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine — Pigstep",
  "item.minecraft.music_disc_precipice": "Пластинка",
  "item.minecraft.music_disc_precipice.desc": "Аарон Шероф — Precipice",
  "item.minecraft.music_disc_relic": "Сасă çаврашка",
  "item.minecraft.music_disc_relic.desc": "Аарон Шероф — Relic",
  "item.minecraft.music_disc_stal": "Пластинка",
  "item.minecraft.music_disc_stal.desc": "C418 — stal",
  "item.minecraft.music_disc_strad": "Пластинка",
  "item.minecraft.music_disc_strad.desc": "C418 — strad",
  "item.minecraft.music_disc_tears": "Пластинка",
  "item.minecraft.music_disc_tears.desc": "Эймос Родди — Tears",
  "item.minecraft.music_disc_wait": "Пластинка",
  "item.minecraft.music_disc_wait.desc": "C418 — wait",
  "item.minecraft.music_disc_ward": "Пластинка",
  "item.minecraft.music_disc_ward.desc": "C418 — ward",
  "item.minecraft.mutton": "Чӗрӗ сурӑх ашӗ",
  "item.minecraft.name_tag": "Ярлӑк",
  "item.minecraft.nautilus_shell": "Наутилус хуранӗ",
  "item.minecraft.nautilus_spawn_egg": "Наутилус ҫурату ҫӑмарти",
  "item.minecraft.nether_brick": "Незер кирпӗчӗ",
  "item.minecraft.nether_star": "Незер ҫӑлтӑрӗ",
  "item.minecraft.nether_wart": "Незер мӑкӑлӗ",
  "item.minecraft.netherite_axe": "Незерит пуртӑ",
  "item.minecraft.netherite_boots": "Незерит атă",
  "item.minecraft.netherite_chestplate": "Незерит кӑкӑрлӑх",
  "item.minecraft.netherite_helmet": "Незерит ҫӗлӗк",
  "item.minecraft.netherite_hoe": "Незерит катмак",
  "item.minecraft.netherite_horse_armor": "Незерит лаша брони",
  "item.minecraft.netherite_ingot": "Незерит катăкĕ",
  "item.minecraft.netherite_leggings": "Незерит йӗм",
  "item.minecraft.netherite_nautilus_armor": "Незерит наутилус брони",
  "item.minecraft.netherite_pickaxe": "Незерит кайла",
  "item.minecraft.netherite_scrap": "Незерит ӑпӑр-тапӑрӗ",
  "item.minecraft.netherite_shovel": "Незерит кӗреҫе",
  "item.minecraft.netherite_spear": "Незерит сӑнӑ",
  "item.minecraft.netherite_sword": "Незерит хӗҫ",
  "item.minecraft.netherite_upgrade_smithing_template": "Тимӗрҫӗ ӗлки",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Незерит лайӑхлатни",
  "item.minecraft.oak_boat": "Юман кимӗ",
  "item.minecraft.oak_chest_boat": "Арчаллӑ юман кимĕ",
  "item.minecraft.ocelot_spawn_egg": "Оцелот ҫурату ҫӑмарти",
  "item.minecraft.ominous_bottle": "Хӑрушӑ кӗленче",
  "item.minecraft.ominous_trial_key": "Хӑрушӑ тӗрӗслев уҫҫи",
  "item.minecraft.orange_bundle": "Хӗрлӗ сарӑ михӗ",
  "item.minecraft.orange_dye": "Хӗрлӗ сарӑ сӑрӑ",
  "item.minecraft.orange_harness": "Хӗрлӗ сарӑ гаст таврашӗ",
  "item.minecraft.painting": "Ӳкерчĕк",
  "item.minecraft.pale_oak_boat": "Шуранка юман кимӗ",
  "item.minecraft.pale_oak_chest_boat": "Арчаллӑ шуранка юман кимӗ",
  "item.minecraft.panda_spawn_egg": "Панда ҫурату ҫӑмарти",
  "item.minecraft.paper": "Хут",
  "item.minecraft.parched_spawn_egg": "Типшӗнчӗк ҫурату ҫӑмарти",
  "item.minecraft.parrot_spawn_egg": "Попугай ҫурату ҫӑмарти",
  "item.minecraft.phantom_membrane": "Фантом ҫурхахӗ",
  "item.minecraft.phantom_spawn_egg": "Фантом ҫурату ҫӑмарти",
  "item.minecraft.pig_spawn_egg": "Сысна ҫурату ҫӑмарти",
  "item.minecraft.piglin_banner_pattern": "Ялав тӗрри",
  "item.minecraft.piglin_banner_pattern.desc": "Сăмса",
  "item.minecraft.piglin_banner_pattern.new": "«Сӑмса» ялав тӗрри",
  "item.minecraft.piglin_brute_spawn_egg": "Хаяр пиглин ҫурату ҫӑмарти",
  "item.minecraft.piglin_spawn_egg": "Пиглин ҫурату ҫӑмарти",
  "item.minecraft.pillager_spawn_egg": "Хурах ҫурату ҫӑмарти",
  "item.minecraft.pink_bundle": "Кӗрен михӗ",
  "item.minecraft.pink_dye": "Кӗрен сӑрӑ",
  "item.minecraft.pink_harness": "Кӗрен гаст таврашӗ",
  "item.minecraft.pitcher_plant": "Кӑкшӑм курӑкӗ",
  "item.minecraft.pitcher_pod": "Кӑкшӑм курӑкӗ хутаҫҫи",
  "item.minecraft.plenty_pottery_shard": "«Илпек» тӑм чӳлмек катӑкӗ",
  "item.minecraft.plenty_pottery_sherd": "«Илпек» тӑм чӳлмек катӑкӗ",
  "item.minecraft.poisonous_potato": "Наркӑмӑшлӑ ҫӗр улми",
  "item.minecraft.polar_bear_spawn_egg": "Шурӑ упа ҫурату ҫӑмарти",
  "item.minecraft.popped_chorus_fruit": "Ӑшаланӑ хорус ҫимӗҫӗ",
  "item.minecraft.porkchop": "Чӗрӗ сысна ашӗ",
  "item.minecraft.potato": "Ҫӗр улми",
  "item.minecraft.potion": "Им",
  "item.minecraft.potion.effect.awkward": "Пӑтранчӑк им",
  "item.minecraft.potion.effect.empty": "Пултарайман им",
  "item.minecraft.potion.effect.fire_resistance": "Ҫунманлӑх имӗ",
  "item.minecraft.potion.effect.harming": "Сиен имӗ",
  "item.minecraft.potion.effect.healing": "Сиплев имӗ",
  "item.minecraft.potion.effect.infested": "Чирлетӳ имӗ",
  "item.minecraft.potion.effect.invisibility": "Курӑнманлӑх имӗ",
  "item.minecraft.potion.effect.leaping": "Сикӗ имӗ",
  "item.minecraft.potion.effect.levitation": "Ӳкменлӗх имӗ",
  "item.minecraft.potion.effect.luck": "Ӑнӑҫу имӗ",
  "item.minecraft.potion.effect.mundane": "Ахаль им",
  "item.minecraft.potion.effect.night_vision": "Ҫӗрлехи куҫ имӗ",
  "item.minecraft.potion.effect.oozing": "Путхахлӑх имӗ",
  "item.minecraft.potion.effect.poison": "Наркӑмӑшлану имӗ",
  "item.minecraft.potion.effect.regeneration": "Сывату имӗ",
  "item.minecraft.potion.effect.slow_falling": "Тикӗс ӳкни имӗ",
  "item.minecraft.potion.effect.slowness": "Вӑрахлату имӗ",
  "item.minecraft.potion.effect.strength": "Вӑй имӗ",
  "item.minecraft.potion.effect.swiftness": "Хӑвӑртлӑх имӗ",
  "item.minecraft.potion.effect.thick": "Ҫӑра им",
  "item.minecraft.potion.effect.turtle_master": "Тимӗр шапа хӑвачӗ имӗ",
  "item.minecraft.potion.effect.water": "Шыв кӗленчи",
  "item.minecraft.potion.effect.water_breathing": "Шыври сывлав имӗ",
  "item.minecraft.potion.effect.weakness": "Вӑйсӑрлӑх имӗ",
  "item.minecraft.potion.effect.weaving": "Ҫыху имӗ",
  "item.minecraft.potion.effect.wind_charged": "Ҫил йӗтри имӗ",
  "item.minecraft.pottery_shard_archer": "«Ухӑҫӑ» тӑм чӳлмек катӑкӗ",
  "item.minecraft.pottery_shard_arms_up": "«Аллусене ҫӳлелле ҫӗкле» тӑм чӳлмек катӑкӗ",
  "item.minecraft.pottery_shard_prize": "«Парне» тӑм чӳлмек катӑкӗ",
  "item.minecraft.pottery_shard_skull": "«Пуҫ шӑмми» тӑм чӳлмек катӑкӗ",
  "item.minecraft.powder_snow_bucket": "Кӑпӑш юр витри",
  "item.minecraft.prismarine_crystals": "Призмарин кристалӗ",
  "item.minecraft.prismarine_shard": "Призмарин ванчӑкӗ",
  "item.minecraft.prize_pottery_shard": "«Парне» тӑм чӳлмек катӑкӗ",
  "item.minecraft.prize_pottery_sherd": "«Парне» тӑм чӳлмек катӑкӗ",
  "item.minecraft.pufferfish": "Йӗп пулӑ",
  "item.minecraft.pufferfish_bucket": "Витрери йӗп пулӑ",
  "item.minecraft.pufferfish_spawn_egg": "Йӗп пулӑ ҫурату ҫӑмарти",
  "item.minecraft.pumpkin_pie": "Кавӑн кукли",
  "item.minecraft.pumpkin_seeds": "Кавӑн вӑрри",
  "item.minecraft.purple_bundle": "Хӗрлӗ кӑвак михӗ",
  "item.minecraft.purple_dye": "Хӗрлӗ кӑвак сӑрӑ",
  "item.minecraft.purple_harness": "Хӗрлӗ кӑвак гаст таврашӗ",
  "item.minecraft.quartz": "Незер кварцӗ",
  "item.minecraft.rabbit": "Чӗрӗ куян ашӗ",
  "item.minecraft.rabbit_foot": "Куян ури",
  "item.minecraft.rabbit_hide": "Куян тирӗ",
  "item.minecraft.rabbit_spawn_egg": "Куян ҫурату ҫӑмарти",
  "item.minecraft.rabbit_stew": "Пӑшӑхланӑ куян",
  "item.minecraft.raiser_armor_trim_smithing_template": "Тимӗрҫӗ ӗлки",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "«Пухавҫӑ» эрешĕ",
  "item.minecraft.ravager_spawn_egg": "Ҫаратуҫӑ ҫурату ҫӑмарти",
  "item.minecraft.raw_copper": "Чӗрӗ пӑхӑр",
  "item.minecraft.raw_gold": "Чӗрӗ ылтӑн",
  "item.minecraft.raw_iron": "Чӗрӗ тимӗр",
  "item.minecraft.recovery_compass": "Таврӑну компасӗ",
  "item.minecraft.red_bundle": "Хӗрлӗ михӗ",
  "item.minecraft.red_dye": "Хӗрлӗ сӑрӑ",
  "item.minecraft.red_harness": "Хӗрлӗ гаст таврашӗ",
  "item.minecraft.redstone": "Редстоун тусанӗ",
  "item.minecraft.resin_brick": "Сухӑр кирпӗч",
  "item.minecraft.resin_clump": "Сухӑр муклашки",
  "item.minecraft.rib_armor_trim_smithing_template": "Тимӗрҫӗ ӗлки",
  "item.minecraft.rib_armor_trim_smithing_template.new": "«Аяк пӗрчи» эрешĕ",
  "item.minecraft.rotten_flesh": "Ҫĕрĕк ӳт",
  "item.minecraft.saddle": "Йӗнер",
  "item.minecraft.salmon": "Чӗрӗ лосось",
  "item.minecraft.salmon_bucket": "Витрери лосось",
  "item.minecraft.salmon_spawn_egg": "Лосось ҫурату ҫӑмарти",
  "item.minecraft.scrape_pottery_sherd": "«Чӗрӗк» тӑм чӳлмек катӑкӗ",
  "item.minecraft.scute": "Хупӑ катӑкӗ",
  "item.minecraft.sentry_armor_trim_smithing_template": "Тимӗрҫӗ ӗлки",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "«Хуралҫӑ» эрешĕ",
  "item.minecraft.shaper_armor_trim_smithing_template": "Тимӗрҫӗ ӗлки",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "«Кӳлепеҫӗ» эрешĕ",
  "item.minecraft.sheaf_pottery_shard": "«Кӗлте» тӑм чӳлмек катӑкӗ",
  "item.minecraft.sheaf_pottery_sherd": "«Кӗлте» тӑм чӳлмек катӑкӗ",
  "item.minecraft.shears": "Хачӑ",
  "item.minecraft.sheep_spawn_egg": "Сурӑх ҫурату ҫӑмарти",
  "item.minecraft.shelter_pottery_shard": "«Хӳтлӗх» тӑм чӳлмек катӑкӗ",
  "item.minecraft.shelter_pottery_sherd": "«Кӗлте» тӑм чӳлмек катӑкӗ",
  "item.minecraft.shield": "Хулккан",
  "item.minecraft.shield.black": "Хура хулккан",
  "item.minecraft.shield.blue": "Кӑвак хулккан",
  "item.minecraft.shield.brown": "Хӑмӑр хулккан",
  "item.minecraft.shield.cyan": "Кӑвак симӗс хулккан",
  "item.minecraft.shield.gray": "Сӑрӑ хулккан",
  "item.minecraft.shield.green": "Симӗс хулккан",
  "item.minecraft.shield.light_blue": "Сенкер хулккан",
  "item.minecraft.shield.light_gray": "Ҫутӑ сӑрӑ хулккан",
  "item.minecraft.shield.lime": "Сарӑ симӗс хулккан",
  "item.minecraft.shield.magenta": "Хӗрлӗ кӗрен хулккан",
  "item.minecraft.shield.orange": "Хӗрлӗ сарӑ хулккан",
  "item.minecraft.shield.pink": "Кӗрен хулккан",
  "item.minecraft.shield.purple": "Хӗрлӗ кӑвак хулккан",
  "item.minecraft.shield.red": "Хӗрлӗ хулккан",
  "item.minecraft.shield.white": "Шурӑ хулккан",
  "item.minecraft.shield.yellow": "Сарӑ хулккан",
  "item.minecraft.shulker_shell": "Шалкер хуппи",
  "item.minecraft.shulker_spawn_egg": "Шалкер ҫурату ҫӑмарти",
  "item.minecraft.sign": "Паллӑ",
  "item.minecraft.silence_armor_trim_smithing_template": "Тимӗрҫӗ ӗлки",
  "item.minecraft.silence_armor_trim_smithing_template.new": "«Шӑплӑх» эрешĕ",
  "item.minecraft.silverfish_spawn_egg": "Нӑрӑ ҫурату ҫӑмарти",
  "item.minecraft.skeleton_horse_spawn_egg": "Шӑм-шак лаша ҫурату ҫӑмарти",
  "item.minecraft.skeleton_spawn_egg": "Шӑм-шак ҫурату ҫӑмарти",
  "item.minecraft.skull_banner_pattern": "Ялав тӗрри",
  "item.minecraft.skull_banner_pattern.desc": "Пуҫ шӑмми",
  "item.minecraft.skull_banner_pattern.new": "«Пуҫ шӑмми» ялав тӗрри",
  "item.minecraft.skull_pottery_shard": "«Пуҫ шӑмми» тӑм чӳлмек катӑкӗ",
  "item.minecraft.skull_pottery_sherd": "«Пуҫ шӑмми» тӑм чӳлмек катӑкӗ",
  "item.minecraft.slime_ball": "Лӑйма муклашки",
  "item.minecraft.slime_spawn_egg": "Лӑйма ҫурату ҫӑмарти",
  "item.minecraft.smithing_template": "Тимӗрҫӗ ӗлки",
  "item.minecraft.smithing_template.applies_to": "Усӑ курӑнать:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Катӑк е кристалл хуш",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Броня",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Броня пайӗ хуш",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Катӑксемпе кристалсем",
  "item.minecraft.smithing_template.ingredients": "Материалсем:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Незерит катӑкӗ хуш",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Алмас хатӗр-хӗтӗр",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Алмас броня, кӑрал е хатӗр хуш",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Незерит катӑкӗ",
  "item.minecraft.smithing_template.upgrade": "Ҫӗнетӳ: ",
  "item.minecraft.sniffer_spawn_egg": "Шӑршлан ҫурату ҫӑмарти",
  "item.minecraft.snort_pottery_shard": "«Нӑш» тӑм чӳлмек катӑкӗ",
  "item.minecraft.snort_pottery_sherd": "«Нӑш» тӑм чӳлмек катӑкӗ",
  "item.minecraft.snout_armor_trim_smithing_template": "Тимӗрҫӗ ӗлки",
  "item.minecraft.snout_armor_trim_smithing_template.new": "«Сăмса» эрешĕ",
  "item.minecraft.snow_golem_spawn_egg": "Юр голем ҫурату ҫӑмарти",
  "item.minecraft.snowball": "Юр чӑмакки",
  "item.minecraft.spectral_arrow": "Спектрлӑ ҫӗмрен",
  "item.minecraft.spider_eye": "Эрешмен куҫĕ",
  "item.minecraft.spider_spawn_egg": "Эрешмен ҫурату ҫӑмарти",
  "item.minecraft.spire_armor_trim_smithing_template": "Тимӗрҫӗ ӗлки",
  "item.minecraft.spire_armor_trim_smithing_template.new": "«Тăрнашка» эрешĕ",
  "item.minecraft.splash_potion": "Сирпӗтмелли им",
  "item.minecraft.splash_potion.effect.awkward": "Сирпӗтмелли пӑтранчӑк им",
  "item.minecraft.splash_potion.effect.empty": "Пултарайман сирпӗтмелли им",
  "item.minecraft.splash_potion.effect.fire_resistance": "Сирпӗтмелли ҫунманлӑх имӗ",
  "item.minecraft.splash_potion.effect.harming": "Сирпӗтмелли сиен имӗ",
  "item.minecraft.splash_potion.effect.healing": "Сирпӗтмелли сиплев имӗ",
  "item.minecraft.splash_potion.effect.infested": "Сирпӗтмелли чирлетӳ имӗ",
  "item.minecraft.splash_potion.effect.invisibility": "Сирпӗтмелли курӑнманлӑх имӗ",
  "item.minecraft.splash_potion.effect.leaping": "Сирпӗтмелли сикӗ имӗ",
  "item.minecraft.splash_potion.effect.levitation": "Сирпӗтмелли ӳкменлӗх имӗ",
  "item.minecraft.splash_potion.effect.luck": "Сирпӗтмелли ӑнӑҫу имӗ",
  "item.minecraft.splash_potion.effect.mundane": "Сирпӗтмелли ахаль им",
  "item.minecraft.splash_potion.effect.night_vision": "Сирпӗтмелли ҫӗрлехи куҫ имӗ",
  "item.minecraft.splash_potion.effect.oozing": "Сирпӗтмелли путхахлӑх имӗ",
  "item.minecraft.splash_potion.effect.poison": "Сирпӗтмелли наркӑмӑшлану имӗ",
  "item.minecraft.splash_potion.effect.regeneration": "Сирпӗтмелли сывату имӗ",
  "item.minecraft.splash_potion.effect.slow_falling": "Сирпӗтмелли тикӗс ӳкни имӗ",
  "item.minecraft.splash_potion.effect.slowness": "Сирпӗтмелли вӑрахлату имӗ",
  "item.minecraft.splash_potion.effect.strength": "Сирпӗтмелли вӑй имӗ",
  "item.minecraft.splash_potion.effect.swiftness": "Сирпӗтмелли хӑвӑртлӑх имӗ",
  "item.minecraft.splash_potion.effect.thick": "Сирпӗтмелли ҫӑра им",
  "item.minecraft.splash_potion.effect.turtle_master": "Сирпӗтмелли тимӗр шапа хӑвачӗ имӗ",
  "item.minecraft.splash_potion.effect.water": "Сирпӗтмелли шыв кӗленче",
  "item.minecraft.splash_potion.effect.water_breathing": "Сирпӗтмелли шыври сывлав имӗ",
  "item.minecraft.splash_potion.effect.weakness": "Сирпӗтмелли вӑйсӑрлӑх имӗ",
  "item.minecraft.splash_potion.effect.weaving": "Сирпӗтмелли ҫыху имӗ",
  "item.minecraft.splash_potion.effect.wind_charged": "Сирпӗтмелли ҫил йӗтри имӗ",
  "item.minecraft.spruce_boat": "Чӑрӑш кимӗ",
  "item.minecraft.spruce_chest_boat": "Арчаллӑ чӑрӑш кимӗ",
  "item.minecraft.spyglass": "Пăхмалли труба",
  "item.minecraft.squid_spawn_egg": "Сакӑр ура ҫурату ҫӑмарти",
  "item.minecraft.stick": "Патак",
  "item.minecraft.stone_axe": "Чул пуртӑ",
  "item.minecraft.stone_hoe": "Чул катмак",
  "item.minecraft.stone_pickaxe": "Чул кайла",
  "item.minecraft.stone_shovel": "Чул кӗреҫе",
  "item.minecraft.stone_spear": "Чул сӑнӑ",
  "item.minecraft.stone_sword": "Чул хӗҫ",
  "item.minecraft.stray_spawn_egg": "Ҫапкаланчӑк ҫурату ҫӑмарти",
  "item.minecraft.strider_spawn_egg": "Страйдер ҫурату ҫӑмарти",
  "item.minecraft.string": "Ҫип",
  "item.minecraft.sugar": "Сахӑр",
  "item.minecraft.suspicious_stew": "Шиклӗ яшка",
  "item.minecraft.sweet_berries": "Пылак ҫырла",
  "item.minecraft.tadpole_bucket": "Витрери йыт пулли",
  "item.minecraft.tadpole_spawn_egg": "Йыт пулли ҫурату ҫӑмарти",
  "item.minecraft.tide_armor_trim_smithing_template": "Тимӗрҫӗ ӗлки",
  "item.minecraft.tide_armor_trim_smithing_template.new": "«Шыв хăпарни» эрешĕ",
  "item.minecraft.tipped_arrow": "Имлӗ ҫӗмрен",
  "item.minecraft.tipped_arrow.effect.awkward": "Имлӗ ҫӗмрен",
  "item.minecraft.tipped_arrow.effect.empty": "Пултарайман имлӗ ҫӗмрен",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Ҫунманлӑх имӗллӗ ҫӗмрен",
  "item.minecraft.tipped_arrow.effect.harming": "Сиен имӗллӗ ҫӗмрен",
  "item.minecraft.tipped_arrow.effect.healing": "Сиплев имӗллӗ ҫӗмрен",
  "item.minecraft.tipped_arrow.effect.infested": "Чирлетӳ имӗллӗ ҫӗмрен",
  "item.minecraft.tipped_arrow.effect.invisibility": "Курӑнманлӑх имӗллӗ ҫӗмрен",
  "item.minecraft.tipped_arrow.effect.leaping": "Сикӗ имӗллӗ ҫӗмрен",
  "item.minecraft.tipped_arrow.effect.levitation": "Ӳкменлӗх имӗллӗ ҫӗмрен",
  "item.minecraft.tipped_arrow.effect.luck": "Ӑнӑҫу имӗллӗ ҫӗмрен",
  "item.minecraft.tipped_arrow.effect.mundane": "Ахаль имлӗ ҫӗмрен",
  "item.minecraft.tipped_arrow.effect.night_vision": "Ҫӗрлехи куҫ имӗллӗ ҫӗмрен",
  "item.minecraft.tipped_arrow.effect.oozing": "Путхахлӑх имӗллӗ ҫӗмрен",
  "item.minecraft.tipped_arrow.effect.poison": "Наркӑмӑшлану имӗллӗ ҫӗмрен",
  "item.minecraft.tipped_arrow.effect.regeneration": "Сывату имӗллӗ ҫӗмрен",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Тикӗс ӳкни имӗллӗ ҫӗмрен",
  "item.minecraft.tipped_arrow.effect.slowness": "Вӑрахлату имӗллӗ ҫӗмрен",
  "item.minecraft.tipped_arrow.effect.strength": "Вӑй имӗллӗ ҫӗмрен",
  "item.minecraft.tipped_arrow.effect.swiftness": "Хӑвӑртлӑх имӗллӗ ҫӗмрен",
  "item.minecraft.tipped_arrow.effect.thick": "Ҫӑра имлӗ ҫӗмрен",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Тимӗр шапа хӑвачӗ имӗллӗ ҫӗмрен",
  "item.minecraft.tipped_arrow.effect.water": "Сирпӗтмелли ҫӗмрен",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Шыври сывлав имӗллӗ ҫӗмрен",
  "item.minecraft.tipped_arrow.effect.weakness": "Вӑйсӑрлӑх имӗллӗ ҫӗмрен",
  "item.minecraft.tipped_arrow.effect.weaving": "Ҫыху имӗллӗ ҫӗмрен",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Ҫил йӗтри имӗллӗ ҫӗмрен",
  "item.minecraft.tnt_minecart": "Динамитлӑ вакун",
  "item.minecraft.torchflower_seeds": "Ҫункӑҫ чечек вӑрри",
  "item.minecraft.totem_of_undying": "Вилӗмсӗрлӗх йӗрӗхӗ",
  "item.minecraft.trader_llama_spawn_egg": "Сутуҫӑ лами ҫурату ҫӑмарти",
  "item.minecraft.trial_key": "Тӗрӗслев уҫҫи",
  "item.minecraft.trident": "Виҫ шӑллӑ сенӗк",
  "item.minecraft.tropical_fish": "Тропик пулӑ",
  "item.minecraft.tropical_fish_bucket": "Витрери тропик пулӑ",
  "item.minecraft.tropical_fish_spawn_egg": "Тропик пулӑ ҫурату ҫӑмарти",
  "item.minecraft.turtle_helmet": "Тимӗр шапа хуппи",
  "item.minecraft.turtle_scute": "Тимӗр шапа хуппин катӑкӗ",
  "item.minecraft.turtle_spawn_egg": "Тимӗр шапа ҫурату ҫӑмарти",
  "item.minecraft.vex_armor_trim_smithing_template": "Тимӗрҫӗ ӗлки",
  "item.minecraft.vex_armor_trim_smithing_template.new": "«Сӑтӑрҫӑ» эрешĕ",
  "item.minecraft.vex_spawn_egg": "Сӑтӑрҫӑ ҫурату ҫӑмарти",
  "item.minecraft.villager_spawn_egg": "Хресчен ҫурату ҫӑмарти",
  "item.minecraft.vindicator_spawn_egg": "Тавӑруҫӑ ҫурату ҫӑмарти",
  "item.minecraft.wandering_trader_spawn_egg": "Юркӑн сутуҫӑ ҫурату ҫӑмарти",
  "item.minecraft.ward_armor_trim_smithing_template": "Тимӗрҫӗ ӗлки",
  "item.minecraft.ward_armor_trim_smithing_template.new": "«Сыхчă» эрешĕ",
  "item.minecraft.warden_spawn_egg": "Сыхчӑ ҫурату ҫӑмарти",
  "item.minecraft.warped_fungus_on_a_stick": "Пӑсӑк кӑмпаллӑ вӑлта",
  "item.minecraft.water_bucket": "Шыв витри",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Тимӗрҫӗ ӗлки",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "«Шыравҫӑ» эрешĕ",
  "item.minecraft.wheat": "Тулӑ",
  "item.minecraft.wheat_seeds": "Тулӑ вӑрлӑхӗ",
  "item.minecraft.white_bundle": "Шурӑ михӗ",
  "item.minecraft.white_dye": "Шурӑ сӑрӑ",
  "item.minecraft.white_harness": "Шурӑ гаст таврашӗ",
  "item.minecraft.wild_armor_trim_smithing_template": "Тимӗрҫӗ ӗлки",
  "item.minecraft.wild_armor_trim_smithing_template.new": "«Тискерлӗх» эрешĕ",
  "item.minecraft.wind_charge": "Ҫил йӗтри",
  "item.minecraft.witch_spawn_egg": "Тухатмӑш ҫурату ҫӑмарти",
  "item.minecraft.wither_skeleton_spawn_egg": "Визер шӑм-шак ҫурату ҫӑмарти",
  "item.minecraft.wither_spawn_egg": "Визер ҫурату ҫӑмарти",
  "item.minecraft.wolf_armor": "Кашкӑр брони",
  "item.minecraft.wolf_spawn_egg": "Кашкӑр ҫурату ҫӑмарти",
  "item.minecraft.wooden_axe": "Йывӑҫ пуртӑ",
  "item.minecraft.wooden_hoe": "Йывӑҫ катмак",
  "item.minecraft.wooden_pickaxe": "Йывӑҫ кайла",
  "item.minecraft.wooden_shovel": "Йывӑҫ кӗреҫе",
  "item.minecraft.wooden_spear": "Йывӑҫ сӑнӑ",
  "item.minecraft.wooden_sword": "Йывӑҫ хӗҫ",
  "item.minecraft.writable_book": "Кӗнекепе калем",
  "item.minecraft.written_book": "Вӗҫленӗ кӗнеке",
  "item.minecraft.yellow_bundle": "Сарӑ михӗ",
  "item.minecraft.yellow_dye": "Сарӑ сӑрӑ",
  "item.minecraft.yellow_harness": "Сарӑ гаст таврашӗ",
  "item.minecraft.zoglin_spawn_egg": "Зоглин ҫурату ҫӑмарти",
  "item.minecraft.zombie_horse_spawn_egg": "Зомби лаша ҫурату ҫӑмарти",
  "item.minecraft.zombie_nautilus_spawn_egg": "Зомби наутилус ҫурату ҫӑмарти",
  "item.minecraft.zombie_spawn_egg": "Зомби ҫурату ҫӑмарти",
  "item.minecraft.zombie_villager_spawn_egg": "Зомби хресчен ҫурату ҫӑмарти",
  "item.minecraft.zombified_piglin_spawn_egg": "Зомбиленнӗ пиглин ҫурату ҫӑмарти"
}
export const cv_cu = items; 
